var Zc = Object.defineProperty, eu = Object.defineProperties;
var tu = Object.getOwnPropertyDescriptors;
var Ur = Object.getOwnPropertySymbols;
var ki = Object.prototype.hasOwnProperty, Ci = Object.prototype.propertyIsEnumerable;
var zt = Math.pow, qn = (e, r, t) => r in e ? Zc(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, A = (e, r) => {
  for (var t in r || (r = {}))
    ki.call(r, t) && qn(e, t, r[t]);
  if (Ur)
    for (var t of Ur(r))
      Ci.call(r, t) && qn(e, t, r[t]);
  return e;
}, ve = (e, r) => eu(e, tu(r));
var Se = (e, r) => {
  var t = {};
  for (var n in e)
    ki.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Ur)
    for (var n of Ur(e))
      r.indexOf(n) < 0 && Ci.call(e, n) && (t[n] = e[n]);
  return t;
};
var N = (e, r, t) => (qn(e, typeof r != "symbol" ? r + "" : r, t), t);
var ji = (e, r, t) => new Promise((n, o) => {
  var i = (u) => {
    try {
      c(t.next(u));
    } catch (l) {
      o(l);
    }
  }, a = (u) => {
    try {
      c(t.throw(u));
    } catch (l) {
      o(l);
    }
  }, c = (u) => u.done ? n(u.value) : Promise.resolve(u.value).then(i, a);
  c((t = t.apply(e, r)).next());
});
import * as Oe from "react";
import zs, { forwardRef as ze, useState as xe, useRef as tt, useMemo as He, useCallback as ko, Fragment as $r, useEffect as sn } from "react";
import { Chip as Qt, styled as Z, Select as At, MenuItem as yt, Typography as ur, Box as De, FormControl as nt, IconButton as qs, ClickAwayListener as pn, Popper as mn, FormHelperText as ot, TextField as lr, Divider as dr, RadioGroup as ru, FormControlLabel as Us, Radio as nu, FormGroup as ou, Checkbox as an, createTheme as Vs, ThemeProvider as Gs, Button as Xs, Dialog as iu, DialogTitle as su, DialogContent as au, DialogActions as cu, InputLabel as gn, Paper as Ks, createFilterOptions as Qs, Popover as Js, Autocomplete as Zs } from "@mui/material";
import { Clear as ea, PhotoLibraryOutlined as uu, PhotoCameraOutlined as lu } from "@mui/icons-material";
import { Z as at, N as Co, L as jo, a as du, D as fu, E as hu } from "./text-46a2fb86.js";
import { a as Er, b as ta, S as or, c as Le, d as Mr, g as ra, e as Ft, f as Do, h as po, j as na, k as pu, M as oa, r as ia, l as Di, m as mu, n as sa, o as Un, i as ye, p as Fe, u as aa, _ as gu, q as yu, s as wt } from "./compressor.esm-9d4ad9d2.js";
import bu from "@emotion/styled";
import { CacheProvider as xu, Global as vu, ThemeContext as ca, css as _u, keyframes as ua } from "@emotion/react";
import { LocalizationProvider as wu, DesktopDatePicker as Tu } from "@mui/x-date-pickers";
import { InputDate as Su } from "@mescius/wijmo.react.input";
var mo = { exports: {} }, br = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ri;
function Eu() {
  if (Ri)
    return br;
  Ri = 1;
  var e = zs, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(c, u, l) {
    var f, d = {}, h = null, y = null;
    l !== void 0 && (h = "" + l), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (y = u.ref);
    for (f in u)
      n.call(u, f) && !i.hasOwnProperty(f) && (d[f] = u[f]);
    if (c && c.defaultProps)
      for (f in u = c.defaultProps, u)
        d[f] === void 0 && (d[f] = u[f]);
    return { $$typeof: r, type: c, key: h, ref: y, props: d, _owner: o.current };
  }
  return br.Fragment = t, br.jsx = a, br.jsxs = a, br;
}
var xr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $i;
function Mu() {
  return $i || ($i = 1, process.env.NODE_ENV !== "production" && function() {
    var e = zs, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), c = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), b = Symbol.iterator, m = "@@iterator";
    function g(p) {
      if (p === null || typeof p != "object")
        return null;
      var O = b && p[b] || p[m];
      return typeof O == "function" ? O : null;
    }
    var v = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function _(p) {
      {
        for (var O = arguments.length, $ = new Array(O > 1 ? O - 1 : 0), q = 1; q < O; q++)
          $[q - 1] = arguments[q];
        T("error", p, $);
      }
    }
    function T(p, O, $) {
      {
        var q = v.ReactDebugCurrentFrame, ae = q.getStackAddendum();
        ae !== "" && (O += "%s", $ = $.concat([ae]));
        var be = $.map(function(se) {
          return String(se);
        });
        be.unshift("Warning: " + O), Function.prototype.apply.call(console[p], console, be);
      }
    }
    var w = !1, x = !1, S = !1, P = !1, F = !1, ee;
    ee = Symbol.for("react.module.reference");
    function Y(p) {
      return !!(typeof p == "string" || typeof p == "function" || p === n || p === i || F || p === o || p === l || p === f || P || p === y || w || x || S || typeof p == "object" && p !== null && (p.$$typeof === h || p.$$typeof === d || p.$$typeof === a || p.$$typeof === c || p.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      p.$$typeof === ee || p.getModuleId !== void 0));
    }
    function k(p, O, $) {
      var q = p.displayName;
      if (q)
        return q;
      var ae = O.displayName || O.name || "";
      return ae !== "" ? $ + "(" + ae + ")" : $;
    }
    function C(p) {
      return p.displayName || "Context";
    }
    function B(p) {
      if (p == null)
        return null;
      if (typeof p.tag == "number" && _("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof p == "function")
        return p.displayName || p.name || null;
      if (typeof p == "string")
        return p;
      switch (p) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case l:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof p == "object")
        switch (p.$$typeof) {
          case c:
            var O = p;
            return C(O) + ".Consumer";
          case a:
            var $ = p;
            return C($._context) + ".Provider";
          case u:
            return k(p, p.render, "ForwardRef");
          case d:
            var q = p.displayName || null;
            return q !== null ? q : B(p.type) || "Memo";
          case h: {
            var ae = p, be = ae._payload, se = ae._init;
            try {
              return B(se(be));
            } catch (re) {
              return null;
            }
          }
        }
      return null;
    }
    var j = Object.assign, Q = 0, ie, H, G, _e, E, M, L;
    function I() {
    }
    I.__reactDisabledLog = !0;
    function z() {
      {
        if (Q === 0) {
          ie = console.log, H = console.info, G = console.warn, _e = console.error, E = console.group, M = console.groupCollapsed, L = console.groupEnd;
          var p = {
            configurable: !0,
            enumerable: !0,
            value: I,
            writable: !0
          };
          Object.defineProperties(console, {
            info: p,
            log: p,
            warn: p,
            error: p,
            group: p,
            groupCollapsed: p,
            groupEnd: p
          });
        }
        Q++;
      }
    }
    function te() {
      {
        if (Q--, Q === 0) {
          var p = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: j({}, p, {
              value: ie
            }),
            info: j({}, p, {
              value: H
            }),
            warn: j({}, p, {
              value: G
            }),
            error: j({}, p, {
              value: _e
            }),
            group: j({}, p, {
              value: E
            }),
            groupCollapsed: j({}, p, {
              value: M
            }),
            groupEnd: j({}, p, {
              value: L
            })
          });
        }
        Q < 0 && _("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var U = v.ReactCurrentDispatcher, V;
    function X(p, O, $) {
      {
        if (V === void 0)
          try {
            throw Error();
          } catch (ae) {
            var q = ae.stack.trim().match(/\n( *(at )?)/);
            V = q && q[1] || "";
          }
        return `
` + V + p;
      }
    }
    var oe = !1, K;
    {
      var Ae = typeof WeakMap == "function" ? WeakMap : Map;
      K = new Ae();
    }
    function R(p, O) {
      if (!p || oe)
        return "";
      {
        var $ = K.get(p);
        if ($ !== void 0)
          return $;
      }
      var q;
      oe = !0;
      var ae = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var be;
      be = U.current, U.current = null, z();
      try {
        if (O) {
          var se = function() {
            throw Error();
          };
          if (Object.defineProperty(se.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(se, []);
            } catch (xt) {
              q = xt;
            }
            Reflect.construct(p, [], se);
          } else {
            try {
              se.call();
            } catch (xt) {
              q = xt;
            }
            p.call(se.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (xt) {
            q = xt;
          }
          p();
        }
      } catch (xt) {
        if (xt && q && typeof xt.stack == "string") {
          for (var re = xt.stack.split(`
`), qe = q.stack.split(`
`), ke = re.length - 1, Ne = qe.length - 1; ke >= 1 && Ne >= 0 && re[ke] !== qe[Ne]; )
            Ne--;
          for (; ke >= 1 && Ne >= 0; ke--, Ne--)
            if (re[ke] !== qe[Ne]) {
              if (ke !== 1 || Ne !== 1)
                do
                  if (ke--, Ne--, Ne < 0 || re[ke] !== qe[Ne]) {
                    var Qe = `
` + re[ke].replace(" at new ", " at ");
                    return p.displayName && Qe.includes("<anonymous>") && (Qe = Qe.replace("<anonymous>", p.displayName)), typeof p == "function" && K.set(p, Qe), Qe;
                  }
                while (ke >= 1 && Ne >= 0);
              break;
            }
        }
      } finally {
        oe = !1, U.current = be, te(), Error.prepareStackTrace = ae;
      }
      var Ht = p ? p.displayName || p.name : "", Pi = Ht ? X(Ht) : "";
      return typeof p == "function" && K.set(p, Pi), Pi;
    }
    function Ue(p, O, $) {
      return R(p, !1);
    }
    function W(p) {
      var O = p.prototype;
      return !!(O && O.isReactComponent);
    }
    function st(p, O, $) {
      if (p == null)
        return "";
      if (typeof p == "function")
        return R(p, W(p));
      if (typeof p == "string")
        return X(p);
      switch (p) {
        case l:
          return X("Suspense");
        case f:
          return X("SuspenseList");
      }
      if (typeof p == "object")
        switch (p.$$typeof) {
          case u:
            return Ue(p.render);
          case d:
            return st(p.type, O, $);
          case h: {
            var q = p, ae = q._payload, be = q._init;
            try {
              return st(be(ae), O, $);
            } catch (se) {
            }
          }
        }
      return "";
    }
    var bt = Object.prototype.hasOwnProperty, gr = {}, yi = v.ReactDebugCurrentFrame;
    function qr(p) {
      if (p) {
        var O = p._owner, $ = st(p.type, p._source, O ? O.type : null);
        yi.setExtraStackFrame($);
      } else
        yi.setExtraStackFrame(null);
    }
    function Rc(p, O, $, q, ae) {
      {
        var be = Function.call.bind(bt);
        for (var se in p)
          if (be(p, se)) {
            var re = void 0;
            try {
              if (typeof p[se] != "function") {
                var qe = Error((q || "React class") + ": " + $ + " type `" + se + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof p[se] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw qe.name = "Invariant Violation", qe;
              }
              re = p[se](O, se, q, $, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ke) {
              re = ke;
            }
            re && !(re instanceof Error) && (qr(ae), _("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", q || "React class", $, se, typeof re), qr(null)), re instanceof Error && !(re.message in gr) && (gr[re.message] = !0, qr(ae), _("Failed %s type: %s", $, re.message), qr(null));
          }
      }
    }
    var $c = Array.isArray;
    function Bn(p) {
      return $c(p);
    }
    function Nc(p) {
      {
        var O = typeof Symbol == "function" && Symbol.toStringTag, $ = O && p[Symbol.toStringTag] || p.constructor.name || "Object";
        return $;
      }
    }
    function Ic(p) {
      try {
        return bi(p), !1;
      } catch (O) {
        return !0;
      }
    }
    function bi(p) {
      return "" + p;
    }
    function xi(p) {
      if (Ic(p))
        return _("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Nc(p)), bi(p);
    }
    var yr = v.ReactCurrentOwner, Ac = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, vi, _i, Ln;
    Ln = {};
    function Fc(p) {
      if (bt.call(p, "ref")) {
        var O = Object.getOwnPropertyDescriptor(p, "ref").get;
        if (O && O.isReactWarning)
          return !1;
      }
      return p.ref !== void 0;
    }
    function Wc(p) {
      if (bt.call(p, "key")) {
        var O = Object.getOwnPropertyDescriptor(p, "key").get;
        if (O && O.isReactWarning)
          return !1;
      }
      return p.key !== void 0;
    }
    function Bc(p, O) {
      if (typeof p.ref == "string" && yr.current && O && yr.current.stateNode !== O) {
        var $ = B(yr.current.type);
        Ln[$] || (_('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(yr.current.type), p.ref), Ln[$] = !0);
      }
    }
    function Lc(p, O) {
      {
        var $ = function() {
          vi || (vi = !0, _("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", O));
        };
        $.isReactWarning = !0, Object.defineProperty(p, "key", {
          get: $,
          configurable: !0
        });
      }
    }
    function Yc(p, O) {
      {
        var $ = function() {
          _i || (_i = !0, _("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", O));
        };
        $.isReactWarning = !0, Object.defineProperty(p, "ref", {
          get: $,
          configurable: !0
        });
      }
    }
    var Hc = function(p, O, $, q, ae, be, se) {
      var re = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: p,
        key: O,
        ref: $,
        props: se,
        // Record the component responsible for creating this element.
        _owner: be
      };
      return re._store = {}, Object.defineProperty(re._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(re, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: q
      }), Object.defineProperty(re, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ae
      }), Object.freeze && (Object.freeze(re.props), Object.freeze(re)), re;
    };
    function zc(p, O, $, q, ae) {
      {
        var be, se = {}, re = null, qe = null;
        $ !== void 0 && (xi($), re = "" + $), Wc(O) && (xi(O.key), re = "" + O.key), Fc(O) && (qe = O.ref, Bc(O, ae));
        for (be in O)
          bt.call(O, be) && !Ac.hasOwnProperty(be) && (se[be] = O[be]);
        if (p && p.defaultProps) {
          var ke = p.defaultProps;
          for (be in ke)
            se[be] === void 0 && (se[be] = ke[be]);
        }
        if (re || qe) {
          var Ne = typeof p == "function" ? p.displayName || p.name || "Unknown" : p;
          re && Lc(se, Ne), qe && Yc(se, Ne);
        }
        return Hc(p, re, qe, ae, q, yr.current, se);
      }
    }
    var Yn = v.ReactCurrentOwner, wi = v.ReactDebugCurrentFrame;
    function Yt(p) {
      if (p) {
        var O = p._owner, $ = st(p.type, p._source, O ? O.type : null);
        wi.setExtraStackFrame($);
      } else
        wi.setExtraStackFrame(null);
    }
    var Hn;
    Hn = !1;
    function zn(p) {
      return typeof p == "object" && p !== null && p.$$typeof === r;
    }
    function Ti() {
      {
        if (Yn.current) {
          var p = B(Yn.current.type);
          if (p)
            return `

Check the render method of \`` + p + "`.";
        }
        return "";
      }
    }
    function qc(p) {
      {
        if (p !== void 0) {
          var O = p.fileName.replace(/^.*[\\\/]/, ""), $ = p.lineNumber;
          return `

Check your code at ` + O + ":" + $ + ".";
        }
        return "";
      }
    }
    var Si = {};
    function Uc(p) {
      {
        var O = Ti();
        if (!O) {
          var $ = typeof p == "string" ? p : p.displayName || p.name;
          $ && (O = `

Check the top-level render call using <` + $ + ">.");
        }
        return O;
      }
    }
    function Ei(p, O) {
      {
        if (!p._store || p._store.validated || p.key != null)
          return;
        p._store.validated = !0;
        var $ = Uc(O);
        if (Si[$])
          return;
        Si[$] = !0;
        var q = "";
        p && p._owner && p._owner !== Yn.current && (q = " It was passed a child from " + B(p._owner.type) + "."), Yt(p), _('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', $, q), Yt(null);
      }
    }
    function Mi(p, O) {
      {
        if (typeof p != "object")
          return;
        if (Bn(p))
          for (var $ = 0; $ < p.length; $++) {
            var q = p[$];
            zn(q) && Ei(q, O);
          }
        else if (zn(p))
          p._store && (p._store.validated = !0);
        else if (p) {
          var ae = g(p);
          if (typeof ae == "function" && ae !== p.entries)
            for (var be = ae.call(p), se; !(se = be.next()).done; )
              zn(se.value) && Ei(se.value, O);
        }
      }
    }
    function Vc(p) {
      {
        var O = p.type;
        if (O == null || typeof O == "string")
          return;
        var $;
        if (typeof O == "function")
          $ = O.propTypes;
        else if (typeof O == "object" && (O.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        O.$$typeof === d))
          $ = O.propTypes;
        else
          return;
        if ($) {
          var q = B(O);
          Rc($, p.props, "prop", q, p);
        } else if (O.PropTypes !== void 0 && !Hn) {
          Hn = !0;
          var ae = B(O);
          _("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ae || "Unknown");
        }
        typeof O.getDefaultProps == "function" && !O.getDefaultProps.isReactClassApproved && _("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Gc(p) {
      {
        for (var O = Object.keys(p.props), $ = 0; $ < O.length; $++) {
          var q = O[$];
          if (q !== "children" && q !== "key") {
            Yt(p), _("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", q), Yt(null);
            break;
          }
        }
        p.ref !== null && (Yt(p), _("Invalid attribute `ref` supplied to `React.Fragment`."), Yt(null));
      }
    }
    function Oi(p, O, $, q, ae, be) {
      {
        var se = Y(p);
        if (!se) {
          var re = "";
          (p === void 0 || typeof p == "object" && p !== null && Object.keys(p).length === 0) && (re += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var qe = qc(ae);
          qe ? re += qe : re += Ti();
          var ke;
          p === null ? ke = "null" : Bn(p) ? ke = "array" : p !== void 0 && p.$$typeof === r ? (ke = "<" + (B(p.type) || "Unknown") + " />", re = " Did you accidentally export a JSX literal instead of a component?") : ke = typeof p, _("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ke, re);
        }
        var Ne = zc(p, O, $, ae, be);
        if (Ne == null)
          return Ne;
        if (se) {
          var Qe = O.children;
          if (Qe !== void 0)
            if (q)
              if (Bn(Qe)) {
                for (var Ht = 0; Ht < Qe.length; Ht++)
                  Mi(Qe[Ht], p);
                Object.freeze && Object.freeze(Qe);
              } else
                _("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Mi(Qe, p);
        }
        return p === n ? Gc(Ne) : Vc(Ne), Ne;
      }
    }
    function Xc(p, O, $) {
      return Oi(p, O, $, !0);
    }
    function Kc(p, O, $) {
      return Oi(p, O, $, !1);
    }
    var Qc = Kc, Jc = Xc;
    xr.Fragment = n, xr.jsx = Qc, xr.jsxs = Jc;
  }()), xr;
}
process.env.NODE_ENV === "production" ? mo.exports = Eu() : mo.exports = Mu();
var s = mo.exports;
function Vn({
  type: e,
  requiredText: r = "必須"
}) {
  switch (e) {
    case "required":
      return /* @__PURE__ */ s.jsx(
        Qt,
        {
          label: r,
          size: "small",
          sx: {
            color: "#fff",
            fontSize: "12px",
            backgroundColor: "#E64E17",
            marginLeft: "4px",
            height: 18,
            fontWeight: "lighter",
            lineHeight: 1
          }
        }
      );
    case "recommended":
      return /* @__PURE__ */ s.jsx(
        Qt,
        {
          label: "推奨",
          size: "small",
          sx: {
            color: "#fff",
            fontSize: "12px",
            backgroundColor: "#12B36A",
            marginLeft: "4px",
            height: 18,
            fontWeight: "lighter",
            lineHeight: 1
          }
        }
      );
    case "cooperated":
      return /* @__PURE__ */ s.jsx(
        Qt,
        {
          label: "連携項目",
          size: "small",
          variant: "outlined",
          sx: {
            color: "#E6960E",
            fontSize: "12px",
            marginLeft: "4px",
            height: 18,
            fontWeight: "lighter",
            borderColor: "#E6960E",
            borderRadius: "4px",
            lineHeight: 1
          }
        }
      );
    default:
      return /* @__PURE__ */ s.jsx(Qt, {});
  }
}
var Ou = "[object Symbol]";
function ir(e) {
  return typeof e == "symbol" || Er(e) && ta(e) == Ou;
}
function $t(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length, o = Array(n); ++t < n; )
    o[t] = r(e[t], t, e);
  return o;
}
var Pu = 1 / 0, Ni = or ? or.prototype : void 0, Ii = Ni ? Ni.toString : void 0;
function la(e) {
  if (typeof e == "string")
    return e;
  if (Le(e))
    return $t(e, la) + "";
  if (ir(e))
    return Ii ? Ii.call(e) : "";
  var r = e + "";
  return r == "0" && 1 / e == -Pu ? "-0" : r;
}
var ku = /\s/;
function Cu(e) {
  for (var r = e.length; r-- && ku.test(e.charAt(r)); )
    ;
  return r;
}
var ju = /^\s+/;
function Du(e) {
  return e && e.slice(0, Cu(e) + 1).replace(ju, "");
}
var Ai = 0 / 0, Ru = /^[-+]0x[0-9a-f]+$/i, $u = /^0b[01]+$/i, Nu = /^0o[0-7]+$/i, Iu = parseInt;
function go(e) {
  if (typeof e == "number")
    return e;
  if (ir(e))
    return Ai;
  if (Mr(e)) {
    var r = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Mr(r) ? r + "" : r;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Du(e);
  var t = $u.test(e);
  return t || Nu.test(e) ? Iu(e.slice(2), t ? 2 : 8) : Ru.test(e) ? Ai : +e;
}
var Fi = 1 / 0, Au = 17976931348623157e292;
function Fu(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = go(e), e === Fi || e === -Fi) {
    var r = e < 0 ? -1 : 1;
    return r * Au;
  }
  return e === e ? e : 0;
}
function Ro(e) {
  var r = Fu(e), t = r % 1;
  return r === r ? t ? r - t : r : 0;
}
function yn(e) {
  return e;
}
function Wu(e, r, t) {
  switch (t.length) {
    case 0:
      return e.call(r);
    case 1:
      return e.call(r, t[0]);
    case 2:
      return e.call(r, t[0], t[1]);
    case 3:
      return e.call(r, t[0], t[1], t[2]);
  }
  return e.apply(r, t);
}
function Bu() {
}
var Lu = 800, Yu = 16, Hu = Date.now;
function zu(e) {
  var r = 0, t = 0;
  return function() {
    var n = Hu(), o = Yu - (n - t);
    if (t = n, o > 0) {
      if (++r >= Lu)
        return arguments[0];
    } else
      r = 0;
    return e.apply(void 0, arguments);
  };
}
function qu(e) {
  return function() {
    return e;
  };
}
var Uu = function() {
  try {
    var e = ra(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch (r) {
  }
}();
const Wi = Uu;
var Vu = Wi ? function(e, r) {
  return Wi(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: qu(r),
    writable: !0
  });
} : yn;
const Gu = Vu;
var Xu = zu(Gu);
const Ku = Xu;
function da(e, r, t, n) {
  for (var o = e.length, i = t + (n ? 1 : -1); n ? i-- : ++i < o; )
    if (r(e[i], i, e))
      return i;
  return -1;
}
function Qu(e) {
  return e !== e;
}
function Ju(e, r, t) {
  for (var n = t - 1, o = e.length; ++n < o; )
    if (e[n] === r)
      return n;
  return -1;
}
function fa(e, r, t) {
  return r === r ? Ju(e, r, t) : da(e, Qu, t);
}
function ha(e, r) {
  var t = e == null ? 0 : e.length;
  return !!t && fa(e, r, 0) > -1;
}
var Zu = 9007199254740991, el = /^(?:0|[1-9]\d*)$/;
function bn(e, r) {
  var t = typeof e;
  return r = r == null ? Zu : r, !!r && (t == "number" || t != "symbol" && el.test(e)) && e > -1 && e % 1 == 0 && e < r;
}
function $o(e, r) {
  return e === r || e !== e && r !== r;
}
var Bi = Math.max;
function tl(e, r, t) {
  return r = Bi(r === void 0 ? e.length - 1 : r, 0), function() {
    for (var n = arguments, o = -1, i = Bi(n.length - r, 0), a = Array(i); ++o < i; )
      a[o] = n[r + o];
    o = -1;
    for (var c = Array(r + 1); ++o < r; )
      c[o] = n[o];
    return c[r] = t(a), Wu(e, this, c);
  };
}
function rl(e, r) {
  return Ku(tl(e, r, yn), e + "");
}
function nl(e, r, t) {
  if (!Mr(t))
    return !1;
  var n = typeof r;
  return (n == "number" ? Ft(t) && bn(r, t.length) : n == "string" && r in t) ? $o(t[r], e) : !1;
}
function ol(e, r) {
  for (var t = -1, n = Array(e); ++t < e; )
    n[t] = r(t);
  return n;
}
var il = Object.prototype, sl = il.hasOwnProperty;
function al(e, r) {
  var t = Le(e), n = !t && Do(e), o = !t && !n && po(e), i = !t && !n && !o && na(e), a = t || n || o || i, c = a ? ol(e.length, String) : [], u = c.length;
  for (var l in e)
    (r || sl.call(e, l)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    bn(l, u))) && c.push(l);
  return c;
}
function Nr(e) {
  return Ft(e) ? al(e) : pu(e);
}
var cl = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ul = /^\w*$/;
function No(e, r) {
  if (Le(e))
    return !1;
  var t = typeof e;
  return t == "number" || t == "symbol" || t == "boolean" || e == null || ir(e) ? !0 : ul.test(e) || !cl.test(e) || r != null && e in Object(r);
}
var ll = ra(Object, "create");
const Or = ll;
function dl() {
  this.__data__ = Or ? Or(null) : {}, this.size = 0;
}
function fl(e) {
  var r = this.has(e) && delete this.__data__[e];
  return this.size -= r ? 1 : 0, r;
}
var hl = "__lodash_hash_undefined__", pl = Object.prototype, ml = pl.hasOwnProperty;
function gl(e) {
  var r = this.__data__;
  if (Or) {
    var t = r[e];
    return t === hl ? void 0 : t;
  }
  return ml.call(r, e) ? r[e] : void 0;
}
var yl = Object.prototype, bl = yl.hasOwnProperty;
function xl(e) {
  var r = this.__data__;
  return Or ? r[e] !== void 0 : bl.call(r, e);
}
var vl = "__lodash_hash_undefined__";
function _l(e, r) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = Or && r === void 0 ? vl : r, this;
}
function Nt(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
Nt.prototype.clear = dl;
Nt.prototype.delete = fl;
Nt.prototype.get = gl;
Nt.prototype.has = xl;
Nt.prototype.set = _l;
function wl() {
  this.__data__ = [], this.size = 0;
}
function xn(e, r) {
  for (var t = e.length; t--; )
    if ($o(e[t][0], r))
      return t;
  return -1;
}
var Tl = Array.prototype, Sl = Tl.splice;
function El(e) {
  var r = this.__data__, t = xn(r, e);
  if (t < 0)
    return !1;
  var n = r.length - 1;
  return t == n ? r.pop() : Sl.call(r, t, 1), --this.size, !0;
}
function Ml(e) {
  var r = this.__data__, t = xn(r, e);
  return t < 0 ? void 0 : r[t][1];
}
function Ol(e) {
  return xn(this.__data__, e) > -1;
}
function Pl(e, r) {
  var t = this.__data__, n = xn(t, e);
  return n < 0 ? (++this.size, t.push([e, r])) : t[n][1] = r, this;
}
function Tt(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
Tt.prototype.clear = wl;
Tt.prototype.delete = El;
Tt.prototype.get = Ml;
Tt.prototype.has = Ol;
Tt.prototype.set = Pl;
function kl() {
  this.size = 0, this.__data__ = {
    hash: new Nt(),
    map: new (oa || Tt)(),
    string: new Nt()
  };
}
function Cl(e) {
  var r = typeof e;
  return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
}
function vn(e, r) {
  var t = e.__data__;
  return Cl(r) ? t[typeof r == "string" ? "string" : "hash"] : t.map;
}
function jl(e) {
  var r = vn(this, e).delete(e);
  return this.size -= r ? 1 : 0, r;
}
function Dl(e) {
  return vn(this, e).get(e);
}
function Rl(e) {
  return vn(this, e).has(e);
}
function $l(e, r) {
  var t = vn(this, e), n = t.size;
  return t.set(e, r), this.size += t.size == n ? 0 : 1, this;
}
function St(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
St.prototype.clear = kl;
St.prototype.delete = jl;
St.prototype.get = Dl;
St.prototype.has = Rl;
St.prototype.set = $l;
var Nl = "Expected a function";
function Io(e, r) {
  if (typeof e != "function" || r != null && typeof r != "function")
    throw new TypeError(Nl);
  var t = function() {
    var n = arguments, o = r ? r.apply(this, n) : n[0], i = t.cache;
    if (i.has(o))
      return i.get(o);
    var a = e.apply(this, n);
    return t.cache = i.set(o, a) || i, a;
  };
  return t.cache = new (Io.Cache || St)(), t;
}
Io.Cache = St;
var Il = 500;
function Al(e) {
  var r = Io(e, function(n) {
    return t.size === Il && t.clear(), n;
  }), t = r.cache;
  return r;
}
var Fl = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Wl = /\\(\\)?/g, Bl = Al(function(e) {
  var r = [];
  return e.charCodeAt(0) === 46 && r.push(""), e.replace(Fl, function(t, n, o, i) {
    r.push(o ? i.replace(Wl, "$1") : n || t);
  }), r;
});
const Ll = Bl;
function Yl(e) {
  return e == null ? "" : la(e);
}
function pa(e, r) {
  return Le(e) ? e : No(e, r) ? [e] : Ll(Yl(e));
}
var Hl = 1 / 0;
function _n(e) {
  if (typeof e == "string" || ir(e))
    return e;
  var r = e + "";
  return r == "0" && 1 / e == -Hl ? "-0" : r;
}
function Ao(e, r) {
  r = pa(r, e);
  for (var t = 0, n = r.length; e != null && t < n; )
    e = e[_n(r[t++])];
  return t && t == n ? e : void 0;
}
function zl(e, r, t) {
  var n = e == null ? void 0 : Ao(e, r);
  return n === void 0 ? t : n;
}
function ma(e, r) {
  for (var t = -1, n = r.length, o = e.length; ++t < n; )
    e[o + t] = r[t];
  return e;
}
var Li = or ? or.isConcatSpreadable : void 0;
function ql(e) {
  return Le(e) || Do(e) || !!(Li && e && e[Li]);
}
function ga(e, r, t, n, o) {
  var i = -1, a = e.length;
  for (t || (t = ql), o || (o = []); ++i < a; ) {
    var c = e[i];
    r > 0 && t(c) ? r > 1 ? ga(c, r - 1, t, n, o) : ma(o, c) : n || (o[o.length] = c);
  }
  return o;
}
function Ul() {
  this.__data__ = new Tt(), this.size = 0;
}
function Vl(e) {
  var r = this.__data__, t = r.delete(e);
  return this.size = r.size, t;
}
function Gl(e) {
  return this.__data__.get(e);
}
function Xl(e) {
  return this.__data__.has(e);
}
var Kl = 200;
function Ql(e, r) {
  var t = this.__data__;
  if (t instanceof Tt) {
    var n = t.__data__;
    if (!oa || n.length < Kl - 1)
      return n.push([e, r]), this.size = ++t.size, this;
    t = this.__data__ = new St(n);
  }
  return t.set(e, r), this.size = t.size, this;
}
function vt(e) {
  var r = this.__data__ = new Tt(e);
  this.size = r.size;
}
vt.prototype.clear = Ul;
vt.prototype.delete = Vl;
vt.prototype.get = Gl;
vt.prototype.has = Xl;
vt.prototype.set = Ql;
function ya(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length, o = 0, i = []; ++t < n; ) {
    var a = e[t];
    r(a, t, e) && (i[o++] = a);
  }
  return i;
}
function Jl() {
  return [];
}
var Zl = Object.prototype, ed = Zl.propertyIsEnumerable, Yi = Object.getOwnPropertySymbols, td = Yi ? function(e) {
  return e == null ? [] : (e = Object(e), ya(Yi(e), function(r) {
    return ed.call(e, r);
  }));
} : Jl;
const rd = td;
function nd(e, r, t) {
  var n = r(e);
  return Le(e) ? n : ma(n, t(e));
}
function Hi(e) {
  return nd(e, Nr, rd);
}
var od = ia.Uint8Array;
const zi = od;
var id = "__lodash_hash_undefined__";
function sd(e) {
  return this.__data__.set(e, id), this;
}
function ad(e) {
  return this.__data__.has(e);
}
function sr(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.__data__ = new St(); ++r < t; )
    this.add(e[r]);
}
sr.prototype.add = sr.prototype.push = sd;
sr.prototype.has = ad;
function ba(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length; ++t < n; )
    if (r(e[t], t, e))
      return !0;
  return !1;
}
function Fo(e, r) {
  return e.has(r);
}
var cd = 1, ud = 2;
function xa(e, r, t, n, o, i) {
  var a = t & cd, c = e.length, u = r.length;
  if (c != u && !(a && u > c))
    return !1;
  var l = i.get(e), f = i.get(r);
  if (l && f)
    return l == r && f == e;
  var d = -1, h = !0, y = t & ud ? new sr() : void 0;
  for (i.set(e, r), i.set(r, e); ++d < c; ) {
    var b = e[d], m = r[d];
    if (n)
      var g = a ? n(m, b, d, r, e, i) : n(b, m, d, e, r, i);
    if (g !== void 0) {
      if (g)
        continue;
      h = !1;
      break;
    }
    if (y) {
      if (!ba(r, function(v, _) {
        if (!Fo(y, _) && (b === v || o(b, v, t, n, i)))
          return y.push(_);
      })) {
        h = !1;
        break;
      }
    } else if (!(b === m || o(b, m, t, n, i))) {
      h = !1;
      break;
    }
  }
  return i.delete(e), i.delete(r), h;
}
function ld(e) {
  var r = -1, t = Array(e.size);
  return e.forEach(function(n, o) {
    t[++r] = [o, n];
  }), t;
}
function Wo(e) {
  var r = -1, t = Array(e.size);
  return e.forEach(function(n) {
    t[++r] = n;
  }), t;
}
var dd = 1, fd = 2, hd = "[object Boolean]", pd = "[object Date]", md = "[object Error]", gd = "[object Map]", yd = "[object Number]", bd = "[object RegExp]", xd = "[object Set]", vd = "[object String]", _d = "[object Symbol]", wd = "[object ArrayBuffer]", Td = "[object DataView]", qi = or ? or.prototype : void 0, Gn = qi ? qi.valueOf : void 0;
function Sd(e, r, t, n, o, i, a) {
  switch (t) {
    case Td:
      if (e.byteLength != r.byteLength || e.byteOffset != r.byteOffset)
        return !1;
      e = e.buffer, r = r.buffer;
    case wd:
      return !(e.byteLength != r.byteLength || !i(new zi(e), new zi(r)));
    case hd:
    case pd:
    case yd:
      return $o(+e, +r);
    case md:
      return e.name == r.name && e.message == r.message;
    case bd:
    case vd:
      return e == r + "";
    case gd:
      var c = ld;
    case xd:
      var u = n & dd;
      if (c || (c = Wo), e.size != r.size && !u)
        return !1;
      var l = a.get(e);
      if (l)
        return l == r;
      n |= fd, a.set(e, r);
      var f = xa(c(e), c(r), n, o, i, a);
      return a.delete(e), f;
    case _d:
      if (Gn)
        return Gn.call(e) == Gn.call(r);
  }
  return !1;
}
var Ed = 1, Md = Object.prototype, Od = Md.hasOwnProperty;
function Pd(e, r, t, n, o, i) {
  var a = t & Ed, c = Hi(e), u = c.length, l = Hi(r), f = l.length;
  if (u != f && !a)
    return !1;
  for (var d = u; d--; ) {
    var h = c[d];
    if (!(a ? h in r : Od.call(r, h)))
      return !1;
  }
  var y = i.get(e), b = i.get(r);
  if (y && b)
    return y == r && b == e;
  var m = !0;
  i.set(e, r), i.set(r, e);
  for (var g = a; ++d < u; ) {
    h = c[d];
    var v = e[h], _ = r[h];
    if (n)
      var T = a ? n(_, v, h, r, e, i) : n(v, _, h, e, r, i);
    if (!(T === void 0 ? v === _ || o(v, _, t, n, i) : T)) {
      m = !1;
      break;
    }
    g || (g = h == "constructor");
  }
  if (m && !g) {
    var w = e.constructor, x = r.constructor;
    w != x && "constructor" in e && "constructor" in r && !(typeof w == "function" && w instanceof w && typeof x == "function" && x instanceof x) && (m = !1);
  }
  return i.delete(e), i.delete(r), m;
}
var kd = 1, Ui = "[object Arguments]", Vi = "[object Array]", Vr = "[object Object]", Cd = Object.prototype, Gi = Cd.hasOwnProperty;
function jd(e, r, t, n, o, i) {
  var a = Le(e), c = Le(r), u = a ? Vi : Di(e), l = c ? Vi : Di(r);
  u = u == Ui ? Vr : u, l = l == Ui ? Vr : l;
  var f = u == Vr, d = l == Vr, h = u == l;
  if (h && po(e)) {
    if (!po(r))
      return !1;
    a = !0, f = !1;
  }
  if (h && !f)
    return i || (i = new vt()), a || na(e) ? xa(e, r, t, n, o, i) : Sd(e, r, u, t, n, o, i);
  if (!(t & kd)) {
    var y = f && Gi.call(e, "__wrapped__"), b = d && Gi.call(r, "__wrapped__");
    if (y || b) {
      var m = y ? e.value() : e, g = b ? r.value() : r;
      return i || (i = new vt()), o(m, g, t, n, i);
    }
  }
  return h ? (i || (i = new vt()), Pd(e, r, t, n, o, i)) : !1;
}
function wn(e, r, t, n, o) {
  return e === r ? !0 : e == null || r == null || !Er(e) && !Er(r) ? e !== e && r !== r : jd(e, r, t, n, wn, o);
}
var Dd = 1, Rd = 2;
function $d(e, r, t, n) {
  var o = t.length, i = o, a = !n;
  if (e == null)
    return !i;
  for (e = Object(e); o--; ) {
    var c = t[o];
    if (a && c[2] ? c[1] !== e[c[0]] : !(c[0] in e))
      return !1;
  }
  for (; ++o < i; ) {
    c = t[o];
    var u = c[0], l = e[u], f = c[1];
    if (a && c[2]) {
      if (l === void 0 && !(u in e))
        return !1;
    } else {
      var d = new vt();
      if (n)
        var h = n(l, f, u, e, r, d);
      if (!(h === void 0 ? wn(f, l, Dd | Rd, n, d) : h))
        return !1;
    }
  }
  return !0;
}
function va(e) {
  return e === e && !Mr(e);
}
function Nd(e) {
  for (var r = Nr(e), t = r.length; t--; ) {
    var n = r[t], o = e[n];
    r[t] = [n, o, va(o)];
  }
  return r;
}
function _a(e, r) {
  return function(t) {
    return t == null ? !1 : t[e] === r && (r !== void 0 || e in Object(t));
  };
}
function Id(e) {
  var r = Nd(e);
  return r.length == 1 && r[0][2] ? _a(r[0][0], r[0][1]) : function(t) {
    return t === e || $d(t, e, r);
  };
}
function Ad(e, r) {
  return e != null && r in Object(e);
}
function Fd(e, r, t) {
  r = pa(r, e);
  for (var n = -1, o = r.length, i = !1; ++n < o; ) {
    var a = _n(r[n]);
    if (!(i = e != null && t(e, a)))
      break;
    e = e[a];
  }
  return i || ++n != o ? i : (o = e == null ? 0 : e.length, !!o && mu(o) && bn(a, o) && (Le(e) || Do(e)));
}
function Wd(e, r) {
  return e != null && Fd(e, r, Ad);
}
var Bd = 1, Ld = 2;
function Yd(e, r) {
  return No(e) && va(r) ? _a(_n(e), r) : function(t) {
    var n = zl(t, e);
    return n === void 0 && n === r ? Wd(t, e) : wn(r, n, Bd | Ld);
  };
}
function Hd(e) {
  return function(r) {
    return r == null ? void 0 : r[e];
  };
}
function zd(e) {
  return function(r) {
    return Ao(r, e);
  };
}
function qd(e) {
  return No(e) ? Hd(_n(e)) : zd(e);
}
function Wt(e) {
  return typeof e == "function" ? e : e == null ? yn : typeof e == "object" ? Le(e) ? Yd(e[0], e[1]) : Id(e) : qd(e);
}
function Ud(e) {
  return function(r, t, n) {
    for (var o = -1, i = Object(r), a = n(r), c = a.length; c--; ) {
      var u = a[e ? c : ++o];
      if (t(i[u], u, i) === !1)
        break;
    }
    return r;
  };
}
var Vd = Ud();
const Gd = Vd;
function Xd(e, r) {
  return e && Gd(e, r, Nr);
}
function Kd(e, r) {
  return function(t, n) {
    if (t == null)
      return t;
    if (!Ft(t))
      return e(t, n);
    for (var o = t.length, i = r ? o : -1, a = Object(t); (r ? i-- : ++i < o) && n(a[i], i, a) !== !1; )
      ;
    return t;
  };
}
var Qd = Kd(Xd);
const Bo = Qd;
var Jd = function() {
  return ia.Date.now();
};
const Xn = Jd;
var Zd = "Expected a function", ef = Math.max, tf = Math.min;
function Tn(e, r, t) {
  var n, o, i, a, c, u, l = 0, f = !1, d = !1, h = !0;
  if (typeof e != "function")
    throw new TypeError(Zd);
  r = go(r) || 0, Mr(t) && (f = !!t.leading, d = "maxWait" in t, i = d ? ef(go(t.maxWait) || 0, r) : i, h = "trailing" in t ? !!t.trailing : h);
  function y(S) {
    var P = n, F = o;
    return n = o = void 0, l = S, a = e.apply(F, P), a;
  }
  function b(S) {
    return l = S, c = setTimeout(v, r), f ? y(S) : a;
  }
  function m(S) {
    var P = S - u, F = S - l, ee = r - P;
    return d ? tf(ee, i - F) : ee;
  }
  function g(S) {
    var P = S - u, F = S - l;
    return u === void 0 || P >= r || P < 0 || d && F >= i;
  }
  function v() {
    var S = Xn();
    if (g(S))
      return _(S);
    c = setTimeout(v, m(S));
  }
  function _(S) {
    return c = void 0, h && n ? y(S) : (n = o = void 0, a);
  }
  function T() {
    c !== void 0 && clearTimeout(c), l = 0, n = u = o = c = void 0;
  }
  function w() {
    return c === void 0 ? a : _(Xn());
  }
  function x() {
    var S = Xn(), P = g(S);
    if (n = arguments, o = this, u = S, P) {
      if (c === void 0)
        return b(u);
      if (d)
        return clearTimeout(c), c = setTimeout(v, r), y(u);
    }
    return c === void 0 && (c = setTimeout(v, r)), a;
  }
  return x.cancel = T, x.flush = w, x;
}
function Xi(e) {
  return Er(e) && Ft(e);
}
function wa(e, r, t) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o; )
    if (t(r, e[n]))
      return !0;
  return !1;
}
var rf = 200;
function nf(e, r, t, n) {
  var o = -1, i = ha, a = !0, c = e.length, u = [], l = r.length;
  if (!c)
    return u;
  t && (r = $t(r, sa(t))), n ? (i = wa, a = !1) : r.length >= rf && (i = Fo, a = !1, r = new sr(r));
  e:
    for (; ++o < c; ) {
      var f = e[o], d = t == null ? f : t(f);
      if (f = n || f !== 0 ? f : 0, a && d === d) {
        for (var h = l; h--; )
          if (r[h] === d)
            continue e;
        u.push(f);
      } else
        i(r, d, n) || u.push(f);
    }
  return u;
}
var of = rl(function(e, r) {
  return Xi(e) ? nf(e, ga(r, 1, Xi, !0)) : [];
});
const sf = of;
function af(e, r) {
  var t = [];
  return Bo(e, function(n, o, i) {
    r(n, o, i) && t.push(n);
  }), t;
}
function et(e, r) {
  var t = Le(e) ? ya : af;
  return t(e, Wt(r));
}
function cf(e) {
  return function(r, t, n) {
    var o = Object(r);
    if (!Ft(r)) {
      var i = Wt(t);
      r = Nr(r), t = function(c) {
        return i(o[c], c, o);
      };
    }
    var a = e(r, t, n);
    return a > -1 ? o[i ? r[a] : a] : void 0;
  };
}
var uf = Math.max;
function lf(e, r, t) {
  var n = e == null ? 0 : e.length;
  if (!n)
    return -1;
  var o = t == null ? 0 : Ro(t);
  return o < 0 && (o = uf(n + o, 0)), da(e, Wt(r), o);
}
var df = cf(lf);
const Jt = df;
function Ta(e, r) {
  var t = -1, n = Ft(e) ? Array(e.length) : [];
  return Bo(e, function(o, i, a) {
    n[++t] = r(o, i, a);
  }), n;
}
function Ve(e, r) {
  var t = Le(e) ? $t : Ta;
  return t(e, Wt(r));
}
var ff = "[object String]";
function hf(e) {
  return typeof e == "string" || !Le(e) && Er(e) && ta(e) == ff;
}
function pf(e, r) {
  return $t(r, function(t) {
    return e[t];
  });
}
function mf(e) {
  return e == null ? [] : pf(e, Nr(e));
}
var gf = Math.max;
function Be(e, r, t, n) {
  e = Ft(e) ? e : mf(e), t = t && !n ? Ro(t) : 0;
  var o = e.length;
  return t < 0 && (t = gf(o + t, 0)), hf(e) ? t <= o && e.indexOf(r, t) > -1 : !!o && fa(e, r, t) > -1;
}
function Sa(e, r) {
  return wn(e, r);
}
function Sn(e) {
  return e === null;
}
function It(e) {
  return e === void 0;
}
function yf(e, r) {
  var t = e.length;
  if (t)
    return r += r < 0 ? t : 0, bn(r, t) ? e[r] : void 0;
}
function Ki(e, r) {
  return e && e.length ? yf(e, Ro(r)) : void 0;
}
function bf(e, r) {
  var t = e.length;
  for (e.sort(r); t--; )
    e[t] = e[t].value;
  return e;
}
function xf(e, r) {
  if (e !== r) {
    var t = e !== void 0, n = e === null, o = e === e, i = ir(e), a = r !== void 0, c = r === null, u = r === r, l = ir(r);
    if (!c && !l && !i && e > r || i && a && u && !c && !l || n && a && u || !t && u || !o)
      return 1;
    if (!n && !i && !l && e < r || l && t && o && !n && !i || c && t && o || !a && o || !u)
      return -1;
  }
  return 0;
}
function vf(e, r, t) {
  for (var n = -1, o = e.criteria, i = r.criteria, a = o.length, c = t.length; ++n < a; ) {
    var u = xf(o[n], i[n]);
    if (u) {
      if (n >= c)
        return u;
      var l = t[n];
      return u * (l == "desc" ? -1 : 1);
    }
  }
  return e.index - r.index;
}
function _f(e, r, t) {
  r.length ? r = $t(r, function(i) {
    return Le(i) ? function(a) {
      return Ao(a, i.length === 1 ? i[0] : i);
    } : i;
  }) : r = [yn];
  var n = -1;
  r = $t(r, sa(Wt));
  var o = Ta(e, function(i, a, c) {
    var u = $t(r, function(l) {
      return l(i);
    });
    return { criteria: u, index: ++n, value: i };
  });
  return bf(o, function(i, a) {
    return vf(i, a, t);
  });
}
function wf(e, r, t, n) {
  return e == null ? [] : (Le(r) || (r = r == null ? [] : [r]), t = n ? void 0 : t, Le(t) || (t = t == null ? [] : [t]), _f(e, r, t));
}
function Tf(e, r) {
  var t;
  return Bo(e, function(n, o, i) {
    return t = r(n, o, i), !t;
  }), !!t;
}
function yo(e, r, t) {
  var n = Le(e) ? ba : Tf;
  return t && nl(e, r, t) && (r = void 0), n(e, Wt(r));
}
var Sf = 1 / 0, Ef = Un && 1 / Wo(new Un([, -0]))[1] == Sf ? function(e) {
  return new Un(e);
} : Bu;
const Mf = Ef;
var Of = 200;
function Pf(e, r, t) {
  var n = -1, o = ha, i = e.length, a = !0, c = [], u = c;
  if (t)
    a = !1, o = wa;
  else if (i >= Of) {
    var l = r ? null : Mf(e);
    if (l)
      return Wo(l);
    a = !1, o = Fo, u = new sr();
  } else
    u = r ? [] : c;
  e:
    for (; ++n < i; ) {
      var f = e[n], d = r ? r(f) : f;
      if (f = t || f !== 0 ? f : 0, a && d === d) {
        for (var h = u.length; h--; )
          if (u[h] === d)
            continue e;
        r && u.push(d), c.push(f);
      } else
        o(u, d, t) || (u !== c && u.push(d), c.push(f));
    }
  return c;
}
function Lo(e, r) {
  return e && e.length ? Pf(e, Wt(r)) : [];
}
const kf = Z(At)(({ theme: e }) => ({
  "label + &": {
    marginTop: e.spacing(2)
  },
  "&&.MuiInputBase-root": {
    borderRadius: "2px"
  },
  "&&.MuiInputBase-root:not(.Mui-disabled)": {
    backgroundColor: "#fff"
  },
  "&&.MuiInputBase-root.Mui-disabled": {
    backgroundColor: "#eee"
  },
  "&&.MuiInputBase-root.Mui-error": {
    backgroundColor: "#FFD2C2"
  },
  "&&.MuiInputBase-root fieldset": {
    borderRadius: "2px"
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "1px solid #7C7C7C"
  },
  "&&.MuiInputBase-root:has(.MuiButtonBase-root) .MuiInputBase-input": {
    paddingRight: "0px"
  },
  "&& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.Mui-disabled": {
    paddingRight: "26px"
  },
  "& .MuiInputBase-input": {
    boxSizing: "border-box",
    position: "relative",
    fontSize: 16,
    padding: "8px 26px 8px 12px",
    fontFamily: "Hiragino Kaku Gothic ProN",
    "&:focus": {
      borderRadius: 2,
      borderColor: "#2681FF"
    }
  }
})), Cf = Z(yt)({
  display: "-webkit-box",
  textSizeAdjust: "none",
  whiteSpace: "pre-line",
  wordBreak: "break-all",
  fontSize: "16px",
  fontFamily: "Hiragino Kaku Gothic ProN",
  color: "#000000"
}), jf = Z(ur)(({ theme: e }) => ({
  color: "#999"
})), Df = Z(De)(
  ({ theme: e, width: r }) => ({
    boxSizing: "border-box",
    width: r,
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
    backgroundColor: "#fff"
  })
), Ct = ({
  label: e,
  requiredText: r,
  isRequired: t,
  isRecommended: n,
  isCooperated: o,
  children: i
}) => /* @__PURE__ */ s.jsxs(De, { sx: { padding: e ? "10px 0px" : "" }, children: [
  e && /* @__PURE__ */ s.jsx(
    De,
    {
      component: "label",
      sx: {
        display: "flex",
        alignItems: "center"
      },
      children: /* @__PURE__ */ s.jsxs(
        De,
        {
          sx: {
            color: "#1A1A1A",
            fontSize: "16px",
            fontWeight: "bold",
            wordBreak: "break-all",
            overflowWrap: "anywhere"
          },
          children: [
            e,
            t && /* @__PURE__ */ s.jsx(Vn, { type: "required", requiredText: r }),
            n && /* @__PURE__ */ s.jsx(Vn, { type: "recommended" }),
            o && /* @__PURE__ */ s.jsx(Vn, { type: "cooperated" })
          ]
        }
      )
    }
  ),
  i
] }), Ea = ze(function(T, _) {
  var w = T, {
    error: r,
    disabled: t,
    helperText: n,
    label: o,
    options: i,
    placeholder: a,
    hasClearButton: c = !0,
    isRequired: u,
    value: l,
    width: f,
    menuHeight: d,
    onChange: h,
    onOpen: y,
    onScroll: b,
    isLoading: m,
    isZIndexPopupWindow: g
  } = w, v = Se(w, [
    "error",
    "disabled",
    "helperText",
    "label",
    "options",
    "placeholder",
    "hasClearButton",
    "isRequired",
    "value",
    "width",
    "menuHeight",
    "onChange",
    "onOpen",
    "onScroll",
    "isLoading",
    "isZIndexPopupWindow"
  ]);
  const [x, S] = xe(!1), P = tt(null), F = tt(), ee = () => {
    if (!t) {
      if (x) {
        S(!1);
        return;
      }
      S(!0), Fe(y) && y();
    }
  }, Y = (C) => {
    Fe(h) && !Sa(C, l) && h(C), S(!1);
  }, k = (C) => {
    C.stopPropagation(), h(void 0), S(!1);
  };
  return /* @__PURE__ */ s.jsx(Ct, { label: o, isRequired: u, children: /* @__PURE__ */ s.jsxs(
    nt,
    {
      disabled: t,
      error: r,
      sx: { width: f || "100%" },
      ref: P,
      children: [
        /* @__PURE__ */ s.jsx(
          kf,
          A({
            displayEmpty: !0,
            variant: "outlined",
            open: !1,
            ref: (C) => (F.current = C, _),
            onClick: ee,
            endAdornment: !ye(l) && !t && c && /* @__PURE__ */ s.jsx(
              qs,
              {
                onClick: k,
                sx: { marginRight: "8px" },
                children: /* @__PURE__ */ s.jsx(ea, { sx: { fontSize: 16 } })
              }
            ),
            value: (l == null ? void 0 : l.value) || "",
            renderValue: (C) => ye(l == null ? void 0 : l.label) ? /* @__PURE__ */ s.jsx(jf, { children: a || "" }) : l == null ? void 0 : l.label,
            sx: {
              height: "40px",
              ".MuiSelect-icon": {
                transform: x ? "rotate(180deg)" : void 0
              }
            }
          }, v)
        ),
        /* @__PURE__ */ s.jsx(
          pn,
          {
            onClickAway: (C) => {
              F.current && F.current.contains(C.target) || S(!1);
            },
            children: /* @__PURE__ */ s.jsx(
              mn,
              {
                open: x,
                anchorEl: F.current,
                placement: "bottom-start",
                sx: {
                  zIndex: g ? at.POPUP_WINDOW : at.FORM_LAYOUT
                },
                modifiers: [{ name: "preventOverflow", enabled: !1 }],
                children: /* @__PURE__ */ s.jsx(
                  Df,
                  {
                    width: Sn(P.current) ? "auto" : P.current.clientWidth,
                    children: /* @__PURE__ */ s.jsxs(
                      De,
                      {
                        sx: {
                          maxHeight: d || "200px",
                          overflowY: "auto",
                          borderRadius: "2px",
                          padding: "8px 0px 8px 0px"
                        },
                        onScroll: b,
                        children: [
                          ye(i) && !m ? /* @__PURE__ */ s.jsx(yt, { disabled: !0, children: Co }) : Ve(i, (C, B) => /* @__PURE__ */ s.jsx(
                            Cf,
                            {
                              value: C.value,
                              sx: { whiteSpace: "normal", wordBreak: "break-all" },
                              onClick: () => Y(C),
                              children: C.label
                            },
                            `${C.value}_${B}`
                          )),
                          m && /* @__PURE__ */ s.jsx(yt, { disabled: !0, children: jo })
                        ]
                      }
                    )
                  }
                )
              }
            )
          }
        ),
        n && /* @__PURE__ */ s.jsx(ot, { sx: { marginLeft: 0 }, children: n })
      ]
    }
  ) });
});
Ea.displayName = "SPSelect";
const Bt = (e) => {
  const [r, t] = xe(!0), [n, o] = xe(!1), [i, a] = xe(1), [c, u] = xe([]), [l, f] = xe({}), d = tt(0);
  return {
    data: c,
    loading: n,
    hasNextPage: r,
    pageNum: i,
    requestParams: l,
    getData: (b, m) => ji(void 0, null, function* () {
      if (!r && !m)
        return;
      const g = Date.now();
      d.current = g, o(!0);
      const v = A(m ? {} : A({}, l), b), _ = yield e(ve(A({}, v), { page: m ? 1 : i }));
      o(!1), d.current === g && (_.length > 0 ? (f(v), u((T) => m ? _ : [...T, ..._]), a((T) => (m ? 1 : T) + 1), t(!0)) : (m && u([]), t(!1)));
    }),
    initialize: () => {
      d.current = 0, t(!0), o(!1), u([]), a(1), f({});
    }
  };
}, Rf = ze(function(c, a) {
  var u = c, {
    fetchData: r,
    onChange: t,
    initialOptions: n,
    menuHeight: o
  } = u, i = Se(u, [
    "fetchData",
    "onChange",
    "initialOptions",
    "menuHeight"
  ]);
  const { data: l, loading: f, pageNum: d, getData: h } = Bt(r), y = He(() => {
    if (!n)
      return l;
    const g = [...n, ...l];
    return Array.from(
      new Map(
        Ve(g, (v) => [v.value, v])
      ).values()
    );
  }, [l, n]), b = (g) => {
    if (f || !open)
      return;
    const { scrollHeight: v, scrollTop: _, clientHeight: T } = g.target;
    Math.abs(v - _) < T + 1 && h().catch((w) => {
      throw w;
    });
  }, m = () => {
    d === 1 && h().catch((g) => {
      throw g;
    });
  };
  return /* @__PURE__ */ s.jsx(
    Ea,
    ve(A({}, i), {
      isLoading: f,
      onScroll: b,
      onChange: t,
      onOpen: m,
      options: y,
      ref: a
    })
  );
});
Rf.displayName = "SPAsyncSelect";
const $f = Z(At)(({ theme: e }) => ({
  "label + &": {
    marginTop: e.spacing(2)
  },
  "&&.MuiInputBase-root": {
    borderRadius: "2px"
  },
  "&&.MuiInputBase-root:not(.Mui-disabled)": {
    backgroundColor: "#fff"
  },
  "&&.MuiInputBase-root.Mui-disabled": {
    backgroundColor: "#eee"
  },
  "&&.MuiInputBase-root.Mui-error": {
    backgroundColor: "#FFD2C2"
  },
  "&&.MuiInputBase-root fieldset": {
    borderRadius: "2px"
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "1px solid #7C7C7C"
  },
  "&&.MuiInputBase-root:has(.MuiButtonBase-root) .MuiInputBase-input": {
    paddingRight: "0px"
  },
  "&& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.Mui-disabled": {
    paddingRight: "26px"
  },
  "& .MuiInputBase-input": {
    boxSizing: "border-box",
    position: "relative",
    fontSize: 16,
    padding: "8px 26px 8px 12px",
    fontFamily: "Hiragino Kaku Gothic ProN",
    "&:focus": {
      borderRadius: 2,
      borderColor: "#2681FF"
    }
  }
})), Kn = Z(yt)({
  display: "-webkit-box",
  textSizeAdjust: "none",
  whiteSpace: "pre-line",
  wordBreak: "break-all",
  fontSize: "16px",
  fontFamily: "Hiragino Kaku Gothic ProN",
  color: "#000000"
}), Nf = Z(ur)(({ theme: e }) => ({
  color: "#999"
})), If = Z(De)(
  ({ theme: e, width: r }) => ({
    boxSizing: "border-box",
    width: r,
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
    backgroundColor: "#fff"
  })
), Ma = ze(function(F, P) {
  var ee = F, {
    disabled: r,
    error: t,
    helperText: n,
    hasClearButton: o,
    isLoading: i,
    isRequired: a,
    label: c,
    menuHeight: u,
    onChange: l,
    onOpen: f,
    onResetOptions: d,
    onInputChange: h,
    onScroll: y,
    options: b,
    placeholder: m,
    shouldFilterOptions: g = !0,
    value: v,
    width: _,
    listDisabledValues: T = [],
    isTopFixedArea: w = !1,
    isZIndexPopupWindow: x
  } = ee, S = Se(ee, [
    "disabled",
    "error",
    "helperText",
    "hasClearButton",
    "isLoading",
    "isRequired",
    "label",
    "menuHeight",
    "onChange",
    "onOpen",
    "onResetOptions",
    "onInputChange",
    "onScroll",
    "options",
    "placeholder",
    "shouldFilterOptions",
    "value",
    "width",
    "listDisabledValues",
    "isTopFixedArea",
    "isZIndexPopupWindow"
  ]);
  const [Y, k] = xe(""), [C, B, j] = aa(!1), Q = tt(null), ie = tt(), H = () => {
    if (!r) {
      if (C) {
        G();
        return;
      }
      B(!0), Fe(f) && f();
    }
  }, G = () => {
    B(!1), Y !== "" && Fe(d) && d(), k("");
  }, _e = (I) => {
    I.stopPropagation(), Fe(l) && l(void 0), G();
  }, E = (I) => {
    k(I.target.value), Fe(h) && h(I.target.value, j);
  }, M = (I) => {
    Fe(l) && !Sa(I, v) && l(I), G();
  }, L = He(() => !g || !Y || !Y.trim() ? b : et(
    b,
    (I) => Be(I.label.toLowerCase(), Y.toLowerCase())
  ), [Y, b]);
  return /* @__PURE__ */ s.jsx(Ct, { label: c, isRequired: a, children: /* @__PURE__ */ s.jsxs(
    nt,
    {
      disabled: r,
      error: t,
      sx: { width: _ || "100%" },
      ref: Q,
      children: [
        /* @__PURE__ */ s.jsx(
          $f,
          ve(A({}, S), {
            displayEmpty: !0,
            variant: "outlined",
            ref: (I) => (ie.current = I, P),
            open: !1,
            onClick: H,
            value: (v == null ? void 0 : v.value) || "",
            renderValue: (I) => ye(v == null ? void 0 : v.label) ? /* @__PURE__ */ s.jsx(Nf, { children: m || "" }) : v == null ? void 0 : v.label,
            endAdornment: !ye(v) && !r && o && /* @__PURE__ */ s.jsx(
              qs,
              {
                onClick: _e,
                sx: { marginRight: "8px" },
                children: /* @__PURE__ */ s.jsx(ea, { sx: { fontSize: 16 } })
              }
            ),
            sx: {
              height: "40px",
              ".MuiSelect-icon": {
                transform: C ? "rotate(180deg)" : void 0
              }
            }
          })
        ),
        /* @__PURE__ */ s.jsx(
          pn,
          {
            onClickAway: (I) => {
              ie.current && ie.current.contains(I.target) || G();
            },
            children: /* @__PURE__ */ s.jsx(
              mn,
              {
                popperOptions: { strategy: w ? "fixed" : "absolute" },
                open: C,
                anchorEl: ie.current,
                placement: "bottom-start",
                sx: {
                  zIndex: w ? at.TOP_FIXED_AREA : x ? at.POPUP_WINDOW : at.FORM_LAYOUT
                },
                modifiers: [{ name: "preventOverflow", enabled: !1 }],
                children: /* @__PURE__ */ s.jsxs(
                  If,
                  {
                    width: Sn(Q.current) ? "auto" : Q.current.clientWidth,
                    children: [
                      /* @__PURE__ */ s.jsx(
                        lr,
                        {
                          fullWidth: !0,
                          autoComplete: "off",
                          value: Y,
                          onChange: E,
                          InputProps: {
                            sx: {
                              margin: "4px",
                              height: "40px",
                              width: "calc(100% - 8px)"
                            }
                          }
                        }
                      ),
                      /* @__PURE__ */ s.jsx(dr, {}),
                      /* @__PURE__ */ s.jsx(
                        De,
                        {
                          sx: {
                            maxHeight: u || "200px",
                            overflowY: "auto",
                            borderRadius: "2px",
                            padding: "8px 0px 8px 0px"
                          },
                          onScroll: y,
                          children: ye(L) ? /* @__PURE__ */ s.jsx(De, { sx: { padding: "8px" }, children: /* @__PURE__ */ s.jsx(
                            Kn,
                            {
                              disabled: !0,
                              sx: { padding: "0px 16px 0px 16px" },
                              children: Co
                            }
                          ) }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
                            Ve(L, (I) => {
                              const z = Be(
                                T,
                                I.value
                              );
                              return /* @__PURE__ */ s.jsx(
                                Kn,
                                {
                                  value: I.value,
                                  onClick: () => !z && M(I),
                                  disabled: z,
                                  selected: (v == null ? void 0 : v.value) === I.value,
                                  children: I.label
                                },
                                I.value
                              );
                            }),
                            i && /* @__PURE__ */ s.jsx(Kn, { disabled: !0, children: jo })
                          ] })
                        }
                      )
                    ]
                  }
                )
              }
            )
          }
        ),
        n && /* @__PURE__ */ s.jsx(ot, { sx: { marginLeft: 0 }, children: n })
      ]
    }
  ) });
});
Ma.displayName = "SPSuggestiveSelect";
const Af = ze(
  function(u, c) {
    var l = u, {
      initialOptions: r,
      fetchData: t,
      beforeFetchDataOnInputChanged: n,
      onChange: o,
      value: i
    } = l, a = Se(l, [
      "initialOptions",
      "fetchData",
      "beforeFetchDataOnInputChanged",
      "onChange",
      "value"
    ]);
    const { data: f, loading: d, pageNum: h, getData: y, initialize: b } = Bt(t), m = tt(""), g = He(() => {
      if (!r)
        return f;
      const S = [...et(
        r,
        (P) => Be(P.label, m.current)
      ), ...f];
      return Array.from(
        new Map(S.map((P) => [P.value, P])).values()
      );
    }, [f, r]), v = He(
      () => Tn((x, S) => {
        if (Fe(S) && !S())
          return;
        m.current = x;
        const P = n(x);
        y(P, !0).catch((F) => {
          throw F;
        });
      }, 500),
      [n, y]
    ), _ = () => {
      h === 1 && y().catch((x) => {
        throw x;
      });
    }, T = ko(() => {
      m.current = "", b();
    }, [b]), w = (x) => {
      if (d)
        return;
      const { scrollHeight: S, scrollTop: P, clientHeight: F } = x.target;
      Math.abs(S - P) < F + 1 && y().catch((ee) => {
        throw ee;
      });
    };
    return /* @__PURE__ */ s.jsx(
      Ma,
      ve(A({}, a), {
        shouldFilterOptions: !1,
        value: i,
        onChange: o,
        onOpen: _,
        onResetOptions: T,
        isLoading: d,
        onInputChange: v,
        onScroll: w,
        options: g,
        ref: c
      })
    );
  }
);
Af.displayName = "SPAsyncSuggestiveSelect";
const Ff = Z(At)(({ theme: e }) => ({
  minHeight: "40px",
  "label + &": {
    marginTop: e.spacing(2)
  },
  "&&.MuiInputBase-root:not(.Mui-disabled)": {
    backgroundColor: "#fff"
  },
  "&&.MuiInputBase-root.Mui-disabled": {
    backgroundColor: "#eee"
  },
  "&&.MuiInputBase-root.Mui-error": {
    backgroundColor: "#FFD2C2"
  },
  "&&.MuiInputBase-root fieldset": {
    borderRadius: "2px"
  },
  "&&.MuiInputBase-root:has(.MuiButtonBase-root) .MuiInputBase-input": {
    paddingRight: "8px"
  },
  "&& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.Mui-disabled": {
    paddingRight: "26px"
  },
  "& .MuiInputBase-input": {
    boxSizing: "border-box",
    position: "relative",
    padding: "8px",
    "&:focus": {
      borderRadius: 2,
      borderColor: "#2681FF"
    }
  },
  "&& .MuiSelect-icon": {
    display: "none"
  }
})), Wf = () => ({
  borderRadius: "4px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  height: "24px",
  "&&.MuiChip-root .MuiChip-label": {
    order: 2,
    padding: "0 4px 0 4px"
  },
  "&&.MuiChip-root .MuiSvgIcon-root": {
    margin: "0 0 0 4px",
    order: 1
  }
}), Bf = Z(ur)(({ theme: e }) => ({
  color: "#999",
  paddingLeft: "6px"
})), Qn = Z(yt)(({ theme: e }) => ({
  display: "-webkit-box",
  textSizeAdjust: "none",
  whiteSpace: "pre-line",
  wordBreak: "break-all",
  fontSize: "16px",
  fontFamily: "Hiragino Kaku Gothic ProN"
})), Lf = Z(De)(
  ({ theme: e, width: r }) => ({
    boxSizing: "border-box",
    width: r,
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
    backgroundColor: "#fff"
  })
), Oa = ze(
  function(S, x) {
    var P = S, {
      disabled: r,
      error: t,
      helperText: n,
      isLoading: o,
      isRequired: i,
      label: a,
      menuHeight: c,
      onChange: u,
      onOpen: l,
      onResetOptions: f,
      onInputChange: d,
      onScroll: h,
      options: y,
      placeholder: b,
      shouldFilterOptions: m = !0,
      value: g = [],
      width: v,
      hasFilter: _ = !0,
      isZIndexPopupWindow: T
    } = P, w = Se(P, [
      "disabled",
      "error",
      "helperText",
      "isLoading",
      "isRequired",
      "label",
      "menuHeight",
      "onChange",
      "onOpen",
      "onResetOptions",
      "onInputChange",
      "onScroll",
      "options",
      "placeholder",
      "shouldFilterOptions",
      "value",
      "width",
      "hasFilter",
      "isZIndexPopupWindow"
    ]);
    const [F, ee] = xe(""), [Y, k, C] = aa(!1), B = tt(null), j = tt(), Q = () => {
      if (!r) {
        if (Y) {
          ie();
          return;
        }
        k(!0), Fe(l) && l();
      }
    }, ie = () => {
      k(!1), F !== "" && Fe(f) && f(), ee("");
    }, H = (M) => {
      ee(M.target.value), Fe(d) && d(M.target.value, C);
    }, G = (M) => {
      yo(g, ["value", M.value]) ? u(
        et(
          g,
          (L) => M.value !== L.value
        )
      ) : u([...g, M]), ie();
    }, _e = (M) => {
      r || (u(
        et(g, (L) => L.value !== M.value)
      ), ie());
    }, E = He(() => !m || !F || !F.trim() ? y : et(
      y,
      (M) => Be(M.label.toLowerCase(), F.toLowerCase())
    ), [F, y]);
    return /* @__PURE__ */ s.jsx(Ct, { label: a, isRequired: i, children: /* @__PURE__ */ s.jsxs(
      nt,
      {
        disabled: r,
        error: t,
        sx: { width: v || "100%" },
        ref: B,
        children: [
          /* @__PURE__ */ s.jsx(
            Ff,
            A({
              displayEmpty: !0,
              ref: (M) => (j.current = M, x),
              open: !1,
              multiple: !0,
              onClick: Q,
              value: g,
              renderValue: (M) => ye(M) ? /* @__PURE__ */ s.jsx(Bf, { children: b || "" }) : /* @__PURE__ */ s.jsx(De, { sx: { display: "flex", flexWrap: "wrap", gap: 0.5 }, children: Ve(M, (L) => /* @__PURE__ */ s.jsx(
                Qt,
                {
                  label: L.label,
                  onDelete: () => _e(L),
                  sx: Wf()
                },
                L.value
              )) })
            }, w)
          ),
          /* @__PURE__ */ s.jsx(
            pn,
            {
              onClickAway: (M) => {
                j.current && j.current.contains(M.target) || ie();
              },
              children: /* @__PURE__ */ s.jsx(
                mn,
                {
                  open: Y,
                  anchorEl: j.current,
                  placement: "bottom-start",
                  sx: {
                    zIndex: T ? at.POPUP_WINDOW : at.FORM_LAYOUT
                  },
                  modifiers: [{ name: "preventOverflow", enabled: !1 }],
                  children: /* @__PURE__ */ s.jsxs(
                    Lf,
                    {
                      width: Sn(B.current) ? "auto" : B.current.clientWidth,
                      children: [
                        _ && /* @__PURE__ */ s.jsxs($r, { children: [
                          /* @__PURE__ */ s.jsx(
                            lr,
                            {
                              fullWidth: !0,
                              autoComplete: "off",
                              value: F,
                              onChange: H,
                              InputProps: {
                                sx: {
                                  margin: "4px",
                                  height: "40px",
                                  width: "calc(100% - 8px)"
                                }
                              }
                            }
                          ),
                          /* @__PURE__ */ s.jsx(dr, {})
                        ] }),
                        /* @__PURE__ */ s.jsx(
                          De,
                          {
                            sx: {
                              maxHeight: c || "200px",
                              overflowY: "auto",
                              borderRadius: "2px",
                              padding: "8px 0px 8px 0px"
                            },
                            onScroll: h,
                            children: ye(E) ? /* @__PURE__ */ s.jsx(De, { sx: { padding: "8px" }, children: /* @__PURE__ */ s.jsx(
                              Qn,
                              {
                                disabled: !0,
                                sx: { padding: "0px 16px 0px 16px" },
                                children: Co
                              }
                            ) }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
                              Ve(E, (M) => /* @__PURE__ */ s.jsx(
                                Qn,
                                {
                                  value: M.value,
                                  onClick: () => G(M),
                                  selected: yo(g, ["value", M.value]),
                                  children: M.label
                                },
                                M.value
                              )),
                              o && /* @__PURE__ */ s.jsx(Qn, { disabled: !0, children: jo })
                            ] })
                          }
                        )
                      ]
                    }
                  )
                }
              )
            }
          ),
          n && /* @__PURE__ */ s.jsx(ot, { sx: { marginLeft: 0 }, children: n })
        ]
      }
    ) });
  }
);
Oa.displayName = "SPMultiSelectWithFilter";
const Yf = ze(
  function(u, c) {
    var l = u, {
      initialOptions: r,
      fetchData: t,
      beforeFetchDataOnInputChanged: n,
      onChange: o,
      value: i
    } = l, a = Se(l, [
      "initialOptions",
      "fetchData",
      "beforeFetchDataOnInputChanged",
      "onChange",
      "value"
    ]);
    const { data: f, loading: d, pageNum: h, getData: y, initialize: b } = Bt(t), m = tt(""), g = He(() => {
      if (!r)
        return f;
      const x = [...et(
        r,
        (S) => Be(S.label, m.current)
      ), ...f];
      return Array.from(
        new Map(x.map((S) => [S.value, S])).values()
      );
    }, [f, r]), v = He(
      () => Tn((w, x) => {
        if (Fe(x) && !x())
          return;
        const S = n(w);
        y(S, !0).catch((P) => {
          throw P;
        });
      }, 500),
      [n, y]
    ), _ = () => {
      h === 1 && y().catch((w) => {
        throw w;
      });
    }, T = (w) => {
      if (d)
        return;
      const { scrollHeight: x, scrollTop: S, clientHeight: P } = w.target;
      Math.abs(x - S) < P + 1 && y().catch((F) => {
        throw F;
      });
    };
    return /* @__PURE__ */ s.jsx(
      Oa,
      ve(A({}, a), {
        shouldFilterOptions: !1,
        value: i,
        onChange: o,
        onOpen: _,
        onResetOptions: b,
        isLoading: d,
        onInputChange: v,
        onScroll: T,
        options: g,
        ref: c
      })
    );
  }
);
Yf.displayName = "SPAsyncMultiSelectWithFilter";
function rv(f) {
  var d = f, {
    error: e,
    disabled: r,
    helperText: t,
    label: n,
    options: o,
    isRequired: i,
    row: a = !0,
    value: c,
    onChange: u
  } = d, l = Se(d, [
    "error",
    "disabled",
    "helperText",
    "label",
    "options",
    "isRequired",
    "row",
    "value",
    "onChange"
  ]);
  return /* @__PURE__ */ s.jsx(Ct, { label: n, isRequired: i, children: /* @__PURE__ */ s.jsxs(
    nt,
    {
      error: e,
      disabled: r,
      sx: { width: "100%", backgroundColor: "inherit" },
      children: [
        /* @__PURE__ */ s.jsx(ru, ve(A({ row: a, value: c, onChange: u }, l), { children: Ve(o, (h) => /* @__PURE__ */ s.jsx(
          Us,
          {
            value: h.value,
            control: /* @__PURE__ */ s.jsx(nu, { disableRipple: !0 }),
            label: h.label,
            sx: { marginLeft: 0 }
          },
          h.value
        )) })),
        /* @__PURE__ */ s.jsx(ot, { children: t })
      ]
    }
  ) });
}
function nv({
  error: e,
  disabled: r,
  helperText: t,
  isRequired: n,
  label: o,
  options: i,
  row: a,
  values: c,
  onChange: u
}) {
  const [l, f] = xe(c || []), d = (h) => {
    const y = h.target.value;
    f((b) => {
      const m = Be(b, y) ? et(b, (g) => g !== y) : [...b, y];
      return Fe(u) && u(m), m;
    });
  };
  return /* @__PURE__ */ s.jsx(Ct, { label: o, isRequired: n, children: /* @__PURE__ */ s.jsxs(
    nt,
    {
      error: e,
      disabled: r,
      sx: { width: "100%", backgroundColor: "inherit" },
      children: [
        /* @__PURE__ */ s.jsx(ou, { row: a, children: Ve(i, (h) => /* @__PURE__ */ s.jsx(
          Us,
          {
            control: /* @__PURE__ */ s.jsx(
              an,
              {
                disableRipple: !0,
                size: "small",
                checked: Be(l, h.value),
                value: h.value,
                onChange: d,
                sx: { marginleft: 0 }
              }
            ),
            label: h.label,
            sx: { marginLeft: 0 }
          },
          h.value
        )) }),
        /* @__PURE__ */ s.jsx(ot, { children: t })
      ]
    }
  ) });
}
const Hf = Z(lr)(
  ({ theme: e, multiline: r }) => ({
    backgroundColor: "#fff",
    ".MuiInputBase-input": {
      boxSizing: "border-box",
      height: r ? "auto" : 40,
      paddingTop: 0,
      paddingBottom: 0
    },
    "&& .MuiInputBase-root": {
      padding: r ? "4px 14px" : 0,
      borderRadius: "2px"
    },
    "&& .Mui-error": { backgroundColor: "#FFD2C2" },
    "&& .Mui-disabled": { backgroundColor: "#eee" },
    "&& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #7C7C7C"
    }
  })
);
function ov(f) {
  var d = f, {
    error: e,
    disabled: r,
    helperText: t,
    label: n,
    isRequired: o,
    maxLength: i,
    multiline: a,
    rows: c,
    width: u
  } = d, l = Se(d, [
    "error",
    "disabled",
    "helperText",
    "label",
    "isRequired",
    "maxLength",
    "multiline",
    "rows",
    "width"
  ]);
  return /* @__PURE__ */ s.jsx(Ct, { label: n, isRequired: o, children: /* @__PURE__ */ s.jsxs(
    nt,
    {
      error: e,
      disabled: r,
      sx: { width: u || "100%" },
      children: [
        /* @__PURE__ */ s.jsx(
          Hf,
          A({
            error: e,
            multiline: a,
            disabled: r,
            rows: c || 3,
            inputProps: {
              maxLength: i || 255
            }
          }, l)
        ),
        t && /* @__PURE__ */ s.jsx(ot, { sx: { marginLeft: 0 }, children: t })
      ]
    }
  ) });
}
const zf = {
  MuiButton: {
    defaultProps: {
      disableElevation: !0,
      disableFocusRipple: !0,
      variant: "outlined"
    },
    styleOverrides: {
      root: ({ ownerState: e, theme: r }) => {
        const { color: t, variant: n } = e;
        let o = "inherit";
        return t === void 0 && (r.palette.default.main, o = r.palette.default.main), t !== void 0 && t !== "inherit" && (r.palette[t].main, o = r.palette[t].main), A(A({
          // Button共通
          height: "40px",
          borderRadius: "6px",
          padding: "0px 4px",
          width: "100%",
          border: "2px solid",
          color: o,
          backgroundColor: r.palette.common.white,
          lineHeight: "18px",
          "&:focus": {
            border: "2px solid"
          },
          "&:hover": {
            border: "2px solid",
            backgroundColor: r.palette.common.white
          }
        }, n === "text" && {
          fontSize: "0.875rem",
          fontWeight: 400,
          border: "2px solid transparent !important"
        }), n === "contained" && {
          backgroundColor: o,
          color: r.palette.common.white,
          border: "none",
          "&:hover": {
            border: "none",
            backgroundColor: o
          },
          "&:focus": {
            border: "none"
          }
        });
      },
      sizeSmall: {
        fontSize: 14
      }
    }
  }
}, qf = {
  MuiDialog: {
    defaultProps: {
      fullWidth: !0,
      PaperProps: {
        elevation: 0
      }
    },
    styleOverrides: {
      paper: {
        borderRadius: "5px"
      }
    }
  },
  MuiDialogTitle: {
    defaultProps: {},
    styleOverrides: {
      root: {
        display: "inline-block",
        verticalAlign: "middle",
        padding: "12px 8px 12px 12px",
        fontSize: 18,
        fontWeight: "bold",
        lineHeight: "20px"
      }
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: "12px !important",
        whiteSpace: "pre-line"
      }
    }
  },
  MuiDialogContentText: {
    styleOverrides: {
      root: {
        color: "inherit"
      }
    }
  }
}, Uf = {
  components: A(A({}, zf), qf)
}, Vf = Vs(A({
  palette: {
    primary: {
      main: "#2681FF",
      light: void 0,
      dark: void 0
    },
    normal: {
      main: "#7C7C7C",
      light: void 0,
      dark: void 0
    },
    commit: {
      main: "#12B36A",
      light: void 0,
      dark: void 0
    },
    negative: {
      main: "#E64E17",
      light: void 0,
      dark: void 0
    },
    error: {
      main: "#E64E17",
      light: "#FFEDEB",
      dark: void 0,
      contrastText: "#FFF"
    },
    warning: {
      main: "#C83727",
      light: "#FFEDEB",
      dark: void 0
    },
    text: {
      primary: "#1A1A1A",
      secondary: "#444444",
      disabled: "#999999"
    },
    border: {
      main: "rgba(0,0,0,0.23)",
      light: void 0,
      dark: void 0
    },
    divider: "#DBDBDB",
    action: {
      touch: "#e2f3ff",
      selected: "#ddd",
      selectedOpacity: 0.1,
      disabled: "#C7C7C7",
      disabledBackground: "#F1F1F1",
      disabledOpacity: void 0
    },
    background: {
      disabled: "#E3E3E3",
      error: "#FFE0E0",
      header: "#3170C1",
      screen: "#FFFFFF",
      loading: "rgba(0,0,0,0.25)"
    }
  },
  typography: {
    fontFamily: "Hiragino Kaku Gothic ProN",
    h1: {
      fontSize: "1.5rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    h2: {
      fontSize: "1.25rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    h3: {
      fontSize: "1.125rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    h4: {
      fontSize: "1rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    headerTitle: {
      fontSize: "1rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    sideMenuLg: {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: 1.5
    },
    sideMenuMd: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: 1.5
    },
    sideMenuSm: {
      fontSize: "0.75rem",
      fontWeight: 400,
      lineHeight: 1.5
    },
    bodyXxl: {
      fontSize: "1.5rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    bodyXl: {
      fontSize: "1.25rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    bodyLg: {
      fontSize: "1.125rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    bodyMd: {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: 1.5
    },
    body1: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: 1.5
    },
    body2: {
      fontSize: "0.75rem",
      fontWeight: 400,
      lineHeight: 1.5
    },
    bodyXs: {
      fontSize: "0.625rem",
      fontWeight: 400,
      lineHeight: 1.5
    },
    label: {
      fontSize: "0.75rem",
      fontWeight: 400,
      lineHeight: 1.5
    },
    labelMd: {
      fontSize: "0.75rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    labelSm: {
      fontSize: "0.625rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    button: {
      fontSize: "1rem",
      fontWeight: 700,
      lineHeight: 1.5,
      textTransform: "none"
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 880,
      lg: 1200,
      xl: 1536
    }
  }
}, Uf)), En = ({ children: e }) => /* @__PURE__ */ s.jsx(Gs, { theme: Vf, children: e });
function Qi(i) {
  var a = i, {
    sx: e,
    disabled: r,
    onClick: t,
    onDisabledClick: n
  } = a, o = Se(a, [
    "sx",
    "disabled",
    "onClick",
    "onDisabledClick"
  ]);
  const c = (u) => {
    gu.isFunction(n) && n(u);
  };
  return /* @__PURE__ */ s.jsx(En, { children: /* @__PURE__ */ s.jsx(
    Xs,
    ve(A({}, o), {
      onClick: r ? c : t,
      disableRipple: r,
      sx: A(A({}, e || {}), r ? {
        backgroundColor: "#eee",
        color: "#C7C7C7",
        border: "none",
        "&:hover": {
          backgroundColor: "#eee",
          border: "none"
        }
      } : {})
    })
  ) });
}
function Pr(e) {
  let r = "https://mui.com/production-error/?code=" + e;
  for (let t = 1; t < arguments.length; t += 1)
    r += "&args[]=" + encodeURIComponent(arguments[t]);
  return "Minified MUI error #" + e + "; visit " + r + " for the full message.";
}
const Gf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pr
}, Symbol.toStringTag, { value: "Module" })), Pa = "$$material";
function ge() {
  return ge = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, ge.apply(this, arguments);
}
function jt(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), o, i;
  for (i = 0; i < n.length; i++)
    o = n[i], !(r.indexOf(o) >= 0) && (t[o] = e[o]);
  return t;
}
var bo = { exports: {} }, Gr = { exports: {} }, de = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ji;
function Xf() {
  if (Ji)
    return de;
  Ji = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
  function T(x) {
    if (typeof x == "object" && x !== null) {
      var S = x.$$typeof;
      switch (S) {
        case r:
          switch (x = x.type, x) {
            case u:
            case l:
            case n:
            case i:
            case o:
            case d:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case c:
                case f:
                case b:
                case y:
                case a:
                  return x;
                default:
                  return S;
              }
          }
        case t:
          return S;
      }
    }
  }
  function w(x) {
    return T(x) === l;
  }
  return de.AsyncMode = u, de.ConcurrentMode = l, de.ContextConsumer = c, de.ContextProvider = a, de.Element = r, de.ForwardRef = f, de.Fragment = n, de.Lazy = b, de.Memo = y, de.Portal = t, de.Profiler = i, de.StrictMode = o, de.Suspense = d, de.isAsyncMode = function(x) {
    return w(x) || T(x) === u;
  }, de.isConcurrentMode = w, de.isContextConsumer = function(x) {
    return T(x) === c;
  }, de.isContextProvider = function(x) {
    return T(x) === a;
  }, de.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === r;
  }, de.isForwardRef = function(x) {
    return T(x) === f;
  }, de.isFragment = function(x) {
    return T(x) === n;
  }, de.isLazy = function(x) {
    return T(x) === b;
  }, de.isMemo = function(x) {
    return T(x) === y;
  }, de.isPortal = function(x) {
    return T(x) === t;
  }, de.isProfiler = function(x) {
    return T(x) === i;
  }, de.isStrictMode = function(x) {
    return T(x) === o;
  }, de.isSuspense = function(x) {
    return T(x) === d;
  }, de.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === n || x === l || x === i || x === o || x === d || x === h || typeof x == "object" && x !== null && (x.$$typeof === b || x.$$typeof === y || x.$$typeof === a || x.$$typeof === c || x.$$typeof === f || x.$$typeof === g || x.$$typeof === v || x.$$typeof === _ || x.$$typeof === m);
  }, de.typeOf = T, de;
}
var fe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zi;
function Kf() {
  return Zi || (Zi = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
    function T(R) {
      return typeof R == "string" || typeof R == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      R === n || R === l || R === i || R === o || R === d || R === h || typeof R == "object" && R !== null && (R.$$typeof === b || R.$$typeof === y || R.$$typeof === a || R.$$typeof === c || R.$$typeof === f || R.$$typeof === g || R.$$typeof === v || R.$$typeof === _ || R.$$typeof === m);
    }
    function w(R) {
      if (typeof R == "object" && R !== null) {
        var Ue = R.$$typeof;
        switch (Ue) {
          case r:
            var W = R.type;
            switch (W) {
              case u:
              case l:
              case n:
              case i:
              case o:
              case d:
                return W;
              default:
                var st = W && W.$$typeof;
                switch (st) {
                  case c:
                  case f:
                  case b:
                  case y:
                  case a:
                    return st;
                  default:
                    return Ue;
                }
            }
          case t:
            return Ue;
        }
      }
    }
    var x = u, S = l, P = c, F = a, ee = r, Y = f, k = n, C = b, B = y, j = t, Q = i, ie = o, H = d, G = !1;
    function _e(R) {
      return G || (G = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), E(R) || w(R) === u;
    }
    function E(R) {
      return w(R) === l;
    }
    function M(R) {
      return w(R) === c;
    }
    function L(R) {
      return w(R) === a;
    }
    function I(R) {
      return typeof R == "object" && R !== null && R.$$typeof === r;
    }
    function z(R) {
      return w(R) === f;
    }
    function te(R) {
      return w(R) === n;
    }
    function U(R) {
      return w(R) === b;
    }
    function V(R) {
      return w(R) === y;
    }
    function X(R) {
      return w(R) === t;
    }
    function oe(R) {
      return w(R) === i;
    }
    function K(R) {
      return w(R) === o;
    }
    function Ae(R) {
      return w(R) === d;
    }
    fe.AsyncMode = x, fe.ConcurrentMode = S, fe.ContextConsumer = P, fe.ContextProvider = F, fe.Element = ee, fe.ForwardRef = Y, fe.Fragment = k, fe.Lazy = C, fe.Memo = B, fe.Portal = j, fe.Profiler = Q, fe.StrictMode = ie, fe.Suspense = H, fe.isAsyncMode = _e, fe.isConcurrentMode = E, fe.isContextConsumer = M, fe.isContextProvider = L, fe.isElement = I, fe.isForwardRef = z, fe.isFragment = te, fe.isLazy = U, fe.isMemo = V, fe.isPortal = X, fe.isProfiler = oe, fe.isStrictMode = K, fe.isSuspense = Ae, fe.isValidElementType = T, fe.typeOf = w;
  }()), fe;
}
var es;
function ka() {
  return es || (es = 1, process.env.NODE_ENV === "production" ? Gr.exports = Xf() : Gr.exports = Kf()), Gr.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Jn, ts;
function Qf() {
  if (ts)
    return Jn;
  ts = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, c = 0; c < 10; c++)
        a["_" + String.fromCharCode(c)] = c;
      var u = Object.getOwnPropertyNames(a).map(function(f) {
        return a[f];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        l[f] = f;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch (f) {
      return !1;
    }
  }
  return Jn = o() ? Object.assign : function(i, a) {
    for (var c, u = n(i), l, f = 1; f < arguments.length; f++) {
      c = Object(arguments[f]);
      for (var d in c)
        r.call(c, d) && (u[d] = c[d]);
      if (e) {
        l = e(c);
        for (var h = 0; h < l.length; h++)
          t.call(c, l[h]) && (u[l[h]] = c[l[h]]);
      }
    }
    return u;
  }, Jn;
}
var Zn, rs;
function Yo() {
  if (rs)
    return Zn;
  rs = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Zn = e, Zn;
}
var eo, ns;
function Ca() {
  return ns || (ns = 1, eo = Function.call.bind(Object.prototype.hasOwnProperty)), eo;
}
var to, os;
function Jf() {
  if (os)
    return to;
  os = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = Yo(), t = {}, n = Ca();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console != "undefined" && console.error(a);
      try {
        throw new Error(a);
      } catch (c) {
      }
    };
  }
  function o(i, a, c, u, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in i)
        if (n(i, f)) {
          var d;
          try {
            if (typeof i[f] != "function") {
              var h = Error(
                (u || "React class") + ": " + c + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            d = i[f](a, f, u, c, null, r);
          } catch (b) {
            d = b;
          }
          if (d && !(d instanceof Error) && e(
            (u || "React class") + ": type specification of " + c + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in t)) {
            t[d.message] = !0;
            var y = l ? l() : "";
            e(
              "Failed " + c + " type: " + d.message + (y != null ? y : "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, to = o, to;
}
var ro, is;
function Zf() {
  if (is)
    return ro;
  is = 1;
  var e = ka(), r = Qf(), t = Yo(), n = Ca(), o = Jf(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(c) {
    var u = "Warning: " + c;
    typeof console != "undefined" && console.error(u);
    try {
      throw new Error(u);
    } catch (l) {
    }
  });
  function a() {
    return null;
  }
  return ro = function(c, u) {
    var l = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function d(E) {
      var M = E && (l && E[l] || E[f]);
      if (typeof M == "function")
        return M;
    }
    var h = "<<anonymous>>", y = {
      array: v("array"),
      bigint: v("bigint"),
      bool: v("boolean"),
      func: v("function"),
      number: v("number"),
      object: v("object"),
      string: v("string"),
      symbol: v("symbol"),
      any: _(),
      arrayOf: T,
      element: w(),
      elementType: x(),
      instanceOf: S,
      node: Y(),
      objectOf: F,
      oneOf: P,
      oneOfType: ee,
      shape: C,
      exact: B
    };
    function b(E, M) {
      return E === M ? E !== 0 || 1 / E === 1 / M : E !== E && M !== M;
    }
    function m(E, M) {
      this.message = E, this.data = M && typeof M == "object" ? M : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function g(E) {
      if (process.env.NODE_ENV !== "production")
        var M = {}, L = 0;
      function I(te, U, V, X, oe, K, Ae) {
        if (X = X || h, K = K || V, Ae !== t) {
          if (u) {
            var R = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw R.name = "Invariant Violation", R;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var Ue = X + ":" + V;
            !M[Ue] && // Avoid spamming the console because they are often not actionable except for lib authors
            L < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + K + "` prop on `" + X + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), M[Ue] = !0, L++);
          }
        }
        return U[V] == null ? te ? U[V] === null ? new m("The " + oe + " `" + K + "` is marked as required " + ("in `" + X + "`, but its value is `null`.")) : new m("The " + oe + " `" + K + "` is marked as required in " + ("`" + X + "`, but its value is `undefined`.")) : null : E(U, V, X, oe, K);
      }
      var z = I.bind(null, !1);
      return z.isRequired = I.bind(null, !0), z;
    }
    function v(E) {
      function M(L, I, z, te, U, V) {
        var X = L[I], oe = ie(X);
        if (oe !== E) {
          var K = H(X);
          return new m(
            "Invalid " + te + " `" + U + "` of type " + ("`" + K + "` supplied to `" + z + "`, expected ") + ("`" + E + "`."),
            { expectedType: E }
          );
        }
        return null;
      }
      return g(M);
    }
    function _() {
      return g(a);
    }
    function T(E) {
      function M(L, I, z, te, U) {
        if (typeof E != "function")
          return new m("Property `" + U + "` of component `" + z + "` has invalid PropType notation inside arrayOf.");
        var V = L[I];
        if (!Array.isArray(V)) {
          var X = ie(V);
          return new m("Invalid " + te + " `" + U + "` of type " + ("`" + X + "` supplied to `" + z + "`, expected an array."));
        }
        for (var oe = 0; oe < V.length; oe++) {
          var K = E(V, oe, z, te, U + "[" + oe + "]", t);
          if (K instanceof Error)
            return K;
        }
        return null;
      }
      return g(M);
    }
    function w() {
      function E(M, L, I, z, te) {
        var U = M[L];
        if (!c(U)) {
          var V = ie(U);
          return new m("Invalid " + z + " `" + te + "` of type " + ("`" + V + "` supplied to `" + I + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(E);
    }
    function x() {
      function E(M, L, I, z, te) {
        var U = M[L];
        if (!e.isValidElementType(U)) {
          var V = ie(U);
          return new m("Invalid " + z + " `" + te + "` of type " + ("`" + V + "` supplied to `" + I + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(E);
    }
    function S(E) {
      function M(L, I, z, te, U) {
        if (!(L[I] instanceof E)) {
          var V = E.name || h, X = _e(L[I]);
          return new m("Invalid " + te + " `" + U + "` of type " + ("`" + X + "` supplied to `" + z + "`, expected ") + ("instance of `" + V + "`."));
        }
        return null;
      }
      return g(M);
    }
    function P(E) {
      if (!Array.isArray(E))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function M(L, I, z, te, U) {
        for (var V = L[I], X = 0; X < E.length; X++)
          if (b(V, E[X]))
            return null;
        var oe = JSON.stringify(E, function(Ae, R) {
          var Ue = H(R);
          return Ue === "symbol" ? String(R) : R;
        });
        return new m("Invalid " + te + " `" + U + "` of value `" + String(V) + "` " + ("supplied to `" + z + "`, expected one of " + oe + "."));
      }
      return g(M);
    }
    function F(E) {
      function M(L, I, z, te, U) {
        if (typeof E != "function")
          return new m("Property `" + U + "` of component `" + z + "` has invalid PropType notation inside objectOf.");
        var V = L[I], X = ie(V);
        if (X !== "object")
          return new m("Invalid " + te + " `" + U + "` of type " + ("`" + X + "` supplied to `" + z + "`, expected an object."));
        for (var oe in V)
          if (n(V, oe)) {
            var K = E(V, oe, z, te, U + "." + oe, t);
            if (K instanceof Error)
              return K;
          }
        return null;
      }
      return g(M);
    }
    function ee(E) {
      if (!Array.isArray(E))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var M = 0; M < E.length; M++) {
        var L = E[M];
        if (typeof L != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + G(L) + " at index " + M + "."
          ), a;
      }
      function I(z, te, U, V, X) {
        for (var oe = [], K = 0; K < E.length; K++) {
          var Ae = E[K], R = Ae(z, te, U, V, X, t);
          if (R == null)
            return null;
          R.data && n(R.data, "expectedType") && oe.push(R.data.expectedType);
        }
        var Ue = oe.length > 0 ? ", expected one of type [" + oe.join(", ") + "]" : "";
        return new m("Invalid " + V + " `" + X + "` supplied to " + ("`" + U + "`" + Ue + "."));
      }
      return g(I);
    }
    function Y() {
      function E(M, L, I, z, te) {
        return j(M[L]) ? null : new m("Invalid " + z + " `" + te + "` supplied to " + ("`" + I + "`, expected a ReactNode."));
      }
      return g(E);
    }
    function k(E, M, L, I, z) {
      return new m(
        (E || "React class") + ": " + M + " type `" + L + "." + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + z + "`."
      );
    }
    function C(E) {
      function M(L, I, z, te, U) {
        var V = L[I], X = ie(V);
        if (X !== "object")
          return new m("Invalid " + te + " `" + U + "` of type `" + X + "` " + ("supplied to `" + z + "`, expected `object`."));
        for (var oe in E) {
          var K = E[oe];
          if (typeof K != "function")
            return k(z, te, U, oe, H(K));
          var Ae = K(V, oe, z, te, U + "." + oe, t);
          if (Ae)
            return Ae;
        }
        return null;
      }
      return g(M);
    }
    function B(E) {
      function M(L, I, z, te, U) {
        var V = L[I], X = ie(V);
        if (X !== "object")
          return new m("Invalid " + te + " `" + U + "` of type `" + X + "` " + ("supplied to `" + z + "`, expected `object`."));
        var oe = r({}, L[I], E);
        for (var K in oe) {
          var Ae = E[K];
          if (n(E, K) && typeof Ae != "function")
            return k(z, te, U, K, H(Ae));
          if (!Ae)
            return new m(
              "Invalid " + te + " `" + U + "` key `" + K + "` supplied to `" + z + "`.\nBad object: " + JSON.stringify(L[I], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(E), null, "  ")
            );
          var R = Ae(V, K, z, te, U + "." + K, t);
          if (R)
            return R;
        }
        return null;
      }
      return g(M);
    }
    function j(E) {
      switch (typeof E) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !E;
        case "object":
          if (Array.isArray(E))
            return E.every(j);
          if (E === null || c(E))
            return !0;
          var M = d(E);
          if (M) {
            var L = M.call(E), I;
            if (M !== E.entries) {
              for (; !(I = L.next()).done; )
                if (!j(I.value))
                  return !1;
            } else
              for (; !(I = L.next()).done; ) {
                var z = I.value;
                if (z && !j(z[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Q(E, M) {
      return E === "symbol" ? !0 : M ? M["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && M instanceof Symbol : !1;
    }
    function ie(E) {
      var M = typeof E;
      return Array.isArray(E) ? "array" : E instanceof RegExp ? "object" : Q(M, E) ? "symbol" : M;
    }
    function H(E) {
      if (typeof E == "undefined" || E === null)
        return "" + E;
      var M = ie(E);
      if (M === "object") {
        if (E instanceof Date)
          return "date";
        if (E instanceof RegExp)
          return "regexp";
      }
      return M;
    }
    function G(E) {
      var M = H(E);
      switch (M) {
        case "array":
        case "object":
          return "an " + M;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + M;
        default:
          return M;
      }
    }
    function _e(E) {
      return !E.constructor || !E.constructor.name ? h : E.constructor.name;
    }
    return y.checkPropTypes = o, y.resetWarningCache = o.resetWarningCache, y.PropTypes = y, y;
  }, ro;
}
var no, ss;
function eh() {
  if (ss)
    return no;
  ss = 1;
  var e = Yo();
  function r() {
  }
  function t() {
  }
  return t.resetWarningCache = r, no = function() {
    function n(a, c, u, l, f, d) {
      if (d !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: t,
      resetWarningCache: r
    };
    return i.PropTypes = i, i;
  }, no;
}
if (process.env.NODE_ENV !== "production") {
  var th = ka(), rh = !0;
  bo.exports = Zf()(th.isElement, rh);
} else
  bo.exports = eh()();
var nh = bo.exports;
const ne = /* @__PURE__ */ yu(nh);
function oh(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function ih(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var sh = /* @__PURE__ */ function() {
  function e(t) {
    var n = this;
    this._insertTag = function(o) {
      var i;
      n.tags.length === 0 ? n.insertionPoint ? i = n.insertionPoint.nextSibling : n.prepend ? i = n.container.firstChild : i = n.before : i = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(o, i), n.tags.push(o);
    }, this.isSpeedy = t.speedy === void 0 ? process.env.NODE_ENV === "production" : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, r.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(ih(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = n.charCodeAt(0) === 64 && n.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + n + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var a = oh(o);
      try {
        a.insertRule(n, a.cssRules.length);
      } catch (c) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(n) && console.error('There was a problem inserting the following rule: "' + n + '"', c);
      }
    } else
      o.appendChild(document.createTextNode(n));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), Ye = "-ms-", cn = "-moz-", ce = "-webkit-", Ho = "comm", zo = "rule", qo = "decl", ah = "@import", ja = "@keyframes", ch = "@layer", uh = Math.abs, Mn = String.fromCharCode, lh = Object.assign;
function dh(e, r) {
  return We(e, 0) ^ 45 ? (((r << 2 ^ We(e, 0)) << 2 ^ We(e, 1)) << 2 ^ We(e, 2)) << 2 ^ We(e, 3) : 0;
}
function Da(e) {
  return e.trim();
}
function fh(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function ue(e, r, t) {
  return e.replace(r, t);
}
function xo(e, r) {
  return e.indexOf(r);
}
function We(e, r) {
  return e.charCodeAt(r) | 0;
}
function kr(e, r, t) {
  return e.slice(r, t);
}
function lt(e) {
  return e.length;
}
function Uo(e) {
  return e.length;
}
function Xr(e, r) {
  return r.push(e), e;
}
function hh(e, r) {
  return e.map(r).join("");
}
var On = 1, ar = 1, Ra = 0, Ge = 0, Ie = 0, fr = "";
function Pn(e, r, t, n, o, i, a) {
  return { value: e, root: r, parent: t, type: n, props: o, children: i, line: On, column: ar, length: a, return: "" };
}
function vr(e, r) {
  return lh(Pn("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function ph() {
  return Ie;
}
function mh() {
  return Ie = Ge > 0 ? We(fr, --Ge) : 0, ar--, Ie === 10 && (ar = 1, On--), Ie;
}
function Ke() {
  return Ie = Ge < Ra ? We(fr, Ge++) : 0, ar++, Ie === 10 && (ar = 1, On++), Ie;
}
function mt() {
  return We(fr, Ge);
}
function Jr() {
  return Ge;
}
function Ir(e, r) {
  return kr(fr, e, r);
}
function Cr(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function $a(e) {
  return On = ar = 1, Ra = lt(fr = e), Ge = 0, [];
}
function Na(e) {
  return fr = "", e;
}
function Zr(e) {
  return Da(Ir(Ge - 1, vo(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function gh(e) {
  for (; (Ie = mt()) && Ie < 33; )
    Ke();
  return Cr(e) > 2 || Cr(Ie) > 3 ? "" : " ";
}
function yh(e, r) {
  for (; --r && Ke() && !(Ie < 48 || Ie > 102 || Ie > 57 && Ie < 65 || Ie > 70 && Ie < 97); )
    ;
  return Ir(e, Jr() + (r < 6 && mt() == 32 && Ke() == 32));
}
function vo(e) {
  for (; Ke(); )
    switch (Ie) {
      case e:
        return Ge;
      case 34:
      case 39:
        e !== 34 && e !== 39 && vo(Ie);
        break;
      case 40:
        e === 41 && vo(e);
        break;
      case 92:
        Ke();
        break;
    }
  return Ge;
}
function bh(e, r) {
  for (; Ke() && e + Ie !== 47 + 10; )
    if (e + Ie === 42 + 42 && mt() === 47)
      break;
  return "/*" + Ir(r, Ge - 1) + "*" + Mn(e === 47 ? e : Ke());
}
function xh(e) {
  for (; !Cr(mt()); )
    Ke();
  return Ir(e, Ge);
}
function vh(e) {
  return Na(en("", null, null, null, [""], e = $a(e), 0, [0], e));
}
function en(e, r, t, n, o, i, a, c, u) {
  for (var l = 0, f = 0, d = a, h = 0, y = 0, b = 0, m = 1, g = 1, v = 1, _ = 0, T = "", w = o, x = i, S = n, P = T; g; )
    switch (b = _, _ = Ke()) {
      case 40:
        if (b != 108 && We(P, d - 1) == 58) {
          xo(P += ue(Zr(_), "&", "&\f"), "&\f") != -1 && (v = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        P += Zr(_);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        P += gh(b);
        break;
      case 92:
        P += yh(Jr() - 1, 7);
        continue;
      case 47:
        switch (mt()) {
          case 42:
          case 47:
            Xr(_h(bh(Ke(), Jr()), r, t), u);
            break;
          default:
            P += "/";
        }
        break;
      case 123 * m:
        c[l++] = lt(P) * v;
      case 125 * m:
      case 59:
      case 0:
        switch (_) {
          case 0:
          case 125:
            g = 0;
          case 59 + f:
            v == -1 && (P = ue(P, /\f/g, "")), y > 0 && lt(P) - d && Xr(y > 32 ? cs(P + ";", n, t, d - 1) : cs(ue(P, " ", "") + ";", n, t, d - 2), u);
            break;
          case 59:
            P += ";";
          default:
            if (Xr(S = as(P, r, t, l, f, o, c, T, w = [], x = [], d), i), _ === 123)
              if (f === 0)
                en(P, r, S, S, w, i, d, c, x);
              else
                switch (h === 99 && We(P, 3) === 110 ? 100 : h) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    en(e, S, S, n && Xr(as(e, S, S, 0, 0, o, c, T, o, w = [], d), x), o, x, d, c, n ? w : x);
                    break;
                  default:
                    en(P, S, S, S, [""], x, 0, c, x);
                }
        }
        l = f = y = 0, m = v = 1, T = P = "", d = a;
        break;
      case 58:
        d = 1 + lt(P), y = b;
      default:
        if (m < 1) {
          if (_ == 123)
            --m;
          else if (_ == 125 && m++ == 0 && mh() == 125)
            continue;
        }
        switch (P += Mn(_), _ * m) {
          case 38:
            v = f > 0 ? 1 : (P += "\f", -1);
            break;
          case 44:
            c[l++] = (lt(P) - 1) * v, v = 1;
            break;
          case 64:
            mt() === 45 && (P += Zr(Ke())), h = mt(), f = d = lt(T = P += xh(Jr())), _++;
            break;
          case 45:
            b === 45 && lt(P) == 2 && (m = 0);
        }
    }
  return i;
}
function as(e, r, t, n, o, i, a, c, u, l, f) {
  for (var d = o - 1, h = o === 0 ? i : [""], y = Uo(h), b = 0, m = 0, g = 0; b < n; ++b)
    for (var v = 0, _ = kr(e, d + 1, d = uh(m = a[b])), T = e; v < y; ++v)
      (T = Da(m > 0 ? h[v] + " " + _ : ue(_, /&\f/g, h[v]))) && (u[g++] = T);
  return Pn(e, r, t, o === 0 ? zo : c, u, l, f);
}
function _h(e, r, t) {
  return Pn(e, r, t, Ho, Mn(ph()), kr(e, 2, -2), 0);
}
function cs(e, r, t, n) {
  return Pn(e, r, t, qo, kr(e, 0, n), kr(e, n + 1, -1), n);
}
function Zt(e, r) {
  for (var t = "", n = Uo(e), o = 0; o < n; o++)
    t += r(e[o], o, e, r) || "";
  return t;
}
function wh(e, r, t, n) {
  switch (e.type) {
    case ch:
      if (e.children.length)
        break;
    case ah:
    case qo:
      return e.return = e.return || e.value;
    case Ho:
      return "";
    case ja:
      return e.return = e.value + "{" + Zt(e.children, n) + "}";
    case zo:
      e.value = e.props.join(",");
  }
  return lt(t = Zt(e.children, n)) ? e.return = e.value + "{" + t + "}" : "";
}
function Th(e) {
  var r = Uo(e);
  return function(t, n, o, i) {
    for (var a = "", c = 0; c < r; c++)
      a += e[c](t, n, o, i) || "";
    return a;
  };
}
function Sh(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
var Eh = function(r, t, n) {
  for (var o = 0, i = 0; o = i, i = mt(), o === 38 && i === 12 && (t[n] = 1), !Cr(i); )
    Ke();
  return Ir(r, Ge);
}, Mh = function(r, t) {
  var n = -1, o = 44;
  do
    switch (Cr(o)) {
      case 0:
        o === 38 && mt() === 12 && (t[n] = 1), r[n] += Eh(Ge - 1, t, n);
        break;
      case 2:
        r[n] += Zr(o);
        break;
      case 4:
        if (o === 44) {
          r[++n] = mt() === 58 ? "&\f" : "", t[n] = r[n].length;
          break;
        }
      default:
        r[n] += Mn(o);
    }
  while (o = Ke());
  return r;
}, Oh = function(r, t) {
  return Na(Mh($a(r), t));
}, us = /* @__PURE__ */ new WeakMap(), Ph = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, n = r.parent, o = r.column === n.column && r.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !us.get(n)) && !o) {
      us.set(r, !0);
      for (var i = [], a = Oh(t, i), c = n.props, u = 0, l = 0; u < a.length; u++)
        for (var f = 0; f < c.length; f++, l++)
          r.props[l] = i[u] ? a[u].replace(/&\f/g, c[f]) : c[f] + " " + a[u];
    }
  }
}, kh = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, Ch = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", jh = function(r) {
  return r.type === "comm" && r.children.indexOf(Ch) > -1;
}, Dh = function(r) {
  return function(t, n, o) {
    if (!(t.type !== "rule" || r.compat)) {
      var i = t.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var a = !!t.parent, c = a ? t.parent.children : (
          // global rule at the root level
          o
        ), u = c.length - 1; u >= 0; u--) {
          var l = c[u];
          if (l.line < t.line)
            break;
          if (l.column < t.column) {
            if (jh(l))
              return;
            break;
          }
        }
        i.forEach(function(f) {
          console.error('The pseudo class "' + f + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + f.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, Ia = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, Rh = function(r, t) {
  for (var n = r - 1; n >= 0; n--)
    if (!Ia(t[n]))
      return !0;
  return !1;
}, ls = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, $h = function(r, t, n) {
  Ia(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), ls(r)) : Rh(t, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), ls(r)));
};
function Aa(e, r) {
  switch (dh(e, r)) {
    case 5103:
      return ce + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return ce + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return ce + e + cn + e + Ye + e + e;
    case 6828:
    case 4268:
      return ce + e + Ye + e + e;
    case 6165:
      return ce + e + Ye + "flex-" + e + e;
    case 5187:
      return ce + e + ue(e, /(\w+).+(:[^]+)/, ce + "box-$1$2" + Ye + "flex-$1$2") + e;
    case 5443:
      return ce + e + Ye + "flex-item-" + ue(e, /flex-|-self/, "") + e;
    case 4675:
      return ce + e + Ye + "flex-line-pack" + ue(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return ce + e + Ye + ue(e, "shrink", "negative") + e;
    case 5292:
      return ce + e + Ye + ue(e, "basis", "preferred-size") + e;
    case 6060:
      return ce + "box-" + ue(e, "-grow", "") + ce + e + Ye + ue(e, "grow", "positive") + e;
    case 4554:
      return ce + ue(e, /([^-])(transform)/g, "$1" + ce + "$2") + e;
    case 6187:
      return ue(ue(ue(e, /(zoom-|grab)/, ce + "$1"), /(image-set)/, ce + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return ue(e, /(image-set\([^]*)/, ce + "$1$`$1");
    case 4968:
      return ue(ue(e, /(.+:)(flex-)?(.*)/, ce + "box-pack:$3" + Ye + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + ce + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return ue(e, /(.+)-inline(.+)/, ce + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (lt(e) - 1 - r > 6)
        switch (We(e, r + 1)) {
          case 109:
            if (We(e, r + 4) !== 45)
              break;
          case 102:
            return ue(e, /(.+:)(.+)-([^]+)/, "$1" + ce + "$2-$3$1" + cn + (We(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~xo(e, "stretch") ? Aa(ue(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (We(e, r + 1) !== 115)
        break;
    case 6444:
      switch (We(e, lt(e) - 3 - (~xo(e, "!important") && 10))) {
        case 107:
          return ue(e, ":", ":" + ce) + e;
        case 101:
          return ue(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + ce + (We(e, 14) === 45 ? "inline-" : "") + "box$3$1" + ce + "$2$3$1" + Ye + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (We(e, r + 11)) {
        case 114:
          return ce + e + Ye + ue(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return ce + e + Ye + ue(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return ce + e + Ye + ue(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return ce + e + Ye + e + e;
  }
  return e;
}
var Nh = function(r, t, n, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case qo:
        r.return = Aa(r.value, r.length);
        break;
      case ja:
        return Zt([vr(r, {
          value: ue(r.value, "@", "@" + ce)
        })], o);
      case zo:
        if (r.length)
          return hh(r.props, function(i) {
            switch (fh(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Zt([vr(r, {
                  props: [ue(i, /:(read-\w+)/, ":" + cn + "$1")]
                })], o);
              case "::placeholder":
                return Zt([vr(r, {
                  props: [ue(i, /:(plac\w+)/, ":" + ce + "input-$1")]
                }), vr(r, {
                  props: [ue(i, /:(plac\w+)/, ":" + cn + "$1")]
                }), vr(r, {
                  props: [ue(i, /:(plac\w+)/, Ye + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, Ih = [Nh], Ah = function(r) {
  var t = r.key;
  if (process.env.NODE_ENV !== "production" && !t)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(m) {
      var g = m.getAttribute("data-emotion");
      g.indexOf(" ") !== -1 && (document.head.appendChild(m), m.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || Ih;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(t))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var i = {}, a, c = [];
  a = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(m) {
      for (var g = m.getAttribute("data-emotion").split(" "), v = 1; v < g.length; v++)
        i[g[v]] = !0;
      c.push(m);
    }
  );
  var u, l = [Ph, kh];
  process.env.NODE_ENV !== "production" && l.push(Dh({
    get compat() {
      return b.compat;
    }
  }), $h);
  {
    var f, d = [wh, process.env.NODE_ENV !== "production" ? function(m) {
      m.root || (m.return ? f.insert(m.return) : m.value && m.type !== Ho && f.insert(m.value + "{}"));
    } : Sh(function(m) {
      f.insert(m);
    })], h = Th(l.concat(o, d)), y = function(g) {
      return Zt(vh(g), h);
    };
    u = function(g, v, _, T) {
      f = _, process.env.NODE_ENV !== "production" && v.map !== void 0 && (f = {
        insert: function(x) {
          _.insert(x + v.map);
        }
      }), y(g ? g + "{" + v.styles + "}" : v.styles), T && (b.inserted[v.name] = !0);
    };
  }
  var b = {
    key: t,
    sheet: new sh({
      key: t,
      container: a,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: u
  };
  return b.sheet.hydrate(c), b;
};
let _o;
typeof document == "object" && (_o = Ah({
  key: "css",
  prepend: !0
}));
function Fa(e) {
  const {
    injectFirst: r,
    children: t
  } = e;
  return r && _o ? /* @__PURE__ */ s.jsx(xu, {
    value: _o,
    children: t
  }) : t;
}
process.env.NODE_ENV !== "production" && (Fa.propTypes = {
  /**
   * Your component tree.
   */
  children: ne.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: ne.bool
});
function Fh(e) {
  return e == null || Object.keys(e).length === 0;
}
function Wa(e) {
  const {
    styles: r,
    defaultTheme: t = {}
  } = e, n = typeof r == "function" ? (o) => r(Fh(o) ? t : o) : r;
  return /* @__PURE__ */ s.jsx(vu, {
    styles: n
  });
}
process.env.NODE_ENV !== "production" && (Wa.propTypes = {
  defaultTheme: ne.object,
  styles: ne.oneOfType([ne.array, ne.string, ne.object, ne.func])
});
/**
 * @mui/styled-engine v5.15.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function Wh(e, r) {
  const t = bu(e, r);
  return process.env.NODE_ENV !== "production" ? (...n) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return n.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : n.some((i) => i === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), t(...n);
  } : t;
}
const Bh = (e, r) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = r(e.__emotion_styles));
}, Lh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: Wa,
  StyledEngineProvider: Fa,
  ThemeContext: ca,
  css: _u,
  default: Wh,
  internal_processStyles: Bh,
  keyframes: ua
}, Symbol.toStringTag, { value: "Module" }));
function Mt(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const r = Object.getPrototypeOf(e);
  return (r === null || r === Object.prototype || Object.getPrototypeOf(r) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Ba(e) {
  if (!Mt(e))
    return e;
  const r = {};
  return Object.keys(e).forEach((t) => {
    r[t] = Ba(e[t]);
  }), r;
}
function gt(e, r, t = {
  clone: !0
}) {
  const n = t.clone ? ge({}, e) : e;
  return Mt(e) && Mt(r) && Object.keys(r).forEach((o) => {
    o !== "__proto__" && (Mt(r[o]) && o in e && Mt(e[o]) ? n[o] = gt(e[o], r[o], t) : t.clone ? n[o] = Mt(r[o]) ? Ba(r[o]) : r[o] : n[o] = r[o]);
  }), n;
}
const Yh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gt,
  isPlainObject: Mt
}, Symbol.toStringTag, { value: "Module" })), Hh = ["values", "unit", "step"], zh = (e) => {
  const r = Object.keys(e).map((t) => ({
    key: t,
    val: e[t]
  })) || [];
  return r.sort((t, n) => t.val - n.val), r.reduce((t, n) => ge({}, t, {
    [n.key]: n.val
  }), {});
};
function La(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: r = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: t = "px",
    step: n = 5
  } = e, o = jt(e, Hh), i = zh(r), a = Object.keys(i);
  function c(h) {
    return `@media (min-width:${typeof r[h] == "number" ? r[h] : h}${t})`;
  }
  function u(h) {
    return `@media (max-width:${(typeof r[h] == "number" ? r[h] : h) - n / 100}${t})`;
  }
  function l(h, y) {
    const b = a.indexOf(y);
    return `@media (min-width:${typeof r[h] == "number" ? r[h] : h}${t}) and (max-width:${(b !== -1 && typeof r[a[b]] == "number" ? r[a[b]] : y) - n / 100}${t})`;
  }
  function f(h) {
    return a.indexOf(h) + 1 < a.length ? l(h, a[a.indexOf(h) + 1]) : c(h);
  }
  function d(h) {
    const y = a.indexOf(h);
    return y === 0 ? c(a[1]) : y === a.length - 1 ? u(a[y]) : l(h, a[a.indexOf(h) + 1]).replace("@media", "@media not all and");
  }
  return ge({
    keys: a,
    values: i,
    up: c,
    down: u,
    between: l,
    only: f,
    not: d,
    unit: t
  }, o);
}
const qh = {
  borderRadius: 4
}, Uh = qh, Vh = process.env.NODE_ENV !== "production" ? ne.oneOfType([ne.number, ne.string, ne.object, ne.array]) : {}, Dt = Vh;
function Tr(e, r) {
  return r ? gt(e, r, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Vo = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, ds = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Vo[e]}px)`
};
function _t(e, r, t) {
  const n = e.theme || {};
  if (Array.isArray(r)) {
    const i = n.breakpoints || ds;
    return r.reduce((a, c, u) => (a[i.up(i.keys[u])] = t(r[u]), a), {});
  }
  if (typeof r == "object") {
    const i = n.breakpoints || ds;
    return Object.keys(r).reduce((a, c) => {
      if (Object.keys(i.values || Vo).indexOf(c) !== -1) {
        const u = i.up(c);
        a[u] = t(r[c], c);
      } else {
        const u = c;
        a[u] = r[u];
      }
      return a;
    }, {});
  }
  return t(r);
}
function Gh(e = {}) {
  var r;
  return ((r = e.keys) == null ? void 0 : r.reduce((n, o) => {
    const i = e.up(o);
    return n[i] = {}, n;
  }, {})) || {};
}
function Xh(e, r) {
  return e.reduce((t, n) => {
    const o = t[n];
    return (!o || Object.keys(o).length === 0) && delete t[n], t;
  }, r);
}
function kt(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : Pr(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const Kh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kt
}, Symbol.toStringTag, { value: "Module" }));
function kn(e, r, t = !0) {
  if (!r || typeof r != "string")
    return null;
  if (e && e.vars && t) {
    const n = `vars.${r}`.split(".").reduce((o, i) => o && o[i] ? o[i] : null, e);
    if (n != null)
      return n;
  }
  return r.split(".").reduce((n, o) => n && n[o] != null ? n[o] : null, e);
}
function un(e, r, t, n = t) {
  let o;
  return typeof e == "function" ? o = e(t) : Array.isArray(e) ? o = e[t] || n : o = kn(e, t) || n, r && (o = r(o, n, e)), o;
}
function Re(e) {
  const {
    prop: r,
    cssProperty: t = e.prop,
    themeKey: n,
    transform: o
  } = e, i = (a) => {
    if (a[r] == null)
      return null;
    const c = a[r], u = a.theme, l = kn(u, n) || {};
    return _t(a, c, (d) => {
      let h = un(l, o, d);
      return d === h && typeof d == "string" && (h = un(l, o, `${r}${d === "default" ? "" : kt(d)}`, d)), t === !1 ? h : {
        [t]: h
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [r]: Dt
  } : {}, i.filterProps = [r], i;
}
function Qh(e) {
  const r = {};
  return (t) => (r[t] === void 0 && (r[t] = e(t)), r[t]);
}
const Jh = {
  m: "margin",
  p: "padding"
}, Zh = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, fs = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, ep = Qh((e) => {
  if (e.length > 2)
    if (fs[e])
      e = fs[e];
    else
      return [e];
  const [r, t] = e.split(""), n = Jh[r], o = Zh[t] || "";
  return Array.isArray(o) ? o.map((i) => n + i) : [n + o];
}), Cn = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], jn = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], tp = [...Cn, ...jn];
function Ar(e, r, t, n) {
  var o;
  const i = (o = kn(e, r, !1)) != null ? o : t;
  return typeof i == "number" ? (a) => typeof a == "string" ? a : (process.env.NODE_ENV !== "production" && typeof a != "number" && console.error(`MUI: Expected ${n} argument to be a number or a string, got ${a}.`), i * a) : Array.isArray(i) ? (a) => typeof a == "string" ? a : (process.env.NODE_ENV !== "production" && (Number.isInteger(a) ? a > i.length - 1 && console.error([`MUI: The value provided (${a}) overflows.`, `The supported values are: ${JSON.stringify(i)}.`, `${a} > ${i.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${r}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${r}\` as a number.`].join(`
`))), i[a]) : typeof i == "function" ? i : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${r}\` value (${i}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function Ya(e) {
  return Ar(e, "spacing", 8, "spacing");
}
function Fr(e, r) {
  if (typeof r == "string" || r == null)
    return r;
  const t = Math.abs(r), n = e(t);
  return r >= 0 ? n : typeof n == "number" ? -n : `-${n}`;
}
function rp(e, r) {
  return (t) => e.reduce((n, o) => (n[o] = Fr(r, t), n), {});
}
function np(e, r, t, n) {
  if (r.indexOf(t) === -1)
    return null;
  const o = ep(t), i = rp(o, n), a = e[t];
  return _t(e, a, i);
}
function Ha(e, r) {
  const t = Ya(e.theme);
  return Object.keys(e).map((n) => np(e, r, n, t)).reduce(Tr, {});
}
function Ee(e) {
  return Ha(e, Cn);
}
Ee.propTypes = process.env.NODE_ENV !== "production" ? Cn.reduce((e, r) => (e[r] = Dt, e), {}) : {};
Ee.filterProps = Cn;
function Me(e) {
  return Ha(e, jn);
}
Me.propTypes = process.env.NODE_ENV !== "production" ? jn.reduce((e, r) => (e[r] = Dt, e), {}) : {};
Me.filterProps = jn;
process.env.NODE_ENV !== "production" && tp.reduce((e, r) => (e[r] = Dt, e), {});
function op(e = 8) {
  if (e.mui)
    return e;
  const r = Ya({
    spacing: e
  }), t = (...n) => (process.env.NODE_ENV !== "production" && (n.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${n.length}`)), (n.length === 0 ? [1] : n).map((i) => {
    const a = r(i);
    return typeof a == "number" ? `${a}px` : a;
  }).join(" "));
  return t.mui = !0, t;
}
function Dn(...e) {
  const r = e.reduce((n, o) => (o.filterProps.forEach((i) => {
    n[i] = o;
  }), n), {}), t = (n) => Object.keys(n).reduce((o, i) => r[i] ? Tr(o, r[i](n)) : o, {});
  return t.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((n, o) => Object.assign(n, o.propTypes), {}) : {}, t.filterProps = e.reduce((n, o) => n.concat(o.filterProps), []), t;
}
function Ze(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function it(e, r) {
  return Re({
    prop: e,
    themeKey: "borders",
    transform: r
  });
}
const ip = it("border", Ze), sp = it("borderTop", Ze), ap = it("borderRight", Ze), cp = it("borderBottom", Ze), up = it("borderLeft", Ze), lp = it("borderColor"), dp = it("borderTopColor"), fp = it("borderRightColor"), hp = it("borderBottomColor"), pp = it("borderLeftColor"), mp = it("outline", Ze), gp = it("outlineColor"), Rn = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const r = Ar(e.theme, "shape.borderRadius", 4, "borderRadius"), t = (n) => ({
      borderRadius: Fr(r, n)
    });
    return _t(e, e.borderRadius, t);
  }
  return null;
};
Rn.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Dt
} : {};
Rn.filterProps = ["borderRadius"];
Dn(ip, sp, ap, cp, up, lp, dp, fp, hp, pp, Rn, mp, gp);
const $n = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const r = Ar(e.theme, "spacing", 8, "gap"), t = (n) => ({
      gap: Fr(r, n)
    });
    return _t(e, e.gap, t);
  }
  return null;
};
$n.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Dt
} : {};
$n.filterProps = ["gap"];
const Nn = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const r = Ar(e.theme, "spacing", 8, "columnGap"), t = (n) => ({
      columnGap: Fr(r, n)
    });
    return _t(e, e.columnGap, t);
  }
  return null;
};
Nn.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Dt
} : {};
Nn.filterProps = ["columnGap"];
const In = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const r = Ar(e.theme, "spacing", 8, "rowGap"), t = (n) => ({
      rowGap: Fr(r, n)
    });
    return _t(e, e.rowGap, t);
  }
  return null;
};
In.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Dt
} : {};
In.filterProps = ["rowGap"];
const yp = Re({
  prop: "gridColumn"
}), bp = Re({
  prop: "gridRow"
}), xp = Re({
  prop: "gridAutoFlow"
}), vp = Re({
  prop: "gridAutoColumns"
}), _p = Re({
  prop: "gridAutoRows"
}), wp = Re({
  prop: "gridTemplateColumns"
}), Tp = Re({
  prop: "gridTemplateRows"
}), Sp = Re({
  prop: "gridTemplateAreas"
}), Ep = Re({
  prop: "gridArea"
});
Dn($n, Nn, In, yp, bp, xp, vp, _p, wp, Tp, Sp, Ep);
function er(e, r) {
  return r === "grey" ? r : e;
}
const Mp = Re({
  prop: "color",
  themeKey: "palette",
  transform: er
}), Op = Re({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: er
}), Pp = Re({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: er
});
Dn(Mp, Op, Pp);
function Xe(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const kp = Re({
  prop: "width",
  transform: Xe
}), Go = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const r = (t) => {
      var n, o;
      const i = ((n = e.theme) == null || (n = n.breakpoints) == null || (n = n.values) == null ? void 0 : n[t]) || Vo[t];
      return i ? ((o = e.theme) == null || (o = o.breakpoints) == null ? void 0 : o.unit) !== "px" ? {
        maxWidth: `${i}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: i
      } : {
        maxWidth: Xe(t)
      };
    };
    return _t(e, e.maxWidth, r);
  }
  return null;
};
Go.filterProps = ["maxWidth"];
const Cp = Re({
  prop: "minWidth",
  transform: Xe
}), jp = Re({
  prop: "height",
  transform: Xe
}), Dp = Re({
  prop: "maxHeight",
  transform: Xe
}), Rp = Re({
  prop: "minHeight",
  transform: Xe
});
Re({
  prop: "size",
  cssProperty: "width",
  transform: Xe
});
Re({
  prop: "size",
  cssProperty: "height",
  transform: Xe
});
const $p = Re({
  prop: "boxSizing"
});
Dn(kp, Go, Cp, jp, Dp, Rp, $p);
const Np = {
  // borders
  border: {
    themeKey: "borders",
    transform: Ze
  },
  borderTop: {
    themeKey: "borders",
    transform: Ze
  },
  borderRight: {
    themeKey: "borders",
    transform: Ze
  },
  borderBottom: {
    themeKey: "borders",
    transform: Ze
  },
  borderLeft: {
    themeKey: "borders",
    transform: Ze
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: Ze
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Rn
  },
  // palette
  color: {
    themeKey: "palette",
    transform: er
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: er
  },
  backgroundColor: {
    themeKey: "palette",
    transform: er
  },
  // spacing
  p: {
    style: Me
  },
  pt: {
    style: Me
  },
  pr: {
    style: Me
  },
  pb: {
    style: Me
  },
  pl: {
    style: Me
  },
  px: {
    style: Me
  },
  py: {
    style: Me
  },
  padding: {
    style: Me
  },
  paddingTop: {
    style: Me
  },
  paddingRight: {
    style: Me
  },
  paddingBottom: {
    style: Me
  },
  paddingLeft: {
    style: Me
  },
  paddingX: {
    style: Me
  },
  paddingY: {
    style: Me
  },
  paddingInline: {
    style: Me
  },
  paddingInlineStart: {
    style: Me
  },
  paddingInlineEnd: {
    style: Me
  },
  paddingBlock: {
    style: Me
  },
  paddingBlockStart: {
    style: Me
  },
  paddingBlockEnd: {
    style: Me
  },
  m: {
    style: Ee
  },
  mt: {
    style: Ee
  },
  mr: {
    style: Ee
  },
  mb: {
    style: Ee
  },
  ml: {
    style: Ee
  },
  mx: {
    style: Ee
  },
  my: {
    style: Ee
  },
  margin: {
    style: Ee
  },
  marginTop: {
    style: Ee
  },
  marginRight: {
    style: Ee
  },
  marginBottom: {
    style: Ee
  },
  marginLeft: {
    style: Ee
  },
  marginX: {
    style: Ee
  },
  marginY: {
    style: Ee
  },
  marginInline: {
    style: Ee
  },
  marginInlineStart: {
    style: Ee
  },
  marginInlineEnd: {
    style: Ee
  },
  marginBlock: {
    style: Ee
  },
  marginBlockStart: {
    style: Ee
  },
  marginBlockEnd: {
    style: Ee
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: $n
  },
  rowGap: {
    style: In
  },
  columnGap: {
    style: Nn
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Xe
  },
  maxWidth: {
    style: Go
  },
  minWidth: {
    transform: Xe
  },
  height: {
    transform: Xe
  },
  maxHeight: {
    transform: Xe
  },
  minHeight: {
    transform: Xe
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
}, Wr = Np;
function Ip(...e) {
  const r = e.reduce((n, o) => n.concat(Object.keys(o)), []), t = new Set(r);
  return e.every((n) => t.size === Object.keys(n).length);
}
function Ap(e, r) {
  return typeof e == "function" ? e(r) : e;
}
function za() {
  function e(t, n, o, i) {
    const a = {
      [t]: n,
      theme: o
    }, c = i[t];
    if (!c)
      return {
        [t]: n
      };
    const {
      cssProperty: u = t,
      themeKey: l,
      transform: f,
      style: d
    } = c;
    if (n == null)
      return null;
    if (l === "typography" && n === "inherit")
      return {
        [t]: n
      };
    const h = kn(o, l) || {};
    return d ? d(a) : _t(a, n, (b) => {
      let m = un(h, f, b);
      return b === m && typeof b == "string" && (m = un(h, f, `${t}${b === "default" ? "" : kt(b)}`, b)), u === !1 ? m : {
        [u]: m
      };
    });
  }
  function r(t) {
    var n;
    const {
      sx: o,
      theme: i = {}
    } = t || {};
    if (!o)
      return null;
    const a = (n = i.unstable_sxConfig) != null ? n : Wr;
    function c(u) {
      let l = u;
      if (typeof u == "function")
        l = u(i);
      else if (typeof u != "object")
        return u;
      if (!l)
        return null;
      const f = Gh(i.breakpoints), d = Object.keys(f);
      let h = f;
      return Object.keys(l).forEach((y) => {
        const b = Ap(l[y], i);
        if (b != null)
          if (typeof b == "object")
            if (a[y])
              h = Tr(h, e(y, b, i, a));
            else {
              const m = _t({
                theme: i
              }, b, (g) => ({
                [y]: g
              }));
              Ip(m, b) ? h[y] = r({
                sx: b,
                theme: i
              }) : h = Tr(h, m);
            }
          else
            h = Tr(h, e(y, b, i, a));
      }), Xh(d, h);
    }
    return Array.isArray(o) ? o.map(c) : c(o);
  }
  return r;
}
const qa = za();
qa.filterProps = ["sx"];
const Xo = qa;
function Ua(e, r) {
  const t = this;
  return t.vars && typeof t.getColorSchemeSelector == "function" ? {
    [t.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: r
  } : t.palette.mode === e ? r : {};
}
const Fp = ["breakpoints", "palette", "spacing", "shape"];
function Ko(e = {}, ...r) {
  const {
    breakpoints: t = {},
    palette: n = {},
    spacing: o,
    shape: i = {}
  } = e, a = jt(e, Fp), c = La(t), u = op(o);
  let l = gt({
    breakpoints: c,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: ge({
      mode: "light"
    }, n),
    spacing: u,
    shape: ge({}, Uh, i)
  }, a);
  return l.applyStyles = Ua, l = r.reduce((f, d) => gt(f, d), l), l.unstable_sxConfig = ge({}, Wr, a == null ? void 0 : a.unstable_sxConfig), l.unstable_sx = function(d) {
    return Xo({
      sx: d,
      theme: this
    });
  }, l;
}
const Wp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ko,
  private_createBreakpoints: La,
  unstable_applyStyles: Ua
}, Symbol.toStringTag, { value: "Module" }));
function Bp(e) {
  return Object.keys(e).length === 0;
}
function Lp(e = null) {
  const r = Oe.useContext(ca);
  return !r || Bp(r) ? e : r;
}
const Yp = Ko();
function Hp(e = Yp) {
  return Lp(e);
}
const zp = ["sx"], qp = (e) => {
  var r, t;
  const n = {
    systemProps: {},
    otherProps: {}
  }, o = (r = e == null || (t = e.theme) == null ? void 0 : t.unstable_sxConfig) != null ? r : Wr;
  return Object.keys(e).forEach((i) => {
    o[i] ? n.systemProps[i] = e[i] : n.otherProps[i] = e[i];
  }), n;
};
function Up(e) {
  const {
    sx: r
  } = e, t = jt(e, zp), {
    systemProps: n,
    otherProps: o
  } = qp(t);
  let i;
  return Array.isArray(r) ? i = [n, ...r] : typeof r == "function" ? i = (...a) => {
    const c = r(...a);
    return Mt(c) ? ge({}, n, c) : n;
  } : i = ge({}, n, r), ge({}, o, {
    sx: i
  });
}
const Vp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xo,
  extendSxProp: Up,
  unstable_createStyleFunctionSx: za,
  unstable_defaultSxConfig: Wr
}, Symbol.toStringTag, { value: "Module" })), hs = (e) => e, Gp = () => {
  let e = hs;
  return {
    configure(r) {
      e = r;
    },
    generate(r) {
      return e(r);
    },
    reset() {
      e = hs;
    }
  };
}, Xp = Gp(), Va = Xp;
function Ga(e) {
  var r, t, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (r = 0; r < o; r++)
        e[r] && (t = Ga(e[r])) && (n && (n += " "), n += t);
    } else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function Kp() {
  for (var e, r, t = 0, n = "", o = arguments.length; t < o; t++)
    (e = arguments[t]) && (r = Ga(e)) && (n && (n += " "), n += r);
  return n;
}
const Qp = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Qo(e, r, t = "Mui") {
  const n = Qp[r];
  return n ? `${t}-${n}` : `${Va.generate(e)}-${r}`;
}
function Jp(e, r, t = "Mui") {
  const n = {};
  return r.forEach((o) => {
    n[o] = Qo(e, o, t);
  }), n;
}
var wo = { exports: {} }, he = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ps;
function Zp() {
  if (ps)
    return he;
  ps = 1;
  var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), c = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), b;
  b = Symbol.for("react.module.reference");
  function m(g) {
    if (typeof g == "object" && g !== null) {
      var v = g.$$typeof;
      switch (v) {
        case e:
          switch (g = g.type, g) {
            case t:
            case o:
            case n:
            case l:
            case f:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case c:
                case a:
                case u:
                case h:
                case d:
                case i:
                  return g;
                default:
                  return v;
              }
          }
        case r:
          return v;
      }
    }
  }
  return he.ContextConsumer = a, he.ContextProvider = i, he.Element = e, he.ForwardRef = u, he.Fragment = t, he.Lazy = h, he.Memo = d, he.Portal = r, he.Profiler = o, he.StrictMode = n, he.Suspense = l, he.SuspenseList = f, he.isAsyncMode = function() {
    return !1;
  }, he.isConcurrentMode = function() {
    return !1;
  }, he.isContextConsumer = function(g) {
    return m(g) === a;
  }, he.isContextProvider = function(g) {
    return m(g) === i;
  }, he.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, he.isForwardRef = function(g) {
    return m(g) === u;
  }, he.isFragment = function(g) {
    return m(g) === t;
  }, he.isLazy = function(g) {
    return m(g) === h;
  }, he.isMemo = function(g) {
    return m(g) === d;
  }, he.isPortal = function(g) {
    return m(g) === r;
  }, he.isProfiler = function(g) {
    return m(g) === o;
  }, he.isStrictMode = function(g) {
    return m(g) === n;
  }, he.isSuspense = function(g) {
    return m(g) === l;
  }, he.isSuspenseList = function(g) {
    return m(g) === f;
  }, he.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === t || g === o || g === n || g === l || g === f || g === y || typeof g == "object" && g !== null && (g.$$typeof === h || g.$$typeof === d || g.$$typeof === i || g.$$typeof === a || g.$$typeof === u || g.$$typeof === b || g.getModuleId !== void 0);
  }, he.typeOf = m, he;
}
var pe = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ms;
function em() {
  return ms || (ms = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), c = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), b = !1, m = !1, g = !1, v = !1, _ = !1, T;
    T = Symbol.for("react.module.reference");
    function w(W) {
      return !!(typeof W == "string" || typeof W == "function" || W === t || W === o || _ || W === n || W === l || W === f || v || W === y || b || m || g || typeof W == "object" && W !== null && (W.$$typeof === h || W.$$typeof === d || W.$$typeof === i || W.$$typeof === a || W.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      W.$$typeof === T || W.getModuleId !== void 0));
    }
    function x(W) {
      if (typeof W == "object" && W !== null) {
        var st = W.$$typeof;
        switch (st) {
          case e:
            var bt = W.type;
            switch (bt) {
              case t:
              case o:
              case n:
              case l:
              case f:
                return bt;
              default:
                var gr = bt && bt.$$typeof;
                switch (gr) {
                  case c:
                  case a:
                  case u:
                  case h:
                  case d:
                  case i:
                    return gr;
                  default:
                    return st;
                }
            }
          case r:
            return st;
        }
      }
    }
    var S = a, P = i, F = e, ee = u, Y = t, k = h, C = d, B = r, j = o, Q = n, ie = l, H = f, G = !1, _e = !1;
    function E(W) {
      return G || (G = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function M(W) {
      return _e || (_e = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function L(W) {
      return x(W) === a;
    }
    function I(W) {
      return x(W) === i;
    }
    function z(W) {
      return typeof W == "object" && W !== null && W.$$typeof === e;
    }
    function te(W) {
      return x(W) === u;
    }
    function U(W) {
      return x(W) === t;
    }
    function V(W) {
      return x(W) === h;
    }
    function X(W) {
      return x(W) === d;
    }
    function oe(W) {
      return x(W) === r;
    }
    function K(W) {
      return x(W) === o;
    }
    function Ae(W) {
      return x(W) === n;
    }
    function R(W) {
      return x(W) === l;
    }
    function Ue(W) {
      return x(W) === f;
    }
    pe.ContextConsumer = S, pe.ContextProvider = P, pe.Element = F, pe.ForwardRef = ee, pe.Fragment = Y, pe.Lazy = k, pe.Memo = C, pe.Portal = B, pe.Profiler = j, pe.StrictMode = Q, pe.Suspense = ie, pe.SuspenseList = H, pe.isAsyncMode = E, pe.isConcurrentMode = M, pe.isContextConsumer = L, pe.isContextProvider = I, pe.isElement = z, pe.isForwardRef = te, pe.isFragment = U, pe.isLazy = V, pe.isMemo = X, pe.isPortal = oe, pe.isProfiler = K, pe.isStrictMode = Ae, pe.isSuspense = R, pe.isSuspenseList = Ue, pe.isValidElementType = w, pe.typeOf = x;
  }()), pe;
}
process.env.NODE_ENV === "production" ? wo.exports = Zp() : wo.exports = em();
var gs = wo.exports;
const tm = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function Xa(e) {
  const r = `${e}`.match(tm);
  return r && r[1] || "";
}
function Ka(e, r = "") {
  return e.displayName || e.name || Xa(e) || r;
}
function ys(e, r, t) {
  const n = Ka(r);
  return e.displayName || (n !== "" ? `${t}(${n})` : t);
}
function rm(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return Ka(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case gs.ForwardRef:
          return ys(e, e.render, "ForwardRef");
        case gs.Memo:
          return ys(e, e.type, "memo");
        default:
          return;
      }
  }
}
const nm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rm,
  getFunctionName: Xa
}, Symbol.toStringTag, { value: "Module" }));
function Qa(e, r) {
  const t = ge({}, r);
  return Object.keys(e).forEach((n) => {
    if (n.toString().match(/^(components|slots)$/))
      t[n] = ge({}, e[n], t[n]);
    else if (n.toString().match(/^(componentsProps|slotProps)$/)) {
      const o = e[n] || {}, i = r[n];
      t[n] = {}, !i || !Object.keys(i) ? t[n] = o : !o || !Object.keys(o) ? t[n] = i : (t[n] = ge({}, i), Object.keys(o).forEach((a) => {
        t[n][a] = Qa(o[a], i[a]);
      }));
    } else
      t[n] === void 0 && (t[n] = e[n]);
  }), t;
}
function om(e) {
  const {
    theme: r,
    name: t,
    props: n
  } = e;
  return !r || !r.components || !r.components[t] || !r.components[t].defaultProps ? n : Qa(r.components[t].defaultProps, n);
}
function im({
  props: e,
  name: r,
  defaultTheme: t,
  themeId: n
}) {
  let o = Hp(t);
  return n && (o = o[n] || o), om({
    theme: o,
    name: r,
    props: e
  });
}
const sm = typeof window != "undefined" ? Oe.useLayoutEffect : Oe.useEffect, Ja = sm;
function am(e, r = Number.MIN_SAFE_INTEGER, t = Number.MAX_SAFE_INTEGER) {
  return Math.max(r, Math.min(e, t));
}
const cm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: am
}, Symbol.toStringTag, { value: "Module" }));
function um(...e) {
  return e.reduce((r, t) => t == null ? r : function(...o) {
    r.apply(this, o), t.apply(this, o);
  }, () => {
  });
}
function lm(e, r = 166) {
  let t;
  function n(...o) {
    const i = () => {
      e.apply(this, o);
    };
    clearTimeout(t), t = setTimeout(i, r);
  }
  return n.clear = () => {
    clearTimeout(t);
  }, n;
}
function dm(e, r) {
  return process.env.NODE_ENV === "production" ? () => null : (t, n, o, i, a) => {
    const c = o || "<<anonymous>>", u = a || n;
    return typeof t[n] != "undefined" ? new Error(`The ${i} \`${u}\` of \`${c}\` is deprecated. ${r}`) : null;
  };
}
function fm(e, r) {
  var t, n;
  return /* @__PURE__ */ Oe.isValidElement(e) && r.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (t = e.type.muiName) != null ? t : (n = e.type) == null || (n = n._payload) == null || (n = n.value) == null ? void 0 : n.muiName
  ) !== -1;
}
function Za(e) {
  return e && e.ownerDocument || document;
}
function hm(e) {
  return Za(e).defaultView || window;
}
function pm(e, r) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const t = r ? ge({}, r.propTypes) : null;
  return (o) => (i, a, c, u, l, ...f) => {
    const d = l || a, h = t == null ? void 0 : t[d];
    if (h) {
      const y = h(i, a, c, u, l, ...f);
      if (y)
        return y;
    }
    return typeof i[a] != "undefined" && !i[o] ? new Error(`The prop \`${d}\` of \`${e}\` can only be used together with the \`${o}\` prop.`) : null;
  };
}
function ec(e, r) {
  typeof e == "function" ? e(r) : e && (e.current = r);
}
let bs = 0;
function mm(e) {
  const [r, t] = Oe.useState(e), n = e || r;
  return Oe.useEffect(() => {
    r == null && (bs += 1, t(`mui-${bs}`));
  }, [r]), n;
}
const xs = Oe["useId".toString()];
function gm(e) {
  if (xs !== void 0) {
    const r = xs();
    return e != null ? e : r;
  }
  return mm(e);
}
function ym(e, r, t, n, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = o || r;
  return typeof e[r] != "undefined" ? new Error(`The prop \`${i}\` is not supported. Please remove it.`) : null;
}
function bm({
  controlled: e,
  default: r,
  name: t,
  state: n = "value"
}) {
  const {
    current: o
  } = Oe.useRef(e !== void 0), [i, a] = Oe.useState(r), c = o ? e : i;
  if (process.env.NODE_ENV !== "production") {
    Oe.useEffect(() => {
      o !== (e !== void 0) && console.error([`MUI: A component is changing the ${o ? "" : "un"}controlled ${n} state of ${t} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${t} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [n, t, e]);
    const {
      current: l
    } = Oe.useRef(r);
    Oe.useEffect(() => {
      !o && l !== r && console.error([`MUI: A component is changing the default ${n} state of an uncontrolled ${t} after being initialized. To suppress this warning opt to use a controlled ${t}.`].join(`
`));
    }, [JSON.stringify(r)]);
  }
  const u = Oe.useCallback((l) => {
    o || a(l);
  }, []);
  return [c, u];
}
function xm(e) {
  const r = Oe.useRef(e);
  return Ja(() => {
    r.current = e;
  }), Oe.useRef((...t) => (
    // @ts-expect-error hide `this`
    (0, r.current)(...t)
  )).current;
}
function vm(...e) {
  return Oe.useMemo(() => e.every((r) => r == null) ? null : (r) => {
    e.forEach((t) => {
      ec(t, r);
    });
  }, e);
}
class Jo {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new Jo();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(r, t) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, t();
    }, r);
  }
}
let An = !0, To = !1;
const _m = new Jo(), wm = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function Tm(e) {
  const {
    type: r,
    tagName: t
  } = e;
  return !!(t === "INPUT" && wm[r] && !e.readOnly || t === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function Sm(e) {
  e.metaKey || e.altKey || e.ctrlKey || (An = !0);
}
function oo() {
  An = !1;
}
function Em() {
  this.visibilityState === "hidden" && To && (An = !0);
}
function Mm(e) {
  e.addEventListener("keydown", Sm, !0), e.addEventListener("mousedown", oo, !0), e.addEventListener("pointerdown", oo, !0), e.addEventListener("touchstart", oo, !0), e.addEventListener("visibilitychange", Em, !0);
}
function Om(e) {
  const {
    target: r
  } = e;
  try {
    return r.matches(":focus-visible");
  } catch (t) {
  }
  return An || Tm(r);
}
function Pm() {
  const e = Oe.useCallback((o) => {
    o != null && Mm(o.ownerDocument);
  }, []), r = Oe.useRef(!1);
  function t() {
    return r.current ? (To = !0, _m.start(100, () => {
      To = !1;
    }), r.current = !1, !0) : !1;
  }
  function n(o) {
    return Om(o) ? (r.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: r,
    onFocus: n,
    onBlur: t,
    ref: e
  };
}
function km(e, r, t = void 0) {
  const n = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (o) => {
      n[o] = e[o].reduce((i, a) => {
        if (a) {
          const c = r(a);
          c !== "" && i.push(c), t && t[a] && i.push(t[a]);
        }
        return i;
      }, []).join(" ");
    }
  ), n;
}
function Cm(e, r) {
  return ge({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, r);
}
var $e = {}, tc = { exports: {} };
(function(e) {
  function r(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(tc);
var hr = tc.exports;
const jm = /* @__PURE__ */ wt(Gf), Dm = /* @__PURE__ */ wt(cm);
var rc = hr;
Object.defineProperty($e, "__esModule", {
  value: !0
});
$e.alpha = sc;
$e.blend = zm;
$e.colorChannel = void 0;
var Rm = $e.darken = ei;
$e.decomposeColor = rt;
$e.emphasize = Hm;
var vs = $e.getContrastRatio = Wm;
$e.getLuminance = ln;
$e.hexToRgb = nc;
$e.hslToRgb = ic;
var $m = $e.lighten = ti;
$e.private_safeAlpha = Bm;
$e.private_safeColorChannel = void 0;
$e.private_safeDarken = Lm;
$e.private_safeEmphasize = ac;
$e.private_safeLighten = Ym;
$e.recomposeColor = pr;
$e.rgbToHex = Fm;
var _s = rc(jm), Nm = rc(Dm);
function Zo(e, r = 0, t = 1) {
  return process.env.NODE_ENV !== "production" && (e < r || e > t) && console.error(`MUI: The value provided ${e} is out of range [${r}, ${t}].`), (0, Nm.default)(e, r, t);
}
function nc(e) {
  e = e.slice(1);
  const r = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let t = e.match(r);
  return t && t[0].length === 1 && (t = t.map((n) => n + n)), t ? `rgb${t.length === 4 ? "a" : ""}(${t.map((n, o) => o < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Im(e) {
  const r = e.toString(16);
  return r.length === 1 ? `0${r}` : r;
}
function rt(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return rt(nc(e));
  const r = e.indexOf("("), t = e.substring(0, r);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(t) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, _s.default)(9, e));
  let n = e.substring(r + 1, e.length - 1), o;
  if (t === "color") {
    if (n = n.split(" "), o = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(o) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, _s.default)(10, o));
  } else
    n = n.split(",");
  return n = n.map((i) => parseFloat(i)), {
    type: t,
    values: n,
    colorSpace: o
  };
}
const oc = (e) => {
  const r = rt(e);
  return r.values.slice(0, 3).map((t, n) => r.type.indexOf("hsl") !== -1 && n !== 0 ? `${t}%` : t).join(" ");
};
$e.colorChannel = oc;
const Am = (e, r) => {
  try {
    return oc(e);
  } catch (t) {
    return r && process.env.NODE_ENV !== "production" && console.warn(r), e;
  }
};
$e.private_safeColorChannel = Am;
function pr(e) {
  const {
    type: r,
    colorSpace: t
  } = e;
  let {
    values: n
  } = e;
  return r.indexOf("rgb") !== -1 ? n = n.map((o, i) => i < 3 ? parseInt(o, 10) : o) : r.indexOf("hsl") !== -1 && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), r.indexOf("color") !== -1 ? n = `${t} ${n.join(" ")}` : n = `${n.join(", ")}`, `${r}(${n})`;
}
function Fm(e) {
  if (e.indexOf("#") === 0)
    return e;
  const {
    values: r
  } = rt(e);
  return `#${r.map((t, n) => Im(n === 3 ? Math.round(255 * t) : t)).join("")}`;
}
function ic(e) {
  e = rt(e);
  const {
    values: r
  } = e, t = r[0], n = r[1] / 100, o = r[2] / 100, i = n * Math.min(o, 1 - o), a = (l, f = (l + t / 30) % 12) => o - i * Math.max(Math.min(f - 3, 9 - f, 1), -1);
  let c = "rgb";
  const u = [Math.round(a(0) * 255), Math.round(a(8) * 255), Math.round(a(4) * 255)];
  return e.type === "hsla" && (c += "a", u.push(r[3])), pr({
    type: c,
    values: u
  });
}
function ln(e) {
  e = rt(e);
  let r = e.type === "hsl" || e.type === "hsla" ? rt(ic(e)).values : e.values;
  return r = r.map((t) => (e.type !== "color" && (t /= 255), t <= 0.03928 ? t / 12.92 : zt((t + 0.055) / 1.055, 2.4))), Number((0.2126 * r[0] + 0.7152 * r[1] + 0.0722 * r[2]).toFixed(3));
}
function Wm(e, r) {
  const t = ln(e), n = ln(r);
  return (Math.max(t, n) + 0.05) / (Math.min(t, n) + 0.05);
}
function sc(e, r) {
  return e = rt(e), r = Zo(r), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${r}` : e.values[3] = r, pr(e);
}
function Bm(e, r, t) {
  try {
    return sc(e, r);
  } catch (n) {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}
function ei(e, r) {
  if (e = rt(e), r = Zo(r), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - r;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let t = 0; t < 3; t += 1)
      e.values[t] *= 1 - r;
  return pr(e);
}
function Lm(e, r, t) {
  try {
    return ei(e, r);
  } catch (n) {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}
function ti(e, r) {
  if (e = rt(e), r = Zo(r), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * r;
  else if (e.type.indexOf("rgb") !== -1)
    for (let t = 0; t < 3; t += 1)
      e.values[t] += (255 - e.values[t]) * r;
  else if (e.type.indexOf("color") !== -1)
    for (let t = 0; t < 3; t += 1)
      e.values[t] += (1 - e.values[t]) * r;
  return pr(e);
}
function Ym(e, r, t) {
  try {
    return ti(e, r);
  } catch (n) {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}
function Hm(e, r = 0.15) {
  return ln(e) > 0.5 ? ei(e, r) : ti(e, r);
}
function ac(e, r, t) {
  try {
    return ac(e, r);
  } catch (n) {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}
function zm(e, r, t, n = 1) {
  const o = (u, l) => Math.round(zt(zt(u, 1 / n) * (1 - t) + zt(l, 1 / n) * t, n)), i = rt(e), a = rt(r), c = [o(i.values[0], a.values[0]), o(i.values[1], a.values[1]), o(i.values[2], a.values[2])];
  return pr({
    type: "rgb",
    values: c
  });
}
const qm = {
  black: "#000",
  white: "#fff"
}, jr = qm, Um = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Vm = Um, Gm = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, qt = Gm, Xm = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Ut = Xm, Km = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, _r = Km, Qm = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, Vt = Qm, Jm = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Gt = Jm, Zm = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, Xt = Zm, eg = ["mode", "contrastThreshold", "tonalOffset"], ws = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: jr.white,
    default: jr.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, io = {
  text: {
    primary: jr.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: jr.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function Ts(e, r, t, n) {
  const o = n.light || n, i = n.dark || n * 1.5;
  e[r] || (e.hasOwnProperty(t) ? e[r] = e[t] : r === "light" ? e.light = $m(e.main, o) : r === "dark" && (e.dark = Rm(e.main, i)));
}
function tg(e = "light") {
  return e === "dark" ? {
    main: Vt[200],
    light: Vt[50],
    dark: Vt[400]
  } : {
    main: Vt[700],
    light: Vt[400],
    dark: Vt[800]
  };
}
function rg(e = "light") {
  return e === "dark" ? {
    main: qt[200],
    light: qt[50],
    dark: qt[400]
  } : {
    main: qt[500],
    light: qt[300],
    dark: qt[700]
  };
}
function ng(e = "light") {
  return e === "dark" ? {
    main: Ut[500],
    light: Ut[300],
    dark: Ut[700]
  } : {
    main: Ut[700],
    light: Ut[400],
    dark: Ut[800]
  };
}
function og(e = "light") {
  return e === "dark" ? {
    main: Gt[400],
    light: Gt[300],
    dark: Gt[700]
  } : {
    main: Gt[700],
    light: Gt[500],
    dark: Gt[900]
  };
}
function ig(e = "light") {
  return e === "dark" ? {
    main: Xt[400],
    light: Xt[300],
    dark: Xt[700]
  } : {
    main: Xt[800],
    light: Xt[500],
    dark: Xt[900]
  };
}
function sg(e = "light") {
  return e === "dark" ? {
    main: _r[400],
    light: _r[300],
    dark: _r[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: _r[500],
    dark: _r[900]
  };
}
function ag(e) {
  const {
    mode: r = "light",
    contrastThreshold: t = 3,
    tonalOffset: n = 0.2
  } = e, o = jt(e, eg), i = e.primary || tg(r), a = e.secondary || rg(r), c = e.error || ng(r), u = e.info || og(r), l = e.success || ig(r), f = e.warning || sg(r);
  function d(m) {
    const g = vs(m, io.text.primary) >= t ? io.text.primary : ws.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const v = vs(m, g);
      v < 3 && console.error([`MUI: The contrast ratio of ${v}:1 for ${g} on ${m}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return g;
  }
  const h = ({
    color: m,
    name: g,
    mainShade: v = 500,
    lightShade: _ = 300,
    darkShade: T = 700
  }) => {
    if (m = ge({}, m), !m.main && m[v] && (m.main = m[v]), !m.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${g ? ` (${g})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${v}\` property.` : Pr(11, g ? ` (${g})` : "", v));
    if (typeof m.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${g ? ` (${g})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(m.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : Pr(12, g ? ` (${g})` : "", JSON.stringify(m.main)));
    return Ts(m, "light", _, n), Ts(m, "dark", T, n), m.contrastText || (m.contrastText = d(m.main)), m;
  }, y = {
    dark: io,
    light: ws
  };
  return process.env.NODE_ENV !== "production" && (y[r] || console.error(`MUI: The palette mode \`${r}\` is not supported.`)), gt(ge({
    // A collection of common colors.
    common: ge({}, jr),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: r,
    // The colors used to represent primary interface elements for a user.
    primary: h({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: h({
      color: a,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: h({
      color: c,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: h({
      color: f,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: h({
      color: u,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: h({
      color: l,
      name: "success"
    }),
    // The grey colors.
    grey: Vm,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: t,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: d,
    // Generate a rich color object.
    augmentColor: h,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: n
  }, y[r]), o);
}
const cg = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function ug(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Ss = {
  textTransform: "uppercase"
}, Es = '"Roboto", "Helvetica", "Arial", sans-serif';
function lg(e, r) {
  const t = typeof r == "function" ? r(e) : r, {
    fontFamily: n = Es,
    // The default font size of the Material Specification.
    fontSize: o = 14,
    // px
    fontWeightLight: i = 300,
    fontWeightRegular: a = 400,
    fontWeightMedium: c = 500,
    fontWeightBold: u = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: l = 16,
    // Apply the CSS properties to all the variants.
    allVariants: f,
    pxToRem: d
  } = t, h = jt(t, cg);
  process.env.NODE_ENV !== "production" && (typeof o != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof l != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const y = o / 14, b = d || ((v) => `${v / l * y}rem`), m = (v, _, T, w, x) => ge({
    fontFamily: n,
    fontWeight: v,
    fontSize: b(_),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: T
  }, n === Es ? {
    letterSpacing: `${ug(w / _)}em`
  } : {}, x, f), g = {
    h1: m(i, 96, 1.167, -1.5),
    h2: m(i, 60, 1.2, -0.5),
    h3: m(a, 48, 1.167, 0),
    h4: m(a, 34, 1.235, 0.25),
    h5: m(a, 24, 1.334, 0),
    h6: m(c, 20, 1.6, 0.15),
    subtitle1: m(a, 16, 1.75, 0.15),
    subtitle2: m(c, 14, 1.57, 0.1),
    body1: m(a, 16, 1.5, 0.15),
    body2: m(a, 14, 1.43, 0.15),
    button: m(c, 14, 1.75, 0.4, Ss),
    caption: m(a, 12, 1.66, 0.4),
    overline: m(a, 12, 2.66, 1, Ss),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return gt(ge({
    htmlFontSize: l,
    pxToRem: b,
    fontFamily: n,
    fontSize: o,
    fontWeightLight: i,
    fontWeightRegular: a,
    fontWeightMedium: c,
    fontWeightBold: u
  }, g), h, {
    clone: !1
    // No need to clone deep
  });
}
const dg = 0.2, fg = 0.14, hg = 0.12;
function we(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${dg})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${fg})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${hg})`].join(",");
}
const pg = ["none", we(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), we(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), we(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), we(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), we(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), we(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), we(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), we(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), we(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), we(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), we(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), we(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), we(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), we(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), we(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), we(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), we(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), we(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), we(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), we(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), we(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), we(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), we(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), we(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], mg = pg, gg = ["duration", "easing", "delay"], yg = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, bg = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Ms(e) {
  return `${Math.round(e)}ms`;
}
function xg(e) {
  if (!e)
    return 0;
  const r = e / 36;
  return Math.round((4 + 15 * zt(r, 0.25) + r / 5) * 10);
}
function vg(e) {
  const r = ge({}, yg, e.easing), t = ge({}, bg, e.duration);
  return ge({
    getAutoHeightDuration: xg,
    create: (o = ["all"], i = {}) => {
      const {
        duration: a = t.standard,
        easing: c = r.easeInOut,
        delay: u = 0
      } = i, l = jt(i, gg);
      if (process.env.NODE_ENV !== "production") {
        const f = (h) => typeof h == "string", d = (h) => !isNaN(parseFloat(h));
        !f(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !d(a) && !f(a) && console.error(`MUI: Argument "duration" must be a number or a string but found ${a}.`), f(c) || console.error('MUI: Argument "easing" must be a string.'), !d(u) && !f(u) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(l).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(l).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((f) => `${f} ${typeof a == "string" ? a : Ms(a)} ${c} ${typeof u == "string" ? u : Ms(u)}`).join(",");
    }
  }, e, {
    easing: r,
    duration: t
  });
}
const _g = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, wg = _g, Tg = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function Sg(e = {}, ...r) {
  const {
    mixins: t = {},
    palette: n = {},
    transitions: o = {},
    typography: i = {}
  } = e, a = jt(e, Tg);
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : Pr(18));
  const c = ag(n), u = Ko(e);
  let l = gt(u, {
    mixins: Cm(u.breakpoints, t),
    palette: c,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: mg.slice(),
    typography: lg(c, i),
    transitions: vg(o),
    zIndex: ge({}, wg)
  });
  if (l = gt(l, a), l = r.reduce((f, d) => gt(f, d), l), process.env.NODE_ENV !== "production") {
    const f = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], d = (h, y) => {
      let b;
      for (b in h) {
        const m = h[b];
        if (f.indexOf(b) !== -1 && Object.keys(m).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const g = Qo("", b);
            console.error([`MUI: The \`${y}\` component increases the CSS specificity of the \`${b}\` internal state.`, "You can not override it like this: ", JSON.stringify(h, null, 2), "", `Instead, you need to use the '&.${g}' syntax:`, JSON.stringify({
              root: {
                [`&.${g}`]: m
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          h[b] = {};
        }
      }
    };
    Object.keys(l.components).forEach((h) => {
      const y = l.components[h].styleOverrides;
      y && h.indexOf("Mui") === 0 && d(y, h);
    });
  }
  return l.unstable_sxConfig = ge({}, Wr, a == null ? void 0 : a.unstable_sxConfig), l.unstable_sx = function(d) {
    return Xo({
      sx: d,
      theme: this
    });
  }, l;
}
const Eg = Sg(), cc = Eg;
function Mg({
  props: e,
  name: r
}) {
  return im({
    props: e,
    name: r,
    defaultTheme: cc,
    themeId: Pa
  });
}
var Br = {}, so = { exports: {} }, Os;
function Og() {
  return Os || (Os = 1, function(e) {
    function r() {
      return e.exports = r = Object.assign ? Object.assign.bind() : function(t) {
        for (var n = 1; n < arguments.length; n++) {
          var o = arguments[n];
          for (var i in o)
            Object.prototype.hasOwnProperty.call(o, i) && (t[i] = o[i]);
        }
        return t;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, r.apply(this, arguments);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(so)), so.exports;
}
var ao = { exports: {} }, Ps;
function Pg() {
  return Ps || (Ps = 1, function(e) {
    function r(t, n) {
      if (t == null)
        return {};
      var o = {}, i = Object.keys(t), a, c;
      for (c = 0; c < i.length; c++)
        a = i[c], !(n.indexOf(a) >= 0) && (o[a] = t[a]);
      return o;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(ao)), ao.exports;
}
const kg = /* @__PURE__ */ wt(Lh), Cg = /* @__PURE__ */ wt(Yh), jg = /* @__PURE__ */ wt(Kh), Dg = /* @__PURE__ */ wt(nm), Rg = /* @__PURE__ */ wt(Wp), $g = /* @__PURE__ */ wt(Vp);
var mr = hr;
Object.defineProperty(Br, "__esModule", {
  value: !0
});
var Ng = Br.default = Kg, Ig = Br.shouldForwardProp = tn;
Br.systemDefaultTheme = void 0;
var Je = mr(Og()), So = mr(Pg()), ks = qg(kg), Ag = Cg, Fg = mr(jg), Wg = mr(Dg), Bg = mr(Rg), Lg = mr($g);
const Yg = ["ownerState"], Hg = ["variants"], zg = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function uc(e) {
  if (typeof WeakMap != "function")
    return null;
  var r = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (uc = function(n) {
    return n ? t : r;
  })(e);
}
function qg(e, r) {
  if (!r && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var t = uc(r);
  if (t && t.has(e))
    return t.get(e);
  var n = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var a = o ? Object.getOwnPropertyDescriptor(e, i) : null;
      a && (a.get || a.set) ? Object.defineProperty(n, i, a) : n[i] = e[i];
    }
  return n.default = e, t && t.set(e, n), n;
}
function Ug(e) {
  return Object.keys(e).length === 0;
}
function Vg(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function tn(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Gg = Br.systemDefaultTheme = (0, Bg.default)(), Cs = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function Kr({
  defaultTheme: e,
  theme: r,
  themeId: t
}) {
  return Ug(r) ? e : r[t] || r;
}
function Xg(e) {
  return e ? (r, t) => t[e] : null;
}
function rn(e, r) {
  let {
    ownerState: t
  } = r, n = (0, So.default)(r, Yg);
  const o = typeof e == "function" ? e((0, Je.default)({
    ownerState: t
  }, n)) : e;
  if (Array.isArray(o))
    return o.flatMap((i) => rn(i, (0, Je.default)({
      ownerState: t
    }, n)));
  if (o && typeof o == "object" && Array.isArray(o.variants)) {
    const {
      variants: i = []
    } = o;
    let c = (0, So.default)(o, Hg);
    return i.forEach((u) => {
      let l = !0;
      typeof u.props == "function" ? l = u.props((0, Je.default)({
        ownerState: t
      }, n, t)) : Object.keys(u.props).forEach((f) => {
        (t == null ? void 0 : t[f]) !== u.props[f] && n[f] !== u.props[f] && (l = !1);
      }), l && (Array.isArray(c) || (c = [c]), c.push(typeof u.style == "function" ? u.style((0, Je.default)({
        ownerState: t
      }, n, t)) : u.style));
    }), c;
  }
  return o;
}
function Kg(e = {}) {
  const {
    themeId: r,
    defaultTheme: t = Gg,
    rootShouldForwardProp: n = tn,
    slotShouldForwardProp: o = tn
  } = e, i = (a) => (0, Lg.default)((0, Je.default)({}, a, {
    theme: Kr((0, Je.default)({}, a, {
      defaultTheme: t,
      themeId: r
    }))
  }));
  return i.__mui_systemSx = !0, (a, c = {}) => {
    (0, ks.internal_processStyles)(a, (x) => x.filter((S) => !(S != null && S.__mui_systemSx)));
    const {
      name: u,
      slot: l,
      skipVariantsResolver: f,
      skipSx: d,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: h = Xg(Cs(l))
    } = c, y = (0, So.default)(c, zg), b = f !== void 0 ? f : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      l && l !== "Root" && l !== "root" || !1
    ), m = d || !1;
    let g;
    process.env.NODE_ENV !== "production" && u && (g = `${u}-${Cs(l || "Root")}`);
    let v = tn;
    l === "Root" || l === "root" ? v = n : l ? v = o : Vg(a) && (v = void 0);
    const _ = (0, ks.default)(a, (0, Je.default)({
      shouldForwardProp: v,
      label: g
    }, y)), T = (x) => typeof x == "function" && x.__emotion_real !== x || (0, Ag.isPlainObject)(x) ? (S) => rn(x, (0, Je.default)({}, S, {
      theme: Kr({
        theme: S.theme,
        defaultTheme: t,
        themeId: r
      })
    })) : x, w = (x, ...S) => {
      let P = T(x);
      const F = S ? S.map(T) : [];
      u && h && F.push((k) => {
        const C = Kr((0, Je.default)({}, k, {
          defaultTheme: t,
          themeId: r
        }));
        if (!C.components || !C.components[u] || !C.components[u].styleOverrides)
          return null;
        const B = C.components[u].styleOverrides, j = {};
        return Object.entries(B).forEach(([Q, ie]) => {
          j[Q] = rn(ie, (0, Je.default)({}, k, {
            theme: C
          }));
        }), h(k, j);
      }), u && !b && F.push((k) => {
        var C;
        const B = Kr((0, Je.default)({}, k, {
          defaultTheme: t,
          themeId: r
        })), j = B == null || (C = B.components) == null || (C = C[u]) == null ? void 0 : C.variants;
        return rn({
          variants: j
        }, (0, Je.default)({}, k, {
          theme: B
        }));
      }), m || F.push(i);
      const ee = F.length - S.length;
      if (Array.isArray(x) && ee > 0) {
        const k = new Array(ee).fill("");
        P = [...x, ...k], P.raw = [...x.raw, ...k];
      }
      const Y = _(P, ...F);
      if (process.env.NODE_ENV !== "production") {
        let k;
        u && (k = `${u}${(0, Fg.default)(l || "")}`), k === void 0 && (k = `Styled(${(0, Wg.default)(a)})`), Y.displayName = k;
      }
      return a.muiName && (Y.muiName = a.muiName), Y;
    };
    return _.withConfig && (w.withConfig = _.withConfig), w;
  };
}
const Qg = (e) => Ig(e) && e !== "classes", Jg = Ng({
  themeId: Pa,
  defaultTheme: cc,
  rootShouldForwardProp: Qg
}), ri = Jg, Zg = ua`
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
  `, e0 = ri(iu, {
  shouldForwardProp: (e) => e !== "backdropClicked"
})(({ backdropClicked: e }) => A({
  zIndex: 99999999,
  "& .MuiDialog-paper": {
    margin: "10px",
    width: "100%"
  },
  "&. MuiBackdrop-root": {
    backgroundColor: "rgba(68, 68, 68, 0.2)"
  }
}, e && {
  "& .MuiDialog-container": {
    animation: `${Zg} 0.5s linear`
  }
}));
function iv(u) {
  var l = u, {
    actions: e,
    content: r,
    open: t,
    title: n,
    isCenterTitle: o,
    onClose: i,
    onTransitionExited: a
  } = l, c = Se(l, [
    "actions",
    "content",
    "open",
    "title",
    "isCenterTitle",
    "onClose",
    "onTransitionExited"
  ]);
  const [f, d] = xe(!1), h = (y, b) => {
    b === "backdropClick" && (d(!0), setTimeout(() => {
      d(!1);
    }, 500)), Fe(i) && i();
  };
  return /* @__PURE__ */ s.jsx(En, { children: /* @__PURE__ */ s.jsxs(
    e0,
    ve(A({
      backdropClicked: f,
      open: t,
      onTransitionExited: a,
      maxWidth: "lg",
      onClose: h
    }, c), {
      children: [
        n && /* @__PURE__ */ s.jsx(su, { sx: { textAlign: o ? "center" : "left" }, children: n }),
        n && /* @__PURE__ */ s.jsx(dr, { sx: { borderColor: "gray" } }),
        /* @__PURE__ */ s.jsx(au, { children: r }),
        /* @__PURE__ */ s.jsx(cu, { children: e })
      ]
    })
  ) });
}
function D(e) {
  const r = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && r === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || r === "[object Number]" || typeof e == "string" || r === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function me(e, r) {
  return e instanceof Date ? new e.constructor(r) : new Date(r);
}
function Pt(e, r) {
  const t = D(e);
  return isNaN(r) ? me(e, NaN) : (r && t.setDate(t.getDate() + r), t);
}
function ni(e, r) {
  const t = +D(e);
  return me(e, t + r);
}
function t0(e, r) {
  return ni(e, r * 1e3);
}
const lc = 6048e5, r0 = 864e5, Lr = 6e4, Yr = 36e5, n0 = 1e3;
function o0(e, r) {
  return ni(e, r * Lr);
}
function i0(e, r) {
  return ni(e, r * Yr);
}
function s0(e, r) {
  const t = r * 7;
  return Pt(e, t);
}
function tr(e, r) {
  const t = D(e);
  if (isNaN(r))
    return me(e, NaN);
  if (!r)
    return t;
  const n = t.getDate(), o = me(e, t.getTime());
  o.setMonth(t.getMonth() + r + 1, 0);
  const i = o.getDate();
  return n >= i ? o : (t.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    n
  ), t);
}
function js(e, r) {
  return tr(e, r * 12);
}
function Sr(e, r) {
  const t = D(e), n = D(r), o = t.getTime() - n.getTime();
  return o < 0 ? -1 : o > 0 ? 1 : o;
}
function a0(e, r) {
  const t = D(e), n = D(r);
  return t.getFullYear() - n.getFullYear();
}
function c0(e, r) {
  const t = D(e), n = D(r), o = Sr(t, n), i = Math.abs(a0(t, n));
  t.setFullYear(1584), n.setFullYear(1584);
  const a = Sr(t, n) === -o, c = o * (i - +a);
  return c === 0 ? 0 : c;
}
function Hr(e) {
  return e ? Math[e] : Math.trunc;
}
function u0(e, r) {
  const t = D(e), n = D(r), o = t.getFullYear() - n.getFullYear(), i = t.getMonth() - n.getMonth();
  return o * 12 + i;
}
function Eo(e) {
  const r = D(e);
  return r.setHours(23, 59, 59, 999), r;
}
function Mo(e) {
  const r = D(e), t = r.getMonth();
  return r.setFullYear(r.getFullYear(), t + 1, 0), r.setHours(23, 59, 59, 999), r;
}
function l0(e) {
  const r = D(e);
  return +Eo(r) == +Mo(r);
}
function dc(e, r) {
  const t = D(e), n = D(r), o = Sr(t, n), i = Math.abs(
    u0(t, n)
  );
  let a;
  if (i < 1)
    a = 0;
  else {
    t.getMonth() === 1 && t.getDate() > 27 && t.setDate(30), t.setMonth(t.getMonth() - o * i);
    let c = Sr(t, n) === -o;
    l0(D(e)) && i === 1 && Sr(e, n) === 1 && (c = !1), a = o * (i - Number(c));
  }
  return a === 0 ? 0 : a;
}
function d0(e, r, t) {
  const n = dc(e, r) / 3;
  return Hr(t == null ? void 0 : t.roundingMethod)(n);
}
function Dr(e) {
  const r = D(e);
  return r.setHours(0, 0, 0, 0), r;
}
function dn(e) {
  const r = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return r.setUTCFullYear(e.getFullYear()), e.getTime() - r.getTime();
}
function fc(e, r) {
  const t = Dr(e), n = Dr(r), o = t.getTime() - dn(t), i = n.getTime() - dn(n);
  return Math.round((o - i) / r0);
}
function hc(e, r) {
  const t = D(e), n = D(r), o = Ds(t, n), i = Math.abs(fc(t, n));
  t.setDate(t.getDate() - o * i);
  const a = +(Ds(t, n) === -o), c = o * (i - a);
  return c === 0 ? 0 : c;
}
function Ds(e, r) {
  const t = e.getFullYear() - r.getFullYear() || e.getMonth() - r.getMonth() || e.getDate() - r.getDate() || e.getHours() - r.getHours() || e.getMinutes() - r.getMinutes() || e.getSeconds() - r.getSeconds() || e.getMilliseconds() - r.getMilliseconds();
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function f0(e, r, t) {
  const n = hc(e, r) / 7;
  return Hr(t == null ? void 0 : t.roundingMethod)(n);
}
function Fn(e, r) {
  return D(e).getTime() - D(r).getTime();
}
function h0(e, r, t) {
  const n = Fn(e, r) / Yr;
  return Hr(t == null ? void 0 : t.roundingMethod)(n);
}
function p0(e, r, t) {
  const n = Fn(e, r) / Lr;
  return Hr(t == null ? void 0 : t.roundingMethod)(n);
}
function m0(e, r, t) {
  const n = Fn(e, r) / 1e3;
  return Hr(t == null ? void 0 : t.roundingMethod)(n);
}
function g0(e, r) {
  var l;
  const t = D(e.start), n = D(e.end);
  let o = +t > +n;
  const i = o ? +t : +n, a = o ? n : t;
  a.setHours(0, 0, 0, 0);
  let c = (l = r == null ? void 0 : r.step) != null ? l : 1;
  if (!c)
    return [];
  c < 0 && (c = -c, o = !o);
  const u = [];
  for (; +a <= i; )
    u.push(D(a)), a.setDate(a.getDate() + c), a.setHours(0, 0, 0, 0);
  return o ? u.reverse() : u;
}
let y0 = {};
function Lt() {
  return y0;
}
function co(e, r) {
  var c, u, l, f, d, h, y, b;
  const t = Lt(), n = (b = (y = (f = (l = r == null ? void 0 : r.weekStartsOn) != null ? l : (u = (c = r == null ? void 0 : r.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) != null ? f : t.weekStartsOn) != null ? y : (h = (d = t.locale) == null ? void 0 : d.options) == null ? void 0 : h.weekStartsOn) != null ? b : 0, o = D(e), i = o.getDay(), a = (i < n ? -7 : 0) + 6 - (i - n);
  return o.setDate(o.getDate() + a), o.setHours(23, 59, 59, 999), o;
}
function uo(e) {
  const r = D(e), t = r.getFullYear();
  return r.setFullYear(t + 1, 0, 0), r.setHours(23, 59, 59, 999), r;
}
function b0(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function ut(e) {
  if (!b0(e) && typeof e != "number")
    return !1;
  const r = D(e);
  return !isNaN(Number(r));
}
const x0 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, v0 = (e, r, t) => {
  let n;
  const o = x0[e];
  return typeof o == "string" ? n = o : r === 1 ? n = o.one : n = o.other.replace("{{count}}", r.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + n : n + " ago" : n;
};
function rr(e) {
  return (r = {}) => {
    const t = r.width ? String(r.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const _0 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, w0 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, T0 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, S0 = {
  date: rr({
    formats: _0,
    defaultWidth: "full"
  }),
  time: rr({
    formats: w0,
    defaultWidth: "full"
  }),
  dateTime: rr({
    formats: T0,
    defaultWidth: "full"
  })
}, E0 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, M0 = (e, r, t, n) => E0[e];
function dt(e) {
  return (r, t) => {
    const n = t != null && t.context ? String(t.context) : "standalone";
    let o;
    if (n === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, c = t != null && t.width ? String(t.width) : a;
      o = e.formattingValues[c] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, c = t != null && t.width ? String(t.width) : e.defaultWidth;
      o = e.values[c] || e.values[a];
    }
    const i = e.argumentCallback ? e.argumentCallback(r) : r;
    return o[i];
  };
}
const O0 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, P0 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, k0 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, C0 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, j0 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, D0 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, R0 = (e, r) => {
  const t = Number(e), n = t % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, $0 = {
  ordinalNumber: R0,
  era: dt({
    values: O0,
    defaultWidth: "wide"
  }),
  quarter: dt({
    values: P0,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: dt({
    values: k0,
    defaultWidth: "wide"
  }),
  day: dt({
    values: C0,
    defaultWidth: "wide"
  }),
  dayPeriod: dt({
    values: j0,
    defaultWidth: "wide",
    formattingValues: D0,
    defaultFormattingWidth: "wide"
  })
};
function ft(e) {
  return (r, t = {}) => {
    const n = t.width, o = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = r.match(o);
    if (!i)
      return null;
    const a = i[0], c = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(c) ? I0(c, (d) => d.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      N0(c, (d) => d.test(a))
    );
    let l;
    l = e.valueCallback ? e.valueCallback(u) : u, l = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(l)
    ) : l;
    const f = r.slice(a.length);
    return { value: l, rest: f };
  };
}
function N0(e, r) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && r(e[t]))
      return t;
}
function I0(e, r) {
  for (let t = 0; t < e.length; t++)
    if (r(e[t]))
      return t;
}
function pc(e) {
  return (r, t = {}) => {
    const n = r.match(e.matchPattern);
    if (!n)
      return null;
    const o = n[0], i = r.match(e.parsePattern);
    if (!i)
      return null;
    let a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = t.valueCallback ? t.valueCallback(a) : a;
    const c = r.slice(o.length);
    return { value: a, rest: c };
  };
}
const A0 = /^(\d+)(th|st|nd|rd)?/i, F0 = /\d+/i, W0 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, B0 = {
  any: [/^b/i, /^(a|c)/i]
}, L0 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Y0 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, H0 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, z0 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, q0 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, U0 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, V0 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, G0 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, X0 = {
  ordinalNumber: pc({
    matchPattern: A0,
    parsePattern: F0,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ft({
    matchPatterns: W0,
    defaultMatchWidth: "wide",
    parsePatterns: B0,
    defaultParseWidth: "any"
  }),
  quarter: ft({
    matchPatterns: L0,
    defaultMatchWidth: "wide",
    parsePatterns: Y0,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ft({
    matchPatterns: H0,
    defaultMatchWidth: "wide",
    parsePatterns: z0,
    defaultParseWidth: "any"
  }),
  day: ft({
    matchPatterns: q0,
    defaultMatchWidth: "wide",
    parsePatterns: U0,
    defaultParseWidth: "any"
  }),
  dayPeriod: ft({
    matchPatterns: V0,
    defaultMatchWidth: "any",
    parsePatterns: G0,
    defaultParseWidth: "any"
  })
}, oi = {
  code: "en-US",
  formatDistance: v0,
  formatLong: S0,
  formatRelative: M0,
  localize: $0,
  match: X0,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function nn(e) {
  const r = D(e), t = me(e, 0);
  return t.setFullYear(r.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function K0(e) {
  const r = D(e);
  return fc(r, nn(r)) + 1;
}
function ct(e, r) {
  var c, u, l, f, d, h, y, b;
  const t = Lt(), n = (b = (y = (f = (l = r == null ? void 0 : r.weekStartsOn) != null ? l : (u = (c = r == null ? void 0 : r.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) != null ? f : t.weekStartsOn) != null ? y : (h = (d = t.locale) == null ? void 0 : d.options) == null ? void 0 : h.weekStartsOn) != null ? b : 0, o = D(e), i = o.getDay(), a = (i < n ? 7 : 0) + i - n;
  return o.setDate(o.getDate() - a), o.setHours(0, 0, 0, 0), o;
}
function cr(e) {
  return ct(e, { weekStartsOn: 1 });
}
function mc(e) {
  const r = D(e), t = r.getFullYear(), n = me(e, 0);
  n.setFullYear(t + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const o = cr(n), i = me(e, 0);
  i.setFullYear(t, 0, 4), i.setHours(0, 0, 0, 0);
  const a = cr(i);
  return r.getTime() >= o.getTime() ? t + 1 : r.getTime() >= a.getTime() ? t : t - 1;
}
function Q0(e) {
  const r = mc(e), t = me(e, 0);
  return t.setFullYear(r, 0, 4), t.setHours(0, 0, 0, 0), cr(t);
}
function gc(e) {
  const r = D(e), t = cr(r).getTime() - Q0(r).getTime();
  return Math.round(t / lc) + 1;
}
function ii(e, r) {
  var f, d, h, y, b, m, g, v;
  const t = D(e), n = t.getFullYear(), o = Lt(), i = (v = (g = (y = (h = r == null ? void 0 : r.firstWeekContainsDate) != null ? h : (d = (f = r == null ? void 0 : r.locale) == null ? void 0 : f.options) == null ? void 0 : d.firstWeekContainsDate) != null ? y : o.firstWeekContainsDate) != null ? g : (m = (b = o.locale) == null ? void 0 : b.options) == null ? void 0 : m.firstWeekContainsDate) != null ? v : 1, a = me(e, 0);
  a.setFullYear(n + 1, 0, i), a.setHours(0, 0, 0, 0);
  const c = ct(a, r), u = me(e, 0);
  u.setFullYear(n, 0, i), u.setHours(0, 0, 0, 0);
  const l = ct(u, r);
  return t.getTime() >= c.getTime() ? n + 1 : t.getTime() >= l.getTime() ? n : n - 1;
}
function J0(e, r) {
  var c, u, l, f, d, h, y, b;
  const t = Lt(), n = (b = (y = (f = (l = r == null ? void 0 : r.firstWeekContainsDate) != null ? l : (u = (c = r == null ? void 0 : r.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) != null ? f : t.firstWeekContainsDate) != null ? y : (h = (d = t.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) != null ? b : 1, o = ii(e, r), i = me(e, 0);
  return i.setFullYear(o, 0, n), i.setHours(0, 0, 0, 0), ct(i, r);
}
function si(e, r) {
  const t = D(e), n = ct(t, r).getTime() - J0(t, r).getTime();
  return Math.round(n / lc) + 1;
}
function J(e, r) {
  const t = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(r, "0");
  return t + n;
}
const Et = {
  // Year
  y(e, r) {
    const t = e.getFullYear(), n = t > 0 ? t : 1 - t;
    return J(r === "yy" ? n % 100 : n, r.length);
  },
  // Month
  M(e, r) {
    const t = e.getMonth();
    return r === "M" ? String(t + 1) : J(t + 1, 2);
  },
  // Day of the month
  d(e, r) {
    return J(e.getDate(), r.length);
  },
  // AM or PM
  a(e, r) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, r) {
    return J(e.getHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H(e, r) {
    return J(e.getHours(), r.length);
  },
  // Minute
  m(e, r) {
    return J(e.getMinutes(), r.length);
  },
  // Second
  s(e, r) {
    return J(e.getSeconds(), r.length);
  },
  // Fraction of second
  S(e, r) {
    const t = r.length, n = e.getMilliseconds(), o = Math.floor(
      n * Math.pow(10, t - 3)
    );
    return J(o, r.length);
  }
}, Kt = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Z0 = {
  // Era
  G: function(e, r, t) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(n, { width: "abbreviated" });
      case "GGGGG":
        return t.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, r, t) {
    if (r === "yo") {
      const n = e.getFullYear(), o = n > 0 ? n : 1 - n;
      return t.ordinalNumber(o, { unit: "year" });
    }
    return Et.y(e, r);
  },
  // Local week-numbering year
  Y: function(e, r, t, n) {
    const o = ii(e, n), i = o > 0 ? o : 1 - o;
    if (r === "YY") {
      const a = i % 100;
      return J(a, 2);
    }
    return r === "Yo" ? t.ordinalNumber(i, { unit: "year" }) : J(i, r.length);
  },
  // ISO week-numbering year
  R: function(e, r) {
    const t = mc(e);
    return J(t, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, r) {
    const t = e.getFullYear();
    return J(t, r.length);
  },
  // Quarter
  Q: function(e, r, t) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(n);
      case "QQ":
        return J(n, 2);
      case "Qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return t.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, r, t) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(n);
      case "qq":
        return J(n, 2);
      case "qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return t.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, r, t) {
    const n = e.getMonth();
    switch (r) {
      case "M":
      case "MM":
        return Et.M(e, r);
      case "Mo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return t.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, r, t) {
    const n = e.getMonth();
    switch (r) {
      case "L":
        return String(n + 1);
      case "LL":
        return J(n + 1, 2);
      case "Lo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return t.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, r, t, n) {
    const o = si(e, n);
    return r === "wo" ? t.ordinalNumber(o, { unit: "week" }) : J(o, r.length);
  },
  // ISO week of year
  I: function(e, r, t) {
    const n = gc(e);
    return r === "Io" ? t.ordinalNumber(n, { unit: "week" }) : J(n, r.length);
  },
  // Day of the month
  d: function(e, r, t) {
    return r === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : Et.d(e, r);
  },
  // Day of year
  D: function(e, r, t) {
    const n = K0(e);
    return r === "Do" ? t.ordinalNumber(n, { unit: "dayOfYear" }) : J(n, r.length);
  },
  // Day of week
  E: function(e, r, t) {
    const n = e.getDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, r, t, n) {
    const o = e.getDay(), i = (o - n.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(i);
      case "ee":
        return J(i, 2);
      case "eo":
        return t.ordinalNumber(i, { unit: "day" });
      case "eee":
        return t.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, r, t, n) {
    const o = e.getDay(), i = (o - n.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(i);
      case "cc":
        return J(i, r.length);
      case "co":
        return t.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return t.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, r, t) {
    const n = e.getDay(), o = n === 0 ? 7 : n;
    switch (r) {
      case "i":
        return String(o);
      case "ii":
        return J(o, r.length);
      case "io":
        return t.ordinalNumber(o, { unit: "day" });
      case "iii":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, r, t) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, r, t) {
    const n = e.getHours();
    let o;
    switch (n === 12 ? o = Kt.noon : n === 0 ? o = Kt.midnight : o = n / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, r, t) {
    const n = e.getHours();
    let o;
    switch (n >= 17 ? o = Kt.evening : n >= 12 ? o = Kt.afternoon : n >= 4 ? o = Kt.morning : o = Kt.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, r, t) {
    if (r === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), t.ordinalNumber(n, { unit: "hour" });
    }
    return Et.h(e, r);
  },
  // Hour [0-23]
  H: function(e, r, t) {
    return r === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : Et.H(e, r);
  },
  // Hour [0-11]
  K: function(e, r, t) {
    const n = e.getHours() % 12;
    return r === "Ko" ? t.ordinalNumber(n, { unit: "hour" }) : J(n, r.length);
  },
  // Hour [1-24]
  k: function(e, r, t) {
    let n = e.getHours();
    return n === 0 && (n = 24), r === "ko" ? t.ordinalNumber(n, { unit: "hour" }) : J(n, r.length);
  },
  // Minute
  m: function(e, r, t) {
    return r === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Et.m(e, r);
  },
  // Second
  s: function(e, r, t) {
    return r === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : Et.s(e, r);
  },
  // Fraction of second
  S: function(e, r) {
    return Et.S(e, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, r, t, n) {
    const i = (n._originalDate || e).getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (r) {
      case "X":
        return $s(i);
      case "XXXX":
      case "XX":
        return Rt(i);
      case "XXXXX":
      case "XXX":
      default:
        return Rt(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, r, t, n) {
    const i = (n._originalDate || e).getTimezoneOffset();
    switch (r) {
      case "x":
        return $s(i);
      case "xxxx":
      case "xx":
        return Rt(i);
      case "xxxxx":
      case "xxx":
      default:
        return Rt(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, r, t, n) {
    const i = (n._originalDate || e).getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Rs(i, ":");
      case "OOOO":
      default:
        return "GMT" + Rt(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, r, t, n) {
    const i = (n._originalDate || e).getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Rs(i, ":");
      case "zzzz":
      default:
        return "GMT" + Rt(i, ":");
    }
  },
  // Seconds timestamp
  t: function(e, r, t, n) {
    const o = n._originalDate || e, i = Math.floor(o.getTime() / 1e3);
    return J(i, r.length);
  },
  // Milliseconds timestamp
  T: function(e, r, t, n) {
    const i = (n._originalDate || e).getTime();
    return J(i, r.length);
  }
};
function Rs(e, r = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), o = Math.floor(n / 60), i = n % 60;
  return i === 0 ? t + String(o) : t + String(o) + r + J(i, 2);
}
function $s(e, r) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + J(Math.abs(e) / 60, 2) : Rt(e, r);
}
function Rt(e, r = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), o = J(Math.floor(n / 60), 2), i = J(n % 60, 2);
  return t + o + r + i;
}
const Ns = (e, r) => {
  switch (e) {
    case "P":
      return r.date({ width: "short" });
    case "PP":
      return r.date({ width: "medium" });
    case "PPP":
      return r.date({ width: "long" });
    case "PPPP":
    default:
      return r.date({ width: "full" });
  }
}, yc = (e, r) => {
  switch (e) {
    case "p":
      return r.time({ width: "short" });
    case "pp":
      return r.time({ width: "medium" });
    case "ppp":
      return r.time({ width: "long" });
    case "pppp":
    default:
      return r.time({ width: "full" });
  }
}, ey = (e, r) => {
  const t = e.match(/(P+)(p+)?/) || [], n = t[1], o = t[2];
  if (!o)
    return Ns(e, r);
  let i;
  switch (n) {
    case "P":
      i = r.dateTime({ width: "short" });
      break;
    case "PP":
      i = r.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = r.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = r.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Ns(n, r)).replace("{{time}}", yc(o, r));
}, Rr = {
  p: yc,
  P: ey
}, ty = /^D+$/, ry = /^Y+$/, ny = ["D", "DD", "YY", "YYYY"];
function bc(e) {
  return ty.test(e);
}
function xc(e) {
  return ry.test(e);
}
function fn(e, r, t) {
  const n = oy(e, r, t);
  if (console.warn(n), ny.includes(e))
    throw new RangeError(n);
}
function oy(e, r, t) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${r}\`) for formatting ${n} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const iy = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, sy = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ay = /^'([^]*?)'?$/, cy = /''/g, uy = /[a-zA-Z]/;
function Oo(e, r, t) {
  var f, d, h, y, b, m, g, v, _, T, w, x, S, P, F, ee, Y, k;
  const n = Lt(), o = (d = (f = t == null ? void 0 : t.locale) != null ? f : n.locale) != null ? d : oi, i = (T = (_ = (m = (b = t == null ? void 0 : t.firstWeekContainsDate) != null ? b : (y = (h = t == null ? void 0 : t.locale) == null ? void 0 : h.options) == null ? void 0 : y.firstWeekContainsDate) != null ? m : n.firstWeekContainsDate) != null ? _ : (v = (g = n.locale) == null ? void 0 : g.options) == null ? void 0 : v.firstWeekContainsDate) != null ? T : 1, a = (k = (Y = (P = (S = t == null ? void 0 : t.weekStartsOn) != null ? S : (x = (w = t == null ? void 0 : t.locale) == null ? void 0 : w.options) == null ? void 0 : x.weekStartsOn) != null ? P : n.weekStartsOn) != null ? Y : (ee = (F = n.locale) == null ? void 0 : F.options) == null ? void 0 : ee.weekStartsOn) != null ? k : 0, c = D(e);
  if (!ut(c))
    throw new RangeError("Invalid time value");
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: a,
    locale: o,
    _originalDate: c
  };
  return r.match(sy).map(function(C) {
    const B = C[0];
    if (B === "p" || B === "P") {
      const j = Rr[B];
      return j(C, o.formatLong);
    }
    return C;
  }).join("").match(iy).map(function(C) {
    if (C === "''")
      return "'";
    const B = C[0];
    if (B === "'")
      return ly(C);
    const j = Z0[B];
    if (j)
      return !(t != null && t.useAdditionalWeekYearTokens) && xc(C) && fn(C, r, String(e)), !(t != null && t.useAdditionalDayOfYearTokens) && bc(C) && fn(C, r, String(e)), j(
        c,
        C,
        o.localize,
        u
      );
    if (B.match(uy))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + B + "`"
      );
    return C;
  }).join("");
}
function ly(e) {
  const r = e.match(ay);
  return r ? r[1].replace(cy, "'") : e;
}
function dy(e) {
  return D(e).getDate();
}
function vc(e) {
  const r = D(e), t = r.getFullYear(), n = r.getMonth(), o = me(e, 0);
  return o.setFullYear(t, n + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function fy(e) {
  return D(e).getHours();
}
function hy(e) {
  return D(e).getMinutes();
}
function py(e) {
  return D(e).getMonth();
}
function my(e) {
  return D(e).getSeconds();
}
function gy(e) {
  return D(e).getMilliseconds();
}
function yy(e) {
  return D(e).getFullYear();
}
function nr(e, r) {
  const t = D(e), n = D(r);
  return t.getTime() > n.getTime();
}
function Ot(e, r) {
  const t = D(e), n = D(r);
  return +t < +n;
}
function by(e, r) {
  const t = D(e), n = D(r);
  return +t == +n;
}
function on(e, r) {
  const t = Dr(e), n = Dr(r);
  return +t == +n;
}
function xy(e, r) {
  const t = D(e), n = D(r);
  return t.getFullYear() === n.getFullYear();
}
function vy(e, r) {
  const t = D(e), n = D(r);
  return t.getFullYear() === n.getFullYear() && t.getMonth() === n.getMonth();
}
function Is(e) {
  const r = D(e);
  return r.setMinutes(0, 0, 0), r;
}
function _y(e, r) {
  const t = Is(e), n = Is(r);
  return +t == +n;
}
function wy() {
  return Object.assign({}, Lt());
}
function Ty(e, r) {
  const t = r instanceof Date ? me(r, 0) : new r(0);
  return t.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
const Sy = 10;
class _c {
  constructor() {
    N(this, "subPriority", 0);
  }
  validate(r, t) {
    return !0;
  }
}
class Ey extends _c {
  constructor(r, t, n, o, i) {
    super(), this.value = r, this.validateValue = t, this.setValue = n, this.priority = o, i && (this.subPriority = i);
  }
  validate(r, t) {
    return this.validateValue(r, this.value, t);
  }
  set(r, t, n) {
    return this.setValue(r, t, this.value, n);
  }
}
class My extends _c {
  constructor() {
    super(...arguments);
    N(this, "priority", Sy);
    N(this, "subPriority", -1);
  }
  set(t, n) {
    return n.timestampIsSet ? t : me(t, Ty(t, Date));
  }
}
class le {
  run(r, t, n, o) {
    const i = this.parse(r, t, n, o);
    return i ? {
      setter: new Ey(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(r, t, n) {
    return !0;
  }
}
class Oy extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 140);
    N(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return o.era(t, { width: "abbreviated" }) || o.era(t, { width: "narrow" });
      case "GGGGG":
        return o.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return o.era(t, { width: "wide" }) || o.era(t, { width: "abbreviated" }) || o.era(t, { width: "narrow" });
    }
  }
  set(t, n, o) {
    return n.era = o, t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const Ce = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, ht = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function je(e, r) {
  return e && {
    value: r(e.value),
    rest: e.rest
  };
}
function Te(e, r) {
  const t = r.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: r.slice(t[0].length)
  } : null;
}
function pt(e, r) {
  const t = r.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: r.slice(1)
    };
  const n = t[1] === "+" ? 1 : -1, o = t[2] ? parseInt(t[2], 10) : 0, i = t[3] ? parseInt(t[3], 10) : 0, a = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: n * (o * Yr + i * Lr + a * n0),
    rest: r.slice(t[0].length)
  };
}
function wc(e) {
  return Te(Ce.anyDigitsSigned, e);
}
function Pe(e, r) {
  switch (e) {
    case 1:
      return Te(Ce.singleDigit, r);
    case 2:
      return Te(Ce.twoDigits, r);
    case 3:
      return Te(Ce.threeDigits, r);
    case 4:
      return Te(Ce.fourDigits, r);
    default:
      return Te(new RegExp("^\\d{1," + e + "}"), r);
  }
}
function hn(e, r) {
  switch (e) {
    case 1:
      return Te(Ce.singleDigitSigned, r);
    case 2:
      return Te(Ce.twoDigitsSigned, r);
    case 3:
      return Te(Ce.threeDigitsSigned, r);
    case 4:
      return Te(Ce.fourDigitsSigned, r);
    default:
      return Te(new RegExp("^-?\\d{1," + e + "}"), r);
  }
}
function ai(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Tc(e, r) {
  const t = r > 0, n = t ? r : 1 - r;
  let o;
  if (n <= 50)
    o = e || 100;
  else {
    const i = n + 50, a = Math.floor(i / 100) * 100, c = e >= i % 100;
    o = e + a - (c ? 100 : 0);
  }
  return t ? o : 1 - o;
}
function Sc(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class Py extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 130);
    N(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, n, o) {
    const i = (a) => ({
      year: a,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return je(Pe(4, t), i);
      case "yo":
        return je(
          o.ordinalNumber(t, {
            unit: "year"
          }),
          i
        );
      default:
        return je(Pe(n.length, t), i);
    }
  }
  validate(t, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(t, n, o) {
    const i = t.getFullYear();
    if (o.isTwoDigitYear) {
      const c = Tc(
        o.year,
        i
      );
      return t.setFullYear(c, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const a = !("era" in n) || n.era === 1 ? o.year : 1 - o.year;
    return t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class ky extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 130);
    N(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    const i = (a) => ({
      year: a,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return je(Pe(4, t), i);
      case "Yo":
        return je(
          o.ordinalNumber(t, {
            unit: "year"
          }),
          i
        );
      default:
        return je(Pe(n.length, t), i);
    }
  }
  validate(t, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(t, n, o, i) {
    const a = ii(t, i);
    if (o.isTwoDigitYear) {
      const u = Tc(
        o.year,
        a
      );
      return t.setFullYear(
        u,
        0,
        i.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), ct(t, i);
    }
    const c = !("era" in n) || n.era === 1 ? o.year : 1 - o.year;
    return t.setFullYear(c, 0, i.firstWeekContainsDate), t.setHours(0, 0, 0, 0), ct(t, i);
  }
}
class Cy extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 130);
    N(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n) {
    return hn(n === "R" ? 4 : n.length, t);
  }
  set(t, n, o) {
    const i = me(t, 0);
    return i.setFullYear(o, 0, 4), i.setHours(0, 0, 0, 0), cr(i);
  }
}
class jy extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 130);
    N(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, n) {
    return hn(n === "u" ? 4 : n.length, t);
  }
  set(t, n, o) {
    return t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Dy extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 120);
    N(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "Q":
      case "QQ":
        return Pe(n.length, t);
      case "Qo":
        return o.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return o.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return o.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 4;
  }
  set(t, n, o) {
    return t.setMonth((o - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Ry extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 120);
    N(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "q":
      case "qq":
        return Pe(n.length, t);
      case "qo":
        return o.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return o.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return o.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 4;
  }
  set(t, n, o) {
    return t.setMonth((o - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class $y extends le {
  constructor() {
    super(...arguments);
    N(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    N(this, "priority", 110);
  }
  parse(t, n, o) {
    const i = (a) => a - 1;
    switch (n) {
      case "M":
        return je(
          Te(Ce.month, t),
          i
        );
      case "MM":
        return je(Pe(2, t), i);
      case "Mo":
        return je(
          o.ordinalNumber(t, {
            unit: "month"
          }),
          i
        );
      case "MMM":
        return o.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return o.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return o.month(t, { width: "wide", context: "formatting" }) || o.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, o) {
    return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Ny extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 110);
    N(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    const i = (a) => a - 1;
    switch (n) {
      case "L":
        return je(
          Te(Ce.month, t),
          i
        );
      case "LL":
        return je(Pe(2, t), i);
      case "Lo":
        return je(
          o.ordinalNumber(t, {
            unit: "month"
          }),
          i
        );
      case "LLL":
        return o.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return o.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return o.month(t, { width: "wide", context: "standalone" }) || o.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, o) {
    return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function Iy(e, r, t) {
  const n = D(e), o = si(n, t) - r;
  return n.setDate(n.getDate() - o * 7), n;
}
class Ay extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 100);
    N(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "w":
        return Te(Ce.week, t);
      case "wo":
        return o.ordinalNumber(t, { unit: "week" });
      default:
        return Pe(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 53;
  }
  set(t, n, o, i) {
    return ct(Iy(t, o, i), i);
  }
}
function Fy(e, r) {
  const t = D(e), n = gc(t) - r;
  return t.setDate(t.getDate() - n * 7), t;
}
class Wy extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 100);
    N(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "I":
        return Te(Ce.week, t);
      case "Io":
        return o.ordinalNumber(t, { unit: "week" });
      default:
        return Pe(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 53;
  }
  set(t, n, o) {
    return cr(Fy(t, o));
  }
}
const By = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Ly = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Yy extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 90);
    N(this, "subPriority", 1);
    N(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "d":
        return Te(Ce.date, t);
      case "do":
        return o.ordinalNumber(t, { unit: "date" });
      default:
        return Pe(n.length, t);
    }
  }
  validate(t, n) {
    const o = t.getFullYear(), i = Sc(o), a = t.getMonth();
    return i ? n >= 1 && n <= Ly[a] : n >= 1 && n <= By[a];
  }
  set(t, n, o) {
    return t.setDate(o), t.setHours(0, 0, 0, 0), t;
  }
}
class Hy extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 90);
    N(this, "subpriority", 1);
    N(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "D":
      case "DD":
        return Te(Ce.dayOfYear, t);
      case "Do":
        return o.ordinalNumber(t, { unit: "date" });
      default:
        return Pe(n.length, t);
    }
  }
  validate(t, n) {
    const o = t.getFullYear();
    return Sc(o) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(t, n, o) {
    return t.setMonth(0, o), t.setHours(0, 0, 0, 0), t;
  }
}
function ci(e, r, t) {
  var d, h, y, b, m, g, v, _;
  const n = Lt(), o = (_ = (v = (b = (y = t == null ? void 0 : t.weekStartsOn) != null ? y : (h = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : h.weekStartsOn) != null ? b : n.weekStartsOn) != null ? v : (g = (m = n.locale) == null ? void 0 : m.options) == null ? void 0 : g.weekStartsOn) != null ? _ : 0, i = D(e), a = i.getDay(), u = (r % 7 + 7) % 7, l = 7 - o, f = r < 0 || r > 6 ? r - (a + l) % 7 : (u + l) % 7 - (a + l) % 7;
  return Pt(i, f);
}
class zy extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 90);
    N(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return o.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return o.day(t, { width: "wide", context: "formatting" }) || o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, o, i) {
    return t = ci(t, o, i), t.setHours(0, 0, 0, 0), t;
  }
}
class qy extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 90);
    N(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o, i) {
    const a = (c) => {
      const u = Math.floor((c - 1) / 7) * 7;
      return (c + i.weekStartsOn + 6) % 7 + u;
    };
    switch (n) {
      case "e":
      case "ee":
        return je(Pe(n.length, t), a);
      case "eo":
        return je(
          o.ordinalNumber(t, {
            unit: "day"
          }),
          a
        );
      case "eee":
        return o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return o.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return o.day(t, { width: "wide", context: "formatting" }) || o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, o, i) {
    return t = ci(t, o, i), t.setHours(0, 0, 0, 0), t;
  }
}
class Uy extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 90);
    N(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, n, o, i) {
    const a = (c) => {
      const u = Math.floor((c - 1) / 7) * 7;
      return (c + i.weekStartsOn + 6) % 7 + u;
    };
    switch (n) {
      case "c":
      case "cc":
        return je(Pe(n.length, t), a);
      case "co":
        return je(
          o.ordinalNumber(t, {
            unit: "day"
          }),
          a
        );
      case "ccc":
        return o.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return o.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return o.day(t, { width: "wide", context: "standalone" }) || o.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, o, i) {
    return t = ci(t, o, i), t.setHours(0, 0, 0, 0), t;
  }
}
function Vy(e) {
  let t = D(e).getDay();
  return t === 0 && (t = 7), t;
}
function Gy(e, r) {
  const t = D(e), n = Vy(t), o = r - n;
  return Pt(t, o);
}
class Xy extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 90);
    N(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    const i = (a) => a === 0 ? 7 : a;
    switch (n) {
      case "i":
      case "ii":
        return Pe(n.length, t);
      case "io":
        return o.ordinalNumber(t, { unit: "day" });
      case "iii":
        return je(
          o.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiii":
        return je(
          o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiiii":
        return je(
          o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiii":
      default:
        return je(
          o.day(t, {
            width: "wide",
            context: "formatting"
          }) || o.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 7;
  }
  set(t, n, o) {
    return t = Gy(t, o), t.setHours(0, 0, 0, 0), t;
  }
}
class Ky extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 80);
    N(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, o) {
    return t.setHours(ai(o), 0, 0, 0), t;
  }
}
class Qy extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 80);
    N(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, o) {
    return t.setHours(ai(o), 0, 0, 0), t;
  }
}
class Jy extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 80);
    N(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, o) {
    return t.setHours(ai(o), 0, 0, 0), t;
  }
}
class Zy extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 70);
    N(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "h":
        return Te(Ce.hour12h, t);
      case "ho":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return Pe(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 12;
  }
  set(t, n, o) {
    const i = t.getHours() >= 12;
    return i && o < 12 ? t.setHours(o + 12, 0, 0, 0) : !i && o === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(o, 0, 0, 0), t;
  }
}
class eb extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 70);
    N(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "H":
        return Te(Ce.hour23h, t);
      case "Ho":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return Pe(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 23;
  }
  set(t, n, o) {
    return t.setHours(o, 0, 0, 0), t;
  }
}
class tb extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 70);
    N(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "K":
        return Te(Ce.hour11h, t);
      case "Ko":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return Pe(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, o) {
    return t.getHours() >= 12 && o < 12 ? t.setHours(o + 12, 0, 0, 0) : t.setHours(o, 0, 0, 0), t;
  }
}
class rb extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 70);
    N(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "k":
        return Te(Ce.hour24h, t);
      case "ko":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return Pe(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 24;
  }
  set(t, n, o) {
    const i = o <= 24 ? o % 24 : o;
    return t.setHours(i, 0, 0, 0), t;
  }
}
class nb extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 60);
    N(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "m":
        return Te(Ce.minute, t);
      case "mo":
        return o.ordinalNumber(t, { unit: "minute" });
      default:
        return Pe(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 59;
  }
  set(t, n, o) {
    return t.setMinutes(o, 0, 0), t;
  }
}
class ob extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 50);
    N(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "s":
        return Te(Ce.second, t);
      case "so":
        return o.ordinalNumber(t, { unit: "second" });
      default:
        return Pe(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 59;
  }
  set(t, n, o) {
    return t.setSeconds(o, 0), t;
  }
}
class ib extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 30);
    N(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, n) {
    const o = (i) => Math.floor(i * Math.pow(10, -n.length + 3));
    return je(Pe(n.length, t), o);
  }
  set(t, n, o) {
    return t.setMilliseconds(o), t;
  }
}
class sb extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 10);
    N(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, n) {
    switch (n) {
      case "X":
        return pt(
          ht.basicOptionalMinutes,
          t
        );
      case "XX":
        return pt(ht.basic, t);
      case "XXXX":
        return pt(
          ht.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return pt(
          ht.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return pt(ht.extended, t);
    }
  }
  set(t, n, o) {
    return n.timestampIsSet ? t : me(
      t,
      t.getTime() - dn(t) - o
    );
  }
}
class ab extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 10);
    N(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, n) {
    switch (n) {
      case "x":
        return pt(
          ht.basicOptionalMinutes,
          t
        );
      case "xx":
        return pt(ht.basic, t);
      case "xxxx":
        return pt(
          ht.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return pt(
          ht.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return pt(ht.extended, t);
    }
  }
  set(t, n, o) {
    return n.timestampIsSet ? t : me(
      t,
      t.getTime() - dn(t) - o
    );
  }
}
class cb extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 40);
    N(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return wc(t);
  }
  set(t, n, o) {
    return [me(t, o * 1e3), { timestampIsSet: !0 }];
  }
}
class ub extends le {
  constructor() {
    super(...arguments);
    N(this, "priority", 20);
    N(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return wc(t);
  }
  set(t, n, o) {
    return [me(t, o), { timestampIsSet: !0 }];
  }
}
const lb = {
  G: new Oy(),
  y: new Py(),
  Y: new ky(),
  R: new Cy(),
  u: new jy(),
  Q: new Dy(),
  q: new Ry(),
  M: new $y(),
  L: new Ny(),
  w: new Ay(),
  I: new Wy(),
  d: new Yy(),
  D: new Hy(),
  E: new zy(),
  e: new qy(),
  c: new Uy(),
  i: new Xy(),
  a: new Ky(),
  b: new Qy(),
  B: new Jy(),
  h: new Zy(),
  H: new eb(),
  K: new tb(),
  k: new rb(),
  m: new nb(),
  s: new ob(),
  S: new ib(),
  X: new sb(),
  x: new ab(),
  t: new cb(),
  T: new ub()
}, db = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, fb = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, hb = /^'([^]*?)'?$/, pb = /''/g, mb = /\S/, gb = /[a-zA-Z]/;
function Ec(e, r, t, n) {
  var m, g, v, _, T, w, x, S, P, F, ee, Y, k, C, B, j, Q, ie;
  const o = wy(), i = (g = (m = n == null ? void 0 : n.locale) != null ? m : o.locale) != null ? g : oi, a = (F = (P = (w = (T = n == null ? void 0 : n.firstWeekContainsDate) != null ? T : (_ = (v = n == null ? void 0 : n.locale) == null ? void 0 : v.options) == null ? void 0 : _.firstWeekContainsDate) != null ? w : o.firstWeekContainsDate) != null ? P : (S = (x = o.locale) == null ? void 0 : x.options) == null ? void 0 : S.firstWeekContainsDate) != null ? F : 1, c = (ie = (Q = (C = (k = n == null ? void 0 : n.weekStartsOn) != null ? k : (Y = (ee = n == null ? void 0 : n.locale) == null ? void 0 : ee.options) == null ? void 0 : Y.weekStartsOn) != null ? C : o.weekStartsOn) != null ? Q : (j = (B = o.locale) == null ? void 0 : B.options) == null ? void 0 : j.weekStartsOn) != null ? ie : 0;
  if (r === "")
    return e === "" ? D(t) : me(t, NaN);
  const u = {
    firstWeekContainsDate: a,
    weekStartsOn: c,
    locale: i
  }, l = [new My()], f = r.match(fb).map((H) => {
    const G = H[0];
    if (G in Rr) {
      const _e = Rr[G];
      return _e(H, i.formatLong);
    }
    return H;
  }).join("").match(db), d = [];
  for (let H of f) {
    !(n != null && n.useAdditionalWeekYearTokens) && xc(H) && fn(H, r, e), !(n != null && n.useAdditionalDayOfYearTokens) && bc(H) && fn(H, r, e);
    const G = H[0], _e = lb[G];
    if (_e) {
      const { incompatibleTokens: E } = _e;
      if (Array.isArray(E)) {
        const L = d.find(
          (I) => E.includes(I.token) || I.token === G
        );
        if (L)
          throw new RangeError(
            `The format string mustn't contain \`${L.fullToken}\` and \`${H}\` at the same time`
          );
      } else if (_e.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${H}\` and any other token at the same time`
        );
      d.push({ token: G, fullToken: H });
      const M = _e.run(
        e,
        H,
        i.match,
        u
      );
      if (!M)
        return me(t, NaN);
      l.push(M.setter), e = M.rest;
    } else {
      if (G.match(gb))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + G + "`"
        );
      if (H === "''" ? H = "'" : G === "'" && (H = yb(H)), e.indexOf(H) === 0)
        e = e.slice(H.length);
      else
        return me(t, NaN);
    }
  }
  if (e.length > 0 && mb.test(e))
    return me(t, NaN);
  const h = l.map((H) => H.priority).sort((H, G) => G - H).filter((H, G, _e) => _e.indexOf(H) === G).map(
    (H) => l.filter((G) => G.priority === H).sort((G, _e) => _e.subPriority - G.subPriority)
  ).map((H) => H[0]);
  let y = D(t);
  if (isNaN(y.getTime()))
    return me(t, NaN);
  const b = {};
  for (const H of h) {
    if (!H.validate(y, u))
      return me(t, NaN);
    const G = H.set(y, b, u);
    Array.isArray(G) ? (y = G[0], Object.assign(b, G[1])) : y = G;
  }
  return me(t, y);
}
function yb(e) {
  return e.match(hb)[1].replace(pb, "'");
}
function bb(e, r) {
  const t = D(e);
  return t.setDate(r), t;
}
function xb(e, r) {
  const t = D(e);
  return t.setHours(r), t;
}
function vb(e, r) {
  const t = D(e);
  return t.setMinutes(r), t;
}
function _b(e, r) {
  const t = D(e), n = t.getFullYear(), o = t.getDate(), i = me(e, 0);
  i.setFullYear(n, r, 15), i.setHours(0, 0, 0, 0);
  const a = vc(i);
  return t.setMonth(r, Math.min(o, a)), t;
}
function wb(e, r) {
  const t = D(e);
  return t.setSeconds(r), t;
}
function Tb(e, r) {
  const t = D(e);
  return t.setMilliseconds(r), t;
}
function Sb(e, r) {
  const t = D(e);
  return isNaN(+t) ? me(e, NaN) : (t.setFullYear(r), t);
}
function As(e) {
  const r = D(e);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function Eb(e, r) {
  var l, f;
  const t = D(e);
  if (isNaN(t.getTime()))
    throw new RangeError("Invalid time value");
  const n = (l = r == null ? void 0 : r.format) != null ? l : "extended", o = (f = r == null ? void 0 : r.representation) != null ? f : "complete";
  let i = "", a = "";
  const c = n === "extended" ? "-" : "", u = n === "extended" ? ":" : "";
  if (o !== "time") {
    const d = J(t.getDate(), 2), h = J(t.getMonth() + 1, 2);
    i = `${J(t.getFullYear(), 4)}${c}${h}${c}${d}`;
  }
  if (o !== "date") {
    const d = t.getTimezoneOffset();
    if (d !== 0) {
      const v = Math.abs(d), _ = J(Math.floor(v / 60), 2), T = J(v % 60, 2);
      a = `${d < 0 ? "+" : "-"}${_}:${T}`;
    } else
      a = "Z";
    const h = J(t.getHours(), 2), y = J(t.getMinutes(), 2), b = J(t.getSeconds(), 2), m = i === "" ? "" : "T", g = [h, y, b].join(u);
    i = `${i}${m}${g}${a}`;
  }
  return i;
}
function Mb(e, r) {
  var u;
  const t = (u = r == null ? void 0 : r.additionalDigits) != null ? u : 2, n = Cb(e);
  let o;
  if (n.date) {
    const l = jb(n.date, t);
    o = Db(l.restDateString, l.year);
  }
  if (!o || isNaN(o.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const i = o.getTime();
  let a = 0, c;
  if (n.time && (a = Rb(n.time), isNaN(a)))
    return /* @__PURE__ */ new Date(NaN);
  if (n.timezone) {
    if (c = $b(n.timezone), isNaN(c))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const l = new Date(i + a), f = /* @__PURE__ */ new Date(0);
    return f.setFullYear(
      l.getUTCFullYear(),
      l.getUTCMonth(),
      l.getUTCDate()
    ), f.setHours(
      l.getUTCHours(),
      l.getUTCMinutes(),
      l.getUTCSeconds(),
      l.getUTCMilliseconds()
    ), f;
  }
  return new Date(i + a + c);
}
const Qr = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Ob = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Pb = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, kb = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Cb(e) {
  const r = {}, t = e.split(Qr.dateTimeDelimiter);
  let n;
  if (t.length > 2)
    return r;
  if (/:/.test(t[0]) ? n = t[0] : (r.date = t[0], n = t[1], Qr.timeZoneDelimiter.test(r.date) && (r.date = e.split(Qr.timeZoneDelimiter)[0], n = e.substr(
    r.date.length,
    e.length
  ))), n) {
    const o = Qr.timezone.exec(n);
    o ? (r.time = n.replace(o[1], ""), r.timezone = o[1]) : r.time = n;
  }
  return r;
}
function jb(e, r) {
  const t = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + r) + "})|(\\d{2}|[+-]\\d{" + (2 + r) + "})$)"
  ), n = e.match(t);
  if (!n)
    return { year: NaN, restDateString: "" };
  const o = n[1] ? parseInt(n[1]) : null, i = n[2] ? parseInt(n[2]) : null;
  return {
    year: i === null ? o : i * 100,
    restDateString: e.slice((n[1] || n[2]).length)
  };
}
function Db(e, r) {
  if (r === null)
    return /* @__PURE__ */ new Date(NaN);
  const t = e.match(Ob);
  if (!t)
    return /* @__PURE__ */ new Date(NaN);
  const n = !!t[4], o = wr(t[1]), i = wr(t[2]) - 1, a = wr(t[3]), c = wr(t[4]), u = wr(t[5]) - 1;
  if (n)
    return Wb(r, c, u) ? Nb(r, c, u) : /* @__PURE__ */ new Date(NaN);
  {
    const l = /* @__PURE__ */ new Date(0);
    return !Ab(r, i, a) || !Fb(r, o) ? /* @__PURE__ */ new Date(NaN) : (l.setUTCFullYear(r, i, Math.max(o, a)), l);
  }
}
function wr(e) {
  return e ? parseInt(e) : 1;
}
function Rb(e) {
  const r = e.match(Pb);
  if (!r)
    return NaN;
  const t = lo(r[1]), n = lo(r[2]), o = lo(r[3]);
  return Bb(t, n, o) ? t * Yr + n * Lr + o * 1e3 : NaN;
}
function lo(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function $b(e) {
  if (e === "Z")
    return 0;
  const r = e.match(kb);
  if (!r)
    return 0;
  const t = r[1] === "+" ? -1 : 1, n = parseInt(r[2]), o = r[3] && parseInt(r[3]) || 0;
  return Lb(n, o) ? t * (n * Yr + o * Lr) : NaN;
}
function Nb(e, r, t) {
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  const o = n.getUTCDay() || 7, i = (r - 1) * 7 + t + 1 - o;
  return n.setUTCDate(n.getUTCDate() + i), n;
}
const Ib = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Mc(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Ab(e, r, t) {
  return r >= 0 && r <= 11 && t >= 1 && t <= (Ib[r] || (Mc(e) ? 29 : 28));
}
function Fb(e, r) {
  return r >= 1 && r <= (Mc(e) ? 366 : 365);
}
function Wb(e, r, t) {
  return r >= 1 && r <= 53 && t >= 0 && t <= 6;
}
function Bb(e, r, t) {
  return e === 24 ? r === 0 && t === 0 : t >= 0 && t < 60 && r >= 0 && r < 60 && e >= 0 && e < 25;
}
function Lb(e, r) {
  return r >= 0 && r <= 59;
}
function Oc(e, r) {
  const t = +D(e), [n, o] = [
    +D(r.start),
    +D(r.end)
  ].sort((i, a) => i - a);
  return t >= n && t <= o;
}
const Yb = {
  // Year
  y: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yy: "year",
  yyy: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yyyy: "year",
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  L: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  LL: "month",
  LLL: {
    sectionType: "month",
    contentType: "letter"
  },
  LLLL: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  d: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  dd: "day",
  do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  E: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  i: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ii: "weekDay",
  iii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  iiii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  e: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ee: "weekDay",
  eee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  c: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  cc: "weekDay",
  ccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  a: "meridiem",
  aa: "meridiem",
  aaa: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
}, Hb = {
  year: "yyyy",
  month: "LLLL",
  monthShort: "MMM",
  dayOfMonth: "d",
  weekday: "EEEE",
  weekdayShort: "EEEEEE",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "aa",
  minutes: "mm",
  seconds: "ss",
  fullDate: "PP",
  fullDateWithWeekday: "PPPP",
  keyboardDate: "P",
  shortDate: "MMM d",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  monthAndYear: "LLLL yyyy",
  monthAndDate: "MMMM d",
  fullTime: "p",
  fullTime12h: "hh:mm aa",
  fullTime24h: "HH:mm",
  fullDateTime: "PP p",
  fullDateTime12h: "PP hh:mm aa",
  fullDateTime24h: "PP HH:mm",
  keyboardDateTime: "P p",
  keyboardDateTime12h: "P hh:mm aa",
  keyboardDateTime24h: "P HH:mm"
};
class zb {
  constructor(r) {
    this.isMUIAdapter = !0, this.isTimezoneCompatible = !1, this.lib = "date-fns", this.locale = void 0, this.formats = void 0, this.formatTokenMap = Yb, this.escapedCharacters = {
      start: "'",
      end: "'"
    }, this.longFormatters = void 0, this.date = (i) => typeof i == "undefined" ? /* @__PURE__ */ new Date() : i === null ? null : new Date(i), this.dateWithTimezone = (i) => this.date(i), this.getTimezone = () => "default", this.setTimezone = (i) => i, this.toJsDate = (i) => i, this.getCurrentLocaleCode = () => {
      var i;
      return ((i = this.locale) == null ? void 0 : i.code) || "en-US";
    }, this.is12HourCycleInCurrentLocale = () => this.locale ? /a/.test(this.locale.formatLong.time({
      width: "short"
    })) : !0, this.expandFormat = (i) => {
      const a = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      return i.match(a).map((c) => {
        const u = c[0];
        if (u === "p" || u === "P") {
          const l = this.longFormatters[u];
          return l(c, this.locale.formatLong);
        }
        return c;
      }).join("");
    }, this.getFormatHelperText = (i) => this.expandFormat(i).replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase(), this.isNull = (i) => i === null, this.formatNumber = (i) => i, this.getMeridiemText = (i) => i === "am" ? "AM" : "PM";
    const {
      locale: t,
      formats: n,
      longFormatters: o
    } = r;
    this.locale = t, this.formats = ge({}, Hb, n), this.longFormatters = o;
  }
}
class qb extends zb {
  constructor({
    locale: r,
    formats: t
  } = {}) {
    if (typeof Pt != "function")
      throw new Error(["MUI: The `date-fns` package v2.x is not compatible with this adapter.", "Please, install v3.x of the package or use the `AdapterDateFns` instead."].join(`
`));
    if (!Rr)
      throw new Error("MUI: The minimum supported `date-fns` package version compatible with this adapter is `3.2.x`.");
    super({
      locale: r != null ? r : oi,
      formats: t,
      longFormatters: Rr
    }), this.parseISO = (n) => Mb(n), this.toISO = (n) => Eb(n, {
      format: "extended"
    }), this.parse = (n, o) => n === "" ? null : Ec(n, o, /* @__PURE__ */ new Date(), {
      locale: this.locale
    }), this.isValid = (n) => ut(this.date(n)), this.format = (n, o) => this.formatByString(n, this.formats[o]), this.formatByString = (n, o) => Oo(n, o, {
      locale: this.locale
    }), this.getDiff = (n, o, i) => {
      switch (i) {
        case "years":
          return c0(n, this.date(o));
        case "quarters":
          return d0(n, this.date(o));
        case "months":
          return dc(n, this.date(o));
        case "weeks":
          return f0(n, this.date(o));
        case "days":
          return hc(n, this.date(o));
        case "hours":
          return h0(n, this.date(o));
        case "minutes":
          return p0(n, this.date(o));
        case "seconds":
          return m0(n, this.date(o));
        default:
          return Fn(n, this.date(o));
      }
    }, this.isEqual = (n, o) => n === null && o === null ? !0 : by(n, o), this.isSameYear = (n, o) => xy(n, o), this.isSameMonth = (n, o) => vy(n, o), this.isSameDay = (n, o) => on(n, o), this.isSameHour = (n, o) => _y(n, o), this.isAfter = (n, o) => nr(n, o), this.isAfterYear = (n, o) => nr(n, uo(o)), this.isAfterDay = (n, o) => nr(n, Eo(o)), this.isBefore = (n, o) => Ot(n, o), this.isBeforeYear = (n, o) => Ot(n, this.startOfYear(o)), this.isBeforeDay = (n, o) => Ot(n, this.startOfDay(o)), this.isWithinRange = (n, [o, i]) => Oc(n, {
      start: o,
      end: i
    }), this.startOfYear = (n) => nn(n), this.startOfMonth = (n) => As(n), this.startOfWeek = (n) => ct(n, {
      locale: this.locale
    }), this.startOfDay = (n) => Dr(n), this.endOfYear = (n) => uo(n), this.endOfMonth = (n) => Mo(n), this.endOfWeek = (n) => co(n, {
      locale: this.locale
    }), this.endOfDay = (n) => Eo(n), this.addYears = (n, o) => js(n, o), this.addMonths = (n, o) => tr(n, o), this.addWeeks = (n, o) => s0(n, o), this.addDays = (n, o) => Pt(n, o), this.addHours = (n, o) => i0(n, o), this.addMinutes = (n, o) => o0(n, o), this.addSeconds = (n, o) => t0(n, o), this.getYear = (n) => yy(n), this.getMonth = (n) => py(n), this.getDate = (n) => dy(n), this.getHours = (n) => fy(n), this.getMinutes = (n) => hy(n), this.getSeconds = (n) => my(n), this.getMilliseconds = (n) => gy(n), this.setYear = (n, o) => Sb(n, o), this.setMonth = (n, o) => _b(n, o), this.setDate = (n, o) => bb(n, o), this.setHours = (n, o) => xb(n, o), this.setMinutes = (n, o) => vb(n, o), this.setSeconds = (n, o) => wb(n, o), this.setMilliseconds = (n, o) => Tb(n, o), this.getDaysInMonth = (n) => vc(n), this.getNextMonth = (n) => tr(n, 1), this.getPreviousMonth = (n) => tr(n, -1), this.getMonthArray = (n) => {
      const i = [nn(n)];
      for (; i.length < 12; ) {
        const a = i[i.length - 1];
        i.push(this.getNextMonth(a));
      }
      return i;
    }, this.mergeDateAndTime = (n, o) => this.setSeconds(this.setMinutes(this.setHours(n, this.getHours(o)), this.getMinutes(o)), this.getSeconds(o)), this.getWeekdays = () => {
      const n = /* @__PURE__ */ new Date();
      return g0({
        start: ct(n, {
          locale: this.locale
        }),
        end: co(n, {
          locale: this.locale
        })
      }).map((o) => this.formatByString(o, "EEEEEE"));
    }, this.getWeekArray = (n) => {
      const o = ct(As(n), {
        locale: this.locale
      }), i = co(Mo(n), {
        locale: this.locale
      });
      let a = 0, c = o;
      const u = [];
      for (; Ot(c, i); ) {
        const l = Math.floor(a / 7);
        u[l] = u[l] || [], u[l].push(c), c = Pt(c, 1), a += 1;
      }
      return u;
    }, this.getWeekNumber = (n) => si(n, {
      locale: this.locale
    }), this.getYearRange = (n, o) => {
      const i = nn(n), a = uo(o), c = [];
      let u = i;
      for (; Ot(u, a); )
        c.push(u), u = js(u, 1);
      return c;
    };
  }
}
const Ub = {
  lessThanXSeconds: {
    one: "1秒未満",
    other: "{{count}}秒未満",
    oneWithSuffix: "約1秒",
    otherWithSuffix: "約{{count}}秒"
  },
  xSeconds: {
    one: "1秒",
    other: "{{count}}秒"
  },
  halfAMinute: "30秒",
  lessThanXMinutes: {
    one: "1分未満",
    other: "{{count}}分未満",
    oneWithSuffix: "約1分",
    otherWithSuffix: "約{{count}}分"
  },
  xMinutes: {
    one: "1分",
    other: "{{count}}分"
  },
  aboutXHours: {
    one: "約1時間",
    other: "約{{count}}時間"
  },
  xHours: {
    one: "1時間",
    other: "{{count}}時間"
  },
  xDays: {
    one: "1日",
    other: "{{count}}日"
  },
  aboutXWeeks: {
    one: "約1週間",
    other: "約{{count}}週間"
  },
  xWeeks: {
    one: "1週間",
    other: "{{count}}週間"
  },
  aboutXMonths: {
    one: "約1か月",
    other: "約{{count}}か月"
  },
  xMonths: {
    one: "1か月",
    other: "{{count}}か月"
  },
  aboutXYears: {
    one: "約1年",
    other: "約{{count}}年"
  },
  xYears: {
    one: "1年",
    other: "{{count}}年"
  },
  overXYears: {
    one: "1年以上",
    other: "{{count}}年以上"
  },
  almostXYears: {
    one: "1年近く",
    other: "{{count}}年近く"
  }
}, Vb = (e, r, t) => {
  t = t || {};
  let n;
  const o = Ub[e];
  return typeof o == "string" ? n = o : r === 1 ? t.addSuffix && o.oneWithSuffix ? n = o.oneWithSuffix : n = o.one : t.addSuffix && o.otherWithSuffix ? n = o.otherWithSuffix.replace("{{count}}", String(r)) : n = o.other.replace("{{count}}", String(r)), t.addSuffix ? t.comparison && t.comparison > 0 ? n + "後" : n + "前" : n;
}, Gb = {
  full: "y年M月d日EEEE",
  long: "y年M月d日",
  medium: "y/MM/dd",
  short: "y/MM/dd"
}, Xb = {
  full: "H時mm分ss秒 zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, Kb = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Qb = {
  date: rr({
    formats: Gb,
    defaultWidth: "full"
  }),
  time: rr({
    formats: Xb,
    defaultWidth: "full"
  }),
  dateTime: rr({
    formats: Kb,
    defaultWidth: "full"
  })
}, Jb = {
  lastWeek: "先週のeeeeのp",
  yesterday: "昨日のp",
  today: "今日のp",
  tomorrow: "明日のp",
  nextWeek: "翌週のeeeeのp",
  other: "P"
}, Zb = (e, r, t, n) => Jb[e], ex = {
  narrow: ["BC", "AC"],
  abbreviated: ["紀元前", "西暦"],
  wide: ["紀元前", "西暦"]
}, tx = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["第1四半期", "第2四半期", "第3四半期", "第4四半期"]
}, rx = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ],
  wide: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ]
}, nx = {
  narrow: ["日", "月", "火", "水", "木", "金", "土"],
  short: ["日", "月", "火", "水", "木", "金", "土"],
  abbreviated: ["日", "月", "火", "水", "木", "金", "土"],
  wide: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"]
}, ox = {
  narrow: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  abbreviated: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  wide: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  }
}, ix = {
  narrow: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  abbreviated: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  wide: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  }
}, sx = (e, r) => {
  const t = Number(e);
  switch (String(r == null ? void 0 : r.unit)) {
    case "year":
      return `${t}年`;
    case "quarter":
      return `第${t}四半期`;
    case "month":
      return `${t}月`;
    case "week":
      return `第${t}週`;
    case "date":
      return `${t}日`;
    case "hour":
      return `${t}時`;
    case "minute":
      return `${t}分`;
    case "second":
      return `${t}秒`;
    default:
      return `${t}`;
  }
}, ax = {
  ordinalNumber: sx,
  era: dt({
    values: ex,
    defaultWidth: "wide"
  }),
  quarter: dt({
    values: tx,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: dt({
    values: rx,
    defaultWidth: "wide"
  }),
  day: dt({
    values: nx,
    defaultWidth: "wide"
  }),
  dayPeriod: dt({
    values: ox,
    defaultWidth: "wide",
    formattingValues: ix,
    defaultFormattingWidth: "wide"
  })
}, cx = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i, ux = /\d+/i, lx = {
  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
  abbreviated: /^(紀元[前後]|西暦)/i,
  wide: /^(紀元[前後]|西暦)/i
}, dx = {
  narrow: [/^B/i, /^A/i],
  any: [/^(紀元前)/i, /^(西暦|紀元後)/i]
}, fx = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^第[1234一二三四１２３４]四半期/i
}, hx = {
  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
}, px = {
  narrow: /^([123456789]|1[012])/,
  abbreviated: /^([123456789]|1[012])月/i,
  wide: /^([123456789]|1[012])月/i
}, mx = {
  any: [
    /^1\D/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/
  ]
}, gx = {
  narrow: /^[日月火水木金土]/,
  short: /^[日月火水木金土]/,
  abbreviated: /^[日月火水木金土]/,
  wide: /^[日月火水木金土]曜日/
}, yx = {
  any: [/^日/, /^月/, /^火/, /^水/, /^木/, /^金/, /^土/]
}, bx = {
  any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
}, xx = {
  any: {
    am: /^(A|午前)/i,
    pm: /^(P|午後)/i,
    midnight: /^深夜|真夜中/i,
    noon: /^正午/i,
    morning: /^朝/i,
    afternoon: /^午後/i,
    evening: /^夜/i,
    night: /^深夜/i
  }
}, vx = {
  ordinalNumber: pc({
    matchPattern: cx,
    parsePattern: ux,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: ft({
    matchPatterns: lx,
    defaultMatchWidth: "wide",
    parsePatterns: dx,
    defaultParseWidth: "any"
  }),
  quarter: ft({
    matchPatterns: fx,
    defaultMatchWidth: "wide",
    parsePatterns: hx,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ft({
    matchPatterns: px,
    defaultMatchWidth: "wide",
    parsePatterns: mx,
    defaultParseWidth: "any"
  }),
  day: ft({
    matchPatterns: gx,
    defaultMatchWidth: "wide",
    parsePatterns: yx,
    defaultParseWidth: "any"
  }),
  dayPeriod: ft({
    matchPatterns: bx,
    defaultMatchWidth: "any",
    parsePatterns: xx,
    defaultParseWidth: "any"
  })
}, _x = {
  code: "ja",
  formatDistance: Vb,
  formatLong: Qb,
  formatRelative: Zb,
  localize: ax,
  match: vx,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, wx = () => ({
  ".MuiDateCalendar-root": {
    width: "220px",
    height: "210px"
  },
  ".MuiPickersCalendarHeader-root": {
    margin: 0,
    backgroundColor: "#e9e9e9",
    border: "1px solid #dddddd",
    borderRadius: "4px",
    ".MuiPickersCalendarHeader-label": {
      color: "#333",
      fontWeight: "bold",
      pointerEvents: "none",
      cursor: "none"
    },
    ".MuiPickersCalendarHeader-labelContainer": {
      fontFamily: "Hiragino Kaku Gothic ProN",
      position: "relative",
      left: "45px"
    },
    ".MuiPickersArrowSwitcher-root button:first-of-type": {
      position: "relative",
      right: " 115px"
    }
  },
  "&&.MuiPickersLayout-root": {
    padding: "4px",
    ".MuiDayCalendar-header": {
      backgroundColor: ""
    },
    ".MuiPickersDay-dayWithMargin": {
      color: "#454545",
      margin: "1px",
      fontFamily: "Hiragino Kaku Gothic ProN",
      boxSizing: "border-box",
      border: "1px solid #c5c5c5",
      backgroundColor: "#f6f6f6",
      borderRadius: 0,
      width: 29,
      height: 21
    },
    ".MuiPickersDay-dayWithMargin.Mui-disabled:not(.Mui-selected)": {
      color: "rgba(0, 0, 0, 0.38)"
    },
    ".MuiDayCalendar-weekDayLabel": {
      marginTop: "5px",
      marginRight: "1px",
      marginLeft: "1px",
      fontSize: "14px",
      width: 29,
      height: 21,
      color: "#333",
      fontWeight: "bold"
    },
    ".MuiPickersDay-today": {
      color: "#777620",
      backgroundColor: "#fffa90"
    },
    ".Mui-selected": {
      color: "#fff",
      backgroundColor: "#007fff"
    }
  }
}), Tx = (e) => ({
  height: "40px",
  borderRadius: "2px",
  width: e || 170,
  "& .MuiOutlinedInput-notchedOutline": {
    border: "1px solid #7C7C7C"
  },
  backgroundColor: "#ffffff",
  "&.Mui-error": { backgroundColor: "#FFD2C2" },
  "&.Mui-disabled": { backgroundColor: "#eee" },
  "& .MuiInputBase-input": {
    boxSizing: "border-box",
    height: "40px"
  }
}), Po = ze(function(f, l) {
  var d = f, {
    disabled: r,
    error: t,
    helperText: n,
    label: o,
    isRequired: i,
    width: a,
    isDisabledTextInput: c = !0
  } = d, u = Se(d, [
    "disabled",
    "error",
    "helperText",
    "label",
    "isRequired",
    "width",
    "isDisabledTextInput"
  ]);
  const [h, y] = xe(!1);
  return /* @__PURE__ */ s.jsx(Ct, { label: o, isRequired: i, children: /* @__PURE__ */ s.jsx(
    wu,
    {
      dateAdapter: qb,
      dateFormats: { monthAndYear: "yyyy / M" },
      adapterLocale: _x,
      localeText: {
        previousMonth: "前月を表示",
        nextMonth: "次月を表示"
      },
      children: /* @__PURE__ */ s.jsx(
        Tu,
        ve(A({}, u), {
          closeOnSelect: !0,
          format: "yyyy/MM/dd",
          ref: l,
          open: h,
          views: ["day"],
          onClose: () => y(!1),
          disabled: r,
          slotProps: {
            popper: { sx: { zIndex: at.FORM_LAYOUT } },
            calendarHeader: { reduceAnimations: !0 },
            field: { readOnly: c },
            textField: {
              error: t,
              helperText: n,
              FormHelperTextProps: {
                sx: { marginLeft: 0 }
              },
              InputProps: {
                onClick: () => !r && y(!h),
                endAdornment: null,
                sx: Tx(a)
              }
            },
            switchViewButton: {
              sx: { display: "none" }
            },
            layout: {
              sx: wx
            }
          }
        })
      )
    }
  ) });
});
Po.displayName = "SPDatePicker";
function fo(e, r) {
  const {
    years: t = 0,
    months: n = 0,
    weeks: o = 0,
    days: i = 0,
    hours: a = 0,
    minutes: c = 0,
    seconds: u = 0
  } = r, l = D(e), f = n || t ? tr(l, n + t * 12) : l, d = i || o ? Pt(f, i + o * 7) : f, h = c + a * 60, b = (u + h * 60) * 1e3;
  return me(e, d.getTime() + b);
}
function Sx(e, r, t) {
  return ut(Ec(e, r, /* @__PURE__ */ new Date(), t));
}
function Ex(e, r) {
  return Pt(e, -r);
}
function Mx(e, r) {
  return tr(e, -r);
}
function Ox(e, r) {
  const {
    years: t = 0,
    months: n = 0,
    weeks: o = 0,
    days: i = 0,
    hours: a = 0,
    minutes: c = 0,
    seconds: u = 0
  } = r, l = Mx(e, n + t * 12), f = Ex(l, i + o * 7), d = c + a * 60, y = (u + d * 60) * 1e3;
  return me(e, f.getTime() - y);
}
const Px = ri(De)({
  fontSize: "18px",
  minWidth: "24px",
  textAlign: "center",
  lineHeight: "40px"
}), kx = ze(function(l, u) {
  var f = l, {
    helperText: r,
    isRequired: t,
    label: n,
    value: o,
    onChange: i,
    maxDuration: a
  } = f, c = Se(f, [
    "helperText",
    "isRequired",
    "label",
    "value",
    "onChange",
    "maxDuration"
  ]);
  const [d, h] = xe(Ki(o, 0)), [y, b] = xe(Ki(o, 1));
  return sn(() => {
    Fe(i) && i([d, y]);
  }, [d, y]), /* @__PURE__ */ s.jsx(Ct, { label: n, isRequired: t, children: /* @__PURE__ */ s.jsxs(nt, { error: c == null ? void 0 : c.error, children: [
    /* @__PURE__ */ s.jsxs(De, { sx: { display: "flex" }, children: [
      /* @__PURE__ */ s.jsx(
        Po,
        A({
          value: d,
          onChange: (m) => {
            if (h(m), Ot(y, m))
              b(m);
            else if (a) {
              const g = fo(fo(m, a), {
                days: -1
              });
              nr(y, g) && b(g);
            }
          }
        }, c)
      ),
      /* @__PURE__ */ s.jsx(Px, { children: "-" }),
      /* @__PURE__ */ s.jsx(
        Po,
        A({
          value: y,
          onChange: (m) => {
            if (b(m), nr(d, m))
              h(m);
            else if (a) {
              const g = fo(Ox(m, a), {
                days: 1
              });
              Ot(d, g) && h(g);
            }
          }
        }, c)
      )
    ] }),
    r && /* @__PURE__ */ s.jsx(ot, { sx: { marginLeft: 0 }, children: r })
  ] }) });
});
kx.displayName = "SPDateRangePicker";
const Cx = Z(mn)(() => ({
  zIndex: at.FORM_LAYOUT,
  backgroundColor: "#fff",
  borderRadius: "16px",
  boxShadow: "0px 6px 24px 0px #0A0A0A0F"
})), Fs = Z(De)(() => ({
  display: "flex",
  alignItems: "center",
  padding: "17px 16px"
})), Ws = Z(ur)(() => ({
  fontSize: "16px",
  fontWeight: "normal",
  color: "#1A1A1A",
  marginLeft: "16px"
})), sv = ({
  onChooseLibrary: e,
  onChooseCamera: r,
  isShow: t,
  setIsShow: n,
  btnUploadFileRef: o
}) => /* @__PURE__ */ s.jsx(
  pn,
  {
    onClickAway: (i) => {
      o.current && o.current.contains(i.target) || n(!1);
    },
    children: /* @__PURE__ */ s.jsx(
      Cx,
      {
        open: t,
        anchorEl: o.current,
        placement: "bottom-start",
        children: /* @__PURE__ */ s.jsxs($r, { children: [
          /* @__PURE__ */ s.jsxs(Fs, { onClick: e, children: [
            /* @__PURE__ */ s.jsx(uu, {}),
            /* @__PURE__ */ s.jsx(Ws, { children: "写真アルバムからアップロード" })
          ] }),
          /* @__PURE__ */ s.jsx(dr, {}),
          /* @__PURE__ */ s.jsxs(Fs, { onClick: r, children: [
            /* @__PURE__ */ s.jsx(lu, {}),
            /* @__PURE__ */ s.jsx(Ws, { children: "カメラで撮影" })
          ] })
        ] })
      }
    )
  }
);
var ui = {}, ho = {};
function jx(e) {
  return Qo("MuiSvgIcon", e);
}
Jp("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const Dx = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], Rx = (e) => {
  const {
    color: r,
    fontSize: t,
    classes: n
  } = e, o = {
    root: ["root", r !== "inherit" && `color${kt(r)}`, `fontSize${kt(t)}`]
  };
  return km(o, jx, n);
}, $x = ri("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [r.root, t.color !== "inherit" && r[`color${kt(t.color)}`], r[`fontSize${kt(t.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: r
}) => {
  var t, n, o, i, a, c, u, l, f, d, h, y, b;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // e.g. heroicons uses fill="none" and stroke="currentColor"
    fill: r.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (t = e.transitions) == null || (n = t.create) == null ? void 0 : n.call(t, "fill", {
      duration: (o = e.transitions) == null || (o = o.duration) == null ? void 0 : o.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((i = e.typography) == null || (a = i.pxToRem) == null ? void 0 : a.call(i, 20)) || "1.25rem",
      medium: ((c = e.typography) == null || (u = c.pxToRem) == null ? void 0 : u.call(c, 24)) || "1.5rem",
      large: ((l = e.typography) == null || (f = l.pxToRem) == null ? void 0 : f.call(l, 35)) || "2.1875rem"
    }[r.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (d = (h = (e.vars || e).palette) == null || (h = h[r.color]) == null ? void 0 : h.main) != null ? d : {
      action: (y = (e.vars || e).palette) == null || (y = y.action) == null ? void 0 : y.active,
      disabled: (b = (e.vars || e).palette) == null || (b = b.action) == null ? void 0 : b.disabled,
      inherit: void 0
    }[r.color]
  };
}), li = /* @__PURE__ */ Oe.forwardRef(function(r, t) {
  const n = Mg({
    props: r,
    name: "MuiSvgIcon"
  }), {
    children: o,
    className: i,
    color: a = "inherit",
    component: c = "svg",
    fontSize: u = "medium",
    htmlColor: l,
    inheritViewBox: f = !1,
    titleAccess: d,
    viewBox: h = "0 0 24 24"
  } = n, y = jt(n, Dx), b = /* @__PURE__ */ Oe.isValidElement(o) && o.type === "svg", m = ge({}, n, {
    color: a,
    component: c,
    fontSize: u,
    instanceFontSize: r.fontSize,
    inheritViewBox: f,
    viewBox: h,
    hasSvgAsChild: b
  }), g = {};
  f || (g.viewBox = h);
  const v = Rx(m);
  return /* @__PURE__ */ s.jsxs($x, ge({
    as: c,
    className: Kp(v.root, i),
    focusable: "false",
    color: l,
    "aria-hidden": d ? void 0 : !0,
    role: d ? "img" : void 0,
    ref: t
  }, g, y, b && o.props, {
    ownerState: m,
    children: [b ? o.props.children : o, d ? /* @__PURE__ */ s.jsx("title", {
      children: d
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (li.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: ne.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: ne.object,
  /**
   * @ignore
   */
  className: ne.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: ne.oneOfType([ne.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), ne.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: ne.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: ne.oneOfType([ne.oneOf(["inherit", "large", "medium", "small"]), ne.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: ne.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: ne.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: ne.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: ne.oneOfType([ne.arrayOf(ne.oneOfType([ne.func, ne.object, ne.bool])), ne.func, ne.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: ne.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: ne.string
});
li.muiName = "SvgIcon";
const Bs = li;
function Nx(e, r) {
  function t(n, o) {
    return /* @__PURE__ */ s.jsx(Bs, ge({
      "data-testid": `${r}Icon`,
      ref: o
    }, n, {
      children: e
    }));
  }
  return process.env.NODE_ENV !== "production" && (t.displayName = `${r}Icon`), t.muiName = Bs.muiName, /* @__PURE__ */ Oe.memo(/* @__PURE__ */ Oe.forwardRef(t));
}
const Ix = {
  configure: (e) => {
    process.env.NODE_ENV !== "production" && console.warn(["MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.", "", "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", "", "The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401", "", "The updated documentation: https://mui.com/guides/classname-generator/"].join(`
`)), Va.configure(e);
  }
}, Ax = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: kt,
  createChainedFunction: um,
  createSvgIcon: Nx,
  debounce: lm,
  deprecatedPropType: dm,
  isMuiElement: fm,
  ownerDocument: Za,
  ownerWindow: hm,
  requirePropFactory: pm,
  setRef: ec,
  unstable_ClassNameGenerator: Ix,
  unstable_useEnhancedEffect: Ja,
  unstable_useId: gm,
  unsupportedProp: ym,
  useControlled: bm,
  useEventCallback: xm,
  useForkRef: vm,
  useIsFocusVisible: Pm
}, Symbol.toStringTag, { value: "Module" })), Fx = /* @__PURE__ */ wt(Ax);
var Ls;
function Wn() {
  return Ls || (Ls = 1, function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return r.createSvgIcon;
      }
    });
    var r = Fx;
  }(ho)), ho;
}
var Wx = hr;
Object.defineProperty(ui, "__esModule", {
  value: !0
});
var di = ui.default = void 0, Bx = Wx(Wn()), Lx = s;
di = ui.default = (0, Bx.default)(/* @__PURE__ */ (0, Lx.jsx)("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
var fi = {}, Yx = hr;
Object.defineProperty(fi, "__esModule", {
  value: !0
});
var zr = fi.default = void 0, Hx = Yx(Wn()), zx = s;
zr = fi.default = (0, Hx.default)(/* @__PURE__ */ (0, zx.jsx)("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
function qx(y, h) {
  var b = y, {
    error: e,
    disabled: r,
    helperText: t,
    label: n,
    options: o,
    placeholder: i,
    value: a,
    width: c,
    height: u,
    maxHeight: l,
    onChange: f
  } = b, d = Se(b, [
    "error",
    "disabled",
    "helperText",
    "label",
    "options",
    "placeholder",
    "value",
    "width",
    "height",
    "maxHeight",
    "onChange"
  ]);
  const m = (g) => {
    const v = Jt(o, (_) => _.value === g);
    return It(v) ? i != null ? i : "" : v.label;
  };
  return /* @__PURE__ */ s.jsxs(
    nt,
    {
      disabled: r,
      error: e,
      sx: { width: c || "100%" },
      children: [
        /* @__PURE__ */ s.jsx(
          gn,
          {
            shrink: !0,
            sx: (g) => ({ color: g.palette.text.primary }),
            children: n
          }
        ),
        /* @__PURE__ */ s.jsx(
          At,
          ve(A({
            notched: !0,
            displayEmpty: !0,
            label: n,
            IconComponent: zr,
            MenuProps: {
              BackdropProps: {
                // @ts-ignore: data-testid
                "data-testid": "backdrop"
              },
              PaperProps: {
                sx: (g) => ({
                  maxHeight: l || 260,
                  maxWidth: 600,
                  border: "1px solid rgba(0,0,0,0.23)"
                })
              },
              sx: { touchAction: "none" }
            },
            sx: {
              borderRadius: ye(n) ? "4px" : "8px",
              height: u != null ? u : ye(n) ? "42px" : "46px",
              "&& .MuiSelect-select": {
                textOverflow: "inherit",
                borderRight: "32px solid transparent"
              }
            },
            ref: h,
            onChange: (g) => {
              const v = Jt(o, (_) => _.value === g.target.value);
              f(v);
            },
            value: a,
            renderValue: m
          }, d), {
            children: Ve(o, (g) => /* @__PURE__ */ s.jsxs(
              yt,
              {
                value: g.value,
                sx: {
                  display: "flex",
                  justifyContent: "space-between",
                  whiteSpace: "pre-line"
                },
                children: [
                  g.label,
                  g.value === a && /* @__PURE__ */ s.jsx(di, { sx: { fontSize: "20px" } })
                ]
              },
              g.value
            ))
          })
        ),
        t && /* @__PURE__ */ s.jsx(ot, { children: t })
      ]
    }
  );
}
const Pc = ze(qx);
Pc.displayName = "Select";
function Ux(a, i) {
  var c = a, {
    fetchData: e,
    onChange: r,
    initialOptions: t,
    maxHeight: n
  } = c, o = Se(c, [
    "fetchData",
    "onChange",
    "initialOptions",
    "maxHeight"
  ]);
  const [u, l] = xe(!1), { data: f, loading: d, pageNum: h, getData: y } = Bt(e), b = He(() => {
    if (!t)
      return f;
    const T = [...t, ...f];
    return Array.from(
      new Map(
        Ve(T, (w) => [w.value, w])
      ).values()
    );
  }, [f, t]), m = (T) => {
    r && r(T);
  }, g = (T) => {
    if (d || !u)
      return;
    const { scrollHeight: w, scrollTop: x, clientHeight: S } = T.target;
    Math.abs(w - x) < S + 1 && y().catch((P) => {
      throw P;
    });
  }, v = () => {
    l(!1);
  }, _ = () => {
    l(!0), h === 1 && y().catch((T) => {
      throw T;
    });
  };
  return /* @__PURE__ */ s.jsx(
    Pc,
    ve(A({}, o), {
      variant: "outlined",
      MenuProps: {
        PaperProps: {
          // @ts-ignore: data-testid
          "data-testid": "scrollContainer",
          onScroll: g,
          sx: (T) => ({
            maxHeight: n || 260,
            maxWidth: 600,
            border: "1px solid rgba(0,0,0,0.23)"
          })
        },
        sx: { touchAction: "none" }
      },
      onChange: m,
      onClose: v,
      onOpen: _,
      open: u,
      options: b,
      ref: i
    })
  );
}
const Vx = ze(Ux);
Vx.displayName = "AsyncSelect";
var hi = {}, Gx = hr;
Object.defineProperty(hi, "__esModule", {
  value: !0
});
var pi = hi.default = void 0, Xx = Gx(Wn()), Kx = s;
pi = hi.default = (0, Xx.default)(/* @__PURE__ */ (0, Kx.jsx)("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search");
var mi = {}, Qx = hr;
Object.defineProperty(mi, "__esModule", {
  value: !0
});
var gi = mi.default = void 0, Jx = Qx(Wn()), Zx = s;
gi = mi.default = (0, Jx.default)(/* @__PURE__ */ (0, Zx.jsx)("path", {
  d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), "ExpandLess");
const e1 = Z(De)({
  position: "relative"
}), t1 = Z(zr)(({ theme: e }) => ({
  position: "absolute",
  right: 7,
  "&.Mui-disabled": {
    color: e.palette.action.disabled
  }
})), r1 = Z(gi)(({ theme: e }) => ({
  position: "absolute",
  right: 7,
  "&.Mui-disabled": {
    color: e.palette.action.disabled
  }
})), n1 = Z(Ks)(({ theme: e }) => ({
  border: "1px solid rgba(0,0,0,0.23)",
  borderTop: "none",
  borderRadius: "0 0 4px 4px ",
  boxShadow: "0 6px 24px rgba(10,10,10,0.06)"
})), o1 = Z(lr)({
  "& .MuiAutocomplete-inputRoot": {
    backgroundColor: "#FFF",
    zIndex: at.POPUP_WINDOW
  },
  "& .MuiInputBase-root.MuiOutlinedInput-root": {
    borderRadius: "4px 4px 0 0"
  }
});
function i1({
  disabled: e,
  error: r,
  shouldFilterOptions: t = !0,
  height: n,
  helperText: o,
  label: i,
  options: a,
  placeholder: c,
  value: u,
  width: l,
  onChange: f,
  onOpen: d,
  onFilterInputChange: h,
  onScroll: y
}, b) {
  const [m, g] = xe(!1), [v, _] = xe(""), [T, w] = xe(!1), x = tt(null), S = (k) => {
    g(k), k || (w(!1), _("")), d && d(k);
  }, P = () => {
    e || S(!m);
  }, F = (k) => {
    _(k.target.value), h && h(k);
  }, ee = t ? Qs({ stringify: (k) => k.label }) : (k) => k, Y = (k) => {
    const C = Jt(a, (B) => B.value === k);
    return It(C) ? c != null ? c : "" : C.label;
  };
  return /* @__PURE__ */ s.jsxs(e1, { children: [
    /* @__PURE__ */ s.jsxs(
      nt,
      {
        disabled: e,
        error: r,
        sx: {
          width: l || "100%"
        },
        children: [
          /* @__PURE__ */ s.jsx(
            gn,
            {
              shrink: !0,
              sx: (k) => ({
                color: m ? k.palette.primary.main : k.palette.text.primary
              }),
              children: i
            }
          ),
          /* @__PURE__ */ s.jsx(
            At,
            {
              displayEmpty: !0,
              IconComponent: m ? r1 : t1,
              label: i,
              notched: !0,
              onChange: (k) => {
                const C = Jt(a, (B) => B.value === k.target.value);
                f(C);
              },
              onOpen: P,
              open: !1,
              ref: x,
              renderValue: Y,
              sx: (k) => ({
                borderRadius: ye(i) ? "4px" : "8px",
                height: n != null ? n : ye(i) ? "42px" : "46px",
                "&& .MuiSelect-select": {
                  textOverflow: "inherit",
                  borderRight: "32px solid transparent"
                },
                "&& .MuiOutlinedInput-notchedOutline": m ? {
                  borderColor: k.palette.primary.main,
                  borderWidth: 2
                } : {}
              }),
              value: u,
              children: Ve(a, (k) => /* @__PURE__ */ s.jsx("li", { value: k.value, children: k.label }, k.value))
            }
          ),
          o && /* @__PURE__ */ s.jsx(ot, { children: o })
        ]
      }
    ),
    m && /* @__PURE__ */ s.jsx(
      Js,
      {
        anchorEl: x.current,
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        BackdropProps: {
          // @ts-ignore: data-testid
          "data-testid": "backdrop"
        },
        onClose: () => S(!1),
        open: m,
        slotProps: {
          paper: {
            sx: (k) => ({
              width: "calc(100% - 32px)",
              minWidth: l,
              maxWidth: 600,
              // transitionはSelectの動きに合わせる
              transition: `opacity 281ms ${k.transitions.easing.easeInOut} 0ms`,
              borderRadius: "4px 4px 0 0",
              boxShadow: "0 6px 24px rgba(10,10,10,0.06)"
            })
          }
        },
        TransitionProps: {
          onEntered: () => w(!0)
        },
        sx: { touchAction: "none" },
        children: /* @__PURE__ */ s.jsx(
          Zs,
          {
            filterOptions: ee,
            inputValue: v,
            ListboxProps: {
              onScroll: y,
              role: "list-box",
              sx: {
                maxHeight: n || 260,
                "& .MuiAutocomplete-option": {
                  display: "flex",
                  justifyContent: "space-between",
                  whiteSpace: "pre-line"
                }
              },
              // @ts-ignore: data-testid
              "data-testid": "scrollContainer"
            },
            noOptionsText: "選択肢がありません",
            onChange: (k, C) => {
              C && a.length > 0 && (f(C), S(!1));
            },
            open: m && T,
            options: a,
            PaperComponent: n1,
            ref: b,
            renderInput: (k) => /* @__PURE__ */ s.jsx(
              o1,
              ve(A({}, k), {
                onChange: F,
                placeholder: "フィルター条件",
                InputProps: ve(A({}, k.InputProps), {
                  startAdornment: /* @__PURE__ */ s.jsx(pi, { color: "primary" })
                })
              })
            ),
            renderOption: (k, C) => /* @__PURE__ */ s.jsx($r, { children: /* @__PURE__ */ s.jsxs(
              yt,
              ve(A({}, k), {
                selected: C.value === u,
                value: C.value,
                children: [
                  C.label,
                  C.value === u && /* @__PURE__ */ s.jsx(di, { sx: { fontSize: "20px" } })
                ]
              })
            ) }, C.value),
            sx: {
              minWidth: l || "100%",
              "& .MuiAutocomplete-endAdornment": {
                display: "none"
              }
            },
            value: Jt(a, (k) => k.value === u)
          }
        )
      }
    )
  ] });
}
const kc = ze(i1);
kc.displayName = "SuggestiveSelect";
function s1(c, a) {
  var u = c, {
    initialOptions: e,
    fetchData: r,
    beforeFetchDataOnInputChanged: t,
    onChange: n,
    value: o
  } = u, i = Se(u, [
    "initialOptions",
    "fetchData",
    "beforeFetchDataOnInputChanged",
    "onChange",
    "value"
  ]);
  var T;
  const { data: l, loading: f, getData: d } = Bt(r), [h, y] = xe(
    !ye(o) && !It(e) && (T = Jt(e, (w) => w.value === o)) != null ? T : null
  ), b = He(() => {
    let w = l;
    return It(e) || (w = [...e, ...w]), Sn(h) || (w = [h, ...w]), Lo(w, "value");
  }, [l, e, h]), m = (w) => {
    y(w != null ? w : null), n(w);
  }, g = He(
    () => Tn(
      (w) => {
        const x = w.target.value, S = t(x);
        d(S, !0).catch((P) => {
          throw P;
        });
      },
      500
    ),
    [t, d]
  ), v = (w) => {
    w && d(void 0, !0).catch((x) => {
      throw x;
    });
  }, _ = (w) => {
    if (f)
      return;
    const { scrollHeight: x, scrollTop: S, clientHeight: P } = w.target;
    Math.abs(x - S) < P + 1 && d().catch((F) => {
      throw F;
    });
  };
  return /* @__PURE__ */ s.jsx(
    kc,
    ve(A({}, i), {
      shouldFilterOptions: !1,
      onFilterInputChange: g,
      onChange: m,
      onOpen: v,
      onScroll: _,
      options: b,
      ref: a,
      value: o
    })
  );
}
const a1 = ze(s1);
a1.displayName = "AsyncSuggestiveSelect";
const c1 = Z(De)({
  position: "relative"
}), u1 = Z(At, {
  shouldForwardProp: (e) => e !== "width" && e !== "autocompleteOpen"
})(
  ({ theme: e, autocompleteOpen: r, width: t, label: n }) => ({
    position: "relative",
    width: t || "100%",
    height: ye(n) ? "42px" : "46px",
    borderRadius: ye(n) ? "4px" : "8px",
    "&.Mui-disabled": {
      backgroundColor: "#FFF"
    },
    "& .MuiInputBase-root": {
      paddingRight: 0
    },
    "& .MuiInputBase-input": {
      paddingRight: 32,
      textOverflow: "ellipsis"
    },
    "& .MuiInputBase-root.Mui-disabled": {
      backgroundColor: "#FFF"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: e.palette.action.disabled
    },
    "& .MuiOutlinedInput-notchedOutline": r ? {
      borderColor: e.palette.primary.main,
      borderWidth: 2
    } : {}
  })
), l1 = Z(zr)(({ theme: e }) => ({
  position: "absolute",
  right: 7,
  "&.Mui-disabled": {
    color: e.palette.action.disabled
  }
})), d1 = Z(gi)(({ theme: e }) => ({
  position: "absolute",
  right: 7,
  "&.Mui-disabled": {
    color: e.palette.action.disabled
  }
})), f1 = Z(Ks)(({ theme: e }) => ({
  border: "1px solid rgba(0,0,0,0.23)",
  borderTop: "none",
  borderRadius: "0 0 4px 4px ",
  boxShadow: "0 6px 24px rgba(10,10,10,0.06)"
})), h1 = Z(lr)({
  "& .MuiAutocomplete-inputRoot": {
    backgroundColor: "#FFF",
    zIndex: at.POPUP_WINDOW
  },
  "& .MuiInputBase-root.MuiOutlinedInput-root": {
    borderRadius: "4px 4px 0 0"
  }
}), p1 = Z(De)({
  textOverflow: "clip",
  overflow: "hidden",
  whiteSpace: "nowrap"
}), m1 = Z(yt)({
  display: "flex",
  whiteSpace: "pre-line"
});
function g1({
  disabled: e,
  error: r,
  shouldFilterOptions: t = !0,
  height: n,
  helperText: o,
  label: i,
  options: a,
  placeholder: c,
  value: u,
  width: l,
  onChange: f,
  onOpen: d,
  onFilterInputChange: h,
  onScroll: y
}, b) {
  const [m, g] = xe(!1), [v, _] = xe(""), [T, w] = xe(!1), x = tt(null), S = tt(null), P = He(
    () => et(a, (j) => Be(u, j.value)),
    [a, u]
  ), F = (j) => {
    g(j), j || (w(!1), _("")), d && d(j);
  }, ee = () => {
    e || (F(!m), S.current && S.current.blur());
  }, Y = (j) => {
    f(et(P, (Q) => Q.value !== j));
  }, k = (j) => {
    _(j.target.value), h && h(j);
  }, C = (j) => {
    yo(P, (Q) => j.value === Q.value) ? Y(j.value) : f([...P, j]);
  }, B = ko(
    (j) => Be(u, j.value),
    [u]
  );
  return /* @__PURE__ */ s.jsxs(c1, { ref: b, children: [
    /* @__PURE__ */ s.jsxs(
      nt,
      {
        disabled: e,
        error: r,
        ref: x,
        sx: { width: l || "100%" },
        children: [
          /* @__PURE__ */ s.jsx(
            gn,
            {
              shrink: !0,
              sx: (j) => ({
                color: m ? j.palette.primary.main : j.palette.text.primary
              }),
              children: i
            }
          ),
          /* @__PURE__ */ s.jsx(
            u1,
            {
              variant: "outlined",
              autocompleteOpen: m,
              displayEmpty: !0,
              IconComponent: m ? d1 : l1,
              label: i,
              notched: !0,
              onClick: ee,
              open: !1,
              multiple: !0,
              ref: S,
              renderValue: () => (
                // 選択値に紐づくオプションが空ではない場合
                ye(P) ? c != null ? c : "" : /* @__PURE__ */ s.jsx(p1, { children: Ve(P, (j, Q) => /* @__PURE__ */ s.jsxs(ur, { component: "span", children: [
                  Q > 0 ? ", " : "",
                  j.label
                ] }, j.value)) })
              ),
              value: u,
              width: l
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ s.jsx(
      Js,
      {
        anchorEl: x.current,
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        BackdropProps: {
          // @ts-ignore: data-testid
          "data-testid": "backdrop"
        },
        onClose: () => F(!1),
        open: m,
        slotProps: {
          paper: {
            sx: (j) => ({
              width: "calc(100% - 32px)",
              minWidth: l,
              maxWidth: 600,
              // transitionはSelectの動きに合わせる
              transition: `opacity 281ms ${j.transitions.easing.easeInOut} 0ms`,
              borderRadius: "4px 4px 0 0",
              boxShadow: "0 6px 24px rgba(10,10,10,0.06)"
            })
          }
        },
        TransitionProps: {
          onEntered: () => w(!0)
        },
        sx: { touchAction: "none" },
        children: /* @__PURE__ */ s.jsx(
          Zs,
          {
            filterOptions: (j, Q) => ye(Q.inputValue) ? wf(
              j,
              [(ie) => Be(u, ie.value)],
              ["desc"]
            ) : t ? Qs({
              stringify: (ie) => ie.label
            })(j, Q) : j,
            groupBy: ye(v) ? (j) => String(B(j)) : void 0,
            inputValue: v,
            ListboxProps: {
              onScroll: y,
              role: "list-box",
              sx: {
                maxHeight: n || 260,
                "& .MuiAutocomplete-option": {
                  display: "flex",
                  justifyContent: "space-between",
                  whiteSpace: "pre-line"
                }
              },
              // @ts-ignore: data-testid
              "data-testid": "scrollContainer"
            },
            multiple: !0,
            noOptionsText: "選択肢がありません",
            open: m && T,
            options: a,
            PaperComponent: f1,
            renderGroup: ye(v) ? (j) => /* @__PURE__ */ s.jsxs($r, { children: [
              j.children,
              j.group === "true" && /* @__PURE__ */ s.jsx(dr, {})
            ] }, j.key) : void 0,
            renderInput: (j) => /* @__PURE__ */ s.jsx(
              h1,
              ve(A({}, j), {
                onChange: k,
                placeholder: "フィルター条件",
                InputProps: ve(A({}, j.InputProps), {
                  startAdornment: /* @__PURE__ */ s.jsx(pi, { color: "primary" })
                })
              })
            ),
            renderOption: (j, Q) => /* @__PURE__ */ s.jsxs(
              m1,
              {
                onClick: () => C(Q),
                selected: Be(u, Q.value),
                value: Q.value,
                children: [
                  /* @__PURE__ */ s.jsx(
                    an,
                    {
                      checked: Be(u, Q.value),
                      readOnly: !0,
                      sx: { padding: 0, marginRight: 1.5 }
                    }
                  ),
                  Q.label
                ]
              },
              Q.value
            ),
            sx: {
              minWidth: l || "100%",
              "& .MuiAutocomplete-endAdornment": {
                display: "none"
              }
            }
          }
        )
      }
    ),
    o && /* @__PURE__ */ s.jsx(ot, { error: r, children: o })
  ] });
}
const Cc = ze(g1);
Cc.displayName = "SuggestiveMultiSelect";
function y1(c, a) {
  var u = c, {
    initialOptions: e,
    fetchData: r,
    beforeFetchDataOnInputChanged: t,
    onChange: n,
    value: o
  } = u, i = Se(u, [
    "initialOptions",
    "fetchData",
    "beforeFetchDataOnInputChanged",
    "onChange",
    "value"
  ]);
  const { data: l, loading: f, getData: d } = Bt(r), [h, y] = xe(
    It(e) ? [] : et(e, (T) => Be(o, T.value))
  ), b = He(() => {
    let T = [...l, ...h];
    return It(e) || (T = [...e, ...T]), Lo(T, "value");
  }, [l, e, h]), m = (T) => {
    y(T), n(T);
  }, g = He(
    () => Tn(
      (T) => {
        const w = T.target.value, x = t(w);
        d(x, !0).catch((S) => {
          throw S;
        });
      },
      500
    ),
    [t, d]
  ), v = (T) => {
    T && d(void 0, !0).catch((w) => {
      throw w;
    });
  }, _ = (T) => {
    if (f)
      return;
    const { scrollHeight: w, scrollTop: x, clientHeight: S } = T.target;
    Math.abs(w - x) < S + 1 && d().catch((P) => {
      throw P;
    });
  };
  return /* @__PURE__ */ s.jsx(
    Cc,
    ve(A({}, i), {
      shouldFilterOptions: !1,
      onChange: m,
      onFilterInputChange: g,
      onOpen: v,
      onScroll: _,
      options: b,
      ref: a,
      value: o
    })
  );
}
const b1 = ze(
  y1
);
b1.displayName = "AsyncSuggestiveMultiSelect";
Z(Qt)({
  marginRight: 4,
  "&:last-child": {
    margin: 0
  }
});
const Ys = Z(yt)({
  display: "flex",
  whiteSpace: "pre-line"
}), x1 = Z(De)({
  textOverflow: "clip",
  overflow: "hidden",
  whiteSpace: "nowrap"
});
Z(yt)(({ theme: e }) => ({
  "&&": {
    color: e.palette.text.disabled,
    backgroundColor: "#E3E3E3"
  }
}));
function v1(y, h) {
  var b = y, {
    error: e,
    disabled: r,
    helperText: t,
    label: n,
    options: o,
    placeholder: i,
    value: a,
    width: c,
    height: u,
    maxHeight: l,
    onChange: f
  } = b, d = Se(b, [
    "error",
    "disabled",
    "helperText",
    "label",
    "options",
    "placeholder",
    "value",
    "width",
    "height",
    "maxHeight",
    "onChange"
  ]);
  const m = ko(
    (_) => et(o, (T) => Be(_, T.value)),
    [o]
  ), g = He(
    () => et(o, (_) => Be(a, _.value)),
    [o, a]
  ), v = He(
    () => sf(o, g),
    [o, g]
  );
  return /* @__PURE__ */ s.jsxs(
    nt,
    {
      disabled: r,
      error: e,
      sx: { width: c || "100%" },
      children: [
        /* @__PURE__ */ s.jsx(
          gn,
          {
            shrink: !0,
            sx: (_) => ({ color: _.palette.text.primary }),
            children: n
          }
        ),
        /* @__PURE__ */ s.jsxs(
          At,
          ve(A({
            notched: !0,
            displayEmpty: !0,
            label: n,
            IconComponent: zr,
            MenuProps: {
              BackdropProps: {
                // @ts-ignore: data-testid
                "data-testid": "backdrop"
              },
              PaperProps: {
                sx: (_) => ({
                  maxHeight: l || 260,
                  maxWidth: 600,
                  border: "1px solid rgba(0,0,0,0.23)"
                })
              },
              sx: { touchAction: "none" },
              autoFocus: !1
            },
            multiple: !0,
            sx: {
              borderRadius: ye(n) ? "4px" : "8px",
              height: u != null ? u : ye(n) ? "42px" : "46px"
            },
            ref: h,
            onChange: (_) => {
              f(m(_.target.value));
            },
            value: a,
            renderValue: (_) => (
              // 選択値に紐づくオプションが空ではない場合
              ye(m(_)) ? i != null ? i : "" : /* @__PURE__ */ s.jsx(x1, { children: Ve(m(_), (T, w) => /* @__PURE__ */ s.jsxs(ur, { component: "span", children: [
                w > 0 ? ", " : "",
                T.label
              ] }, T.value)) })
            )
          }, d), {
            children: [
              Ve(g, (_) => /* @__PURE__ */ s.jsxs(Ys, { value: _.value, children: [
                /* @__PURE__ */ s.jsx(
                  an,
                  {
                    checked: Be(a, _.value),
                    readOnly: !0,
                    sx: { padding: 0, marginRight: 1.5 }
                  }
                ),
                _.label
              ] }, _.value)),
              !ye(g) && /* @__PURE__ */ s.jsx(dr, {}),
              Ve(v, (_) => /* @__PURE__ */ s.jsxs(Ys, { value: _.value, children: [
                /* @__PURE__ */ s.jsx(
                  an,
                  {
                    checked: Be(a, _.value),
                    readOnly: !0,
                    sx: { padding: 0, marginRight: 1.5 }
                  }
                ),
                _.label
              ] }, _.value))
            ]
          })
        ),
        t && /* @__PURE__ */ s.jsx(ot, { children: t })
      ]
    }
  );
}
const jc = ze(v1);
jc.displayName = "MultiSelect";
function _1(a, i) {
  var c = a, {
    fetchData: e,
    onChange: r,
    initialOptions: t,
    maxHeight: n
  } = c, o = Se(c, [
    "fetchData",
    "onChange",
    "initialOptions",
    "maxHeight"
  ]);
  const [u, l] = xe(!1), [f, d] = xe(t || []), { data: h, loading: y, pageNum: b, getData: m } = Bt(e);
  sn(() => {
    d((w) => Lo([...w, ...h], "value"));
  }, [h]);
  const g = (w) => {
    r && r(w);
  }, v = (w) => {
    if (y || !u)
      return;
    const { scrollHeight: x, scrollTop: S, clientHeight: P } = w.target;
    Math.abs(x - S) < P + 1 && m().catch((F) => {
      throw F;
    });
  }, _ = () => {
    l(!1);
  }, T = () => {
    l(!0), b === 1 && m().catch((w) => {
      throw w;
    });
  };
  return /* @__PURE__ */ s.jsx(
    jc,
    ve(A({}, o), {
      MenuProps: {
        BackdropProps: {
          // @ts-ignore: data-testid
          "data-testid": "backdrop"
        },
        PaperProps: {
          // @ts-ignore: data-testid
          "data-testid": "scrollContainer",
          onScroll: v,
          sx: (w) => ({
            maxHeight: n || 260,
            border: "1px solid rgba(0,0,0,0.23)",
            maxWidth: 600
          })
        },
        autoFocus: !1,
        sx: { touchAction: "none" }
      },
      onChange: g,
      onClose: _,
      onOpen: T,
      open: u,
      options: f,
      ref: i
    })
  );
}
const w1 = ze(_1);
w1.displayName = "AsyncMultiSelect";
const T1 = Z(Su)(({
  isInputValid: e,
  isDisabled: r,
  isDisabledTextInput: t,
  isFocused: n,
  width: o,
  theme: i
}) => {
  const a = r ? i.palette.action.disabled : i.palette.primary.main, c = e ? i.palette.primary.main : i.palette.error.main, u = n ? "2px" : "1px";
  return {
    width: o != null ? o : "200px",
    height: "46px",
    borderRadius: "8px",
    "& input::placeholder": {
      color: "currentColor",
      opacity: 0.42
    },
    "&& input.wj-form-control": {
      pointerEvents: t ? "none" : void 0
    },
    "&&.wj-content:not(.wj-state-focused):hover": t ? void 0 : {
      border: e ? "1px solid" : void 0,
      borderRadius: "8px"
    },
    "&&.wj-inputdate": {
      padding: "2px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      border: e || `1px solid ${i.palette.error.main}`,
      outline: n ? `${u} solid ${c}` : void 0,
      backgroundColor: e || i.palette.background.error
    },
    "&&.wj-inputdate .wj-template": {
      width: o != null ? o : "400px"
    },
    "&& .wj-input-group.wj-input-btn-visible .wj-input-group-btn button.wj-btn.wj-btn-default": {
      padding: "2px",
      borderLeft: "none",
      borderRadius: "0 8px 8px 0",
      backgroundColor: "inherit"
    },
    "&& .wj-input-group.wj-input-btn-visible .wj-input-group-btn button.wj-btn.wj-btn-default:hover": {
      backgroundColor: i.palette.action.hover
    },
    "&&.wj-inputdate div.wj-input .wj-form-control": {
      font: "inherit",
      color: i.palette.text.primary,
      letterSpacing: "inherit",
      padding: "8.5px 14px",
      paddingRight: 0
    },
    "&& .wj-glyph-down": {
      border: "none",
      opacity: 1,
      content: du(a),
      display: "block"
    }
  };
});
function av(g) {
  var v = g, {
    format: e = fu.SLASH_DATE_FORMAT,
    helperText: r,
    onChange: t,
    onBlur: n,
    error: o,
    onError: i,
    placeholder: a,
    handleWeel: c = !1,
    isRequired: u = !1,
    minDate: l,
    maxDate: f,
    disabled: d,
    value: h,
    width: y,
    sx: b
  } = v, m = Se(v, [
    "format",
    "helperText",
    "onChange",
    "onBlur",
    "error",
    "onError",
    "placeholder",
    "handleWeel",
    "isRequired",
    "minDate",
    "maxDate",
    "disabled",
    "value",
    "width",
    "sx"
  ]);
  const [_, T] = xe(!1), [w, x] = xe(h || ""), [S, P] = xe(!0), F = (Y) => {
    const k = new Date(Y);
    let C = !0;
    if (ye(Y))
      if (u)
        C = !1;
      else
        return P(!0), !0;
    (Y.length < 10 || !Sx(Y, e)) && (C = !1), ut(k) || (C = !1);
    const B = new Date(l || ""), j = new Date(f || "");
    return ut(B) && ut(j) && (C = Oc(k, {
      start: B,
      end: j
    }) || on(new Date(k), new Date(B))), ut(B) && !ut(j) && (C = nr(new Date(k), new Date(B)) || on(new Date(k), new Date(B))), !ut(B) && ut(j) && (C = Ot(new Date(k), new Date(j)) || on(new Date(k), new Date(j))), P(C), C;
  };
  sn(() => {
    h && F(h);
  }, []);
  const ee = () => S ? "" : ye(w) && u ? hu : r;
  return sn(() => {
    Fe(i) && i(!S);
  }, [S, i]), /* @__PURE__ */ s.jsxs(nt, { disabled: d, sx: b, children: [
    /* @__PURE__ */ s.jsx(
      T1,
      ve(A({}, m), {
        format: e,
        handleWeel: c,
        placeholder: a != null ? a : e.toUpperCase(),
        isRequired: u,
        value: h || null,
        textChanged: (Y) => {
          x(Y.text);
          const k = F(Y.text);
          Fe(t) && k && (ye(Y.text) ? t("") : t(Oo(new Date(Y.text), e)));
        },
        min: l,
        max: f,
        isDisabled: d,
        isInputValid: It(o) ? S : !o,
        width: y,
        isFocused: _,
        gotFocus: () => {
          T(!0);
        },
        lostFocus: (Y) => {
          const k = F(Y.text);
          Fe(n) && k && (ye(Y.text) ? n("") : n(Oo(new Date(Y.text), e))), T(!1);
        },
        isDroppedDownChanged: (Y) => {
          Y.isDroppedDown && T(!0);
        }
      })
    ),
    r && !S && /* @__PURE__ */ s.jsx(ot, { error: !0, children: ee() })
  ] });
}
const S1 = Z(lr)(({ theme: e, multiline: r }) => ({
  "& .MuiInputBase-root": {
    minHeight: r ? "150px" : void 0
  },
  "& input[type=text]": {
    border: "none"
  }
}));
function cv(n) {
  var o = n, {
    width: e,
    sx: r
  } = o, t = Se(o, [
    "width",
    "sx"
  ]);
  return /* @__PURE__ */ s.jsx(
    S1,
    ve(A({
      fullWidth: !0
    }, t), {
      size: "small",
      InputLabelProps: { shrink: !0 },
      sx: ve(A({}, r), { width: e })
    })
  );
}
const E1 = {
  MuiModal: {
    styleOverrides: {
      backdrop: {
        "&.MuiBackdrop-invisible": {
          backgroundColor: "transparent"
        }
      }
    }
  }
}, M1 = {
  MuiAutocomplete: {
    styleOverrides: {
      groupLabel: {
        lineHeight: 2
      },
      inputRoot: {
        "&.MuiInputBase-root.MuiOutlinedInput-root": {
          height: "auto"
        }
      }
    }
  }
}, O1 = {
  MuiButton: {
    defaultProps: {
      disableElevation: !0,
      disableFocusRipple: !0
    },
    styleOverrides: {
      root: ({ ownerState: e, theme: r }) => {
        const { color: t, variant: n } = e;
        let o = "inherit", i = "inherit", a = "inherit";
        return t === void 0 && (o = r.palette.primary.main, i = r.palette.primary.light, a = r.palette.primary.dark), t !== void 0 && t !== "inherit" && (o = r.palette[t].main, i = r.palette[t].light, a = r.palette[t].dark), A(A(A({
          // Button共通
          borderRadius: "8px",
          padding: "8px 14px",
          "&:focus": {
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: r.palette.action.buttonFocus
          }
        }, n === "contained" && {
          border: "2px solid transparent"
        }), n === "outlined" && {
          borderWidth: 2,
          borderColor: o,
          "&:disabled": {
            borderWidth: 2
          },
          "&:hover": {
            borderWidth: 2,
            backgroundColor: i
          }
        }), n === "text" && {
          fontSize: "0.875rem",
          fontWeight: 400,
          textDecorationLine: "underline",
          border: "2px solid transparent",
          "&:hover": {
            color: a,
            textDecorationLine: "underline"
          }
        });
      },
      sizeSmall: {
        fontSize: 14
      }
    }
  }
}, P1 = {
  MuiCheckbox: {
    styleOverrides: {
      root: ({ ownerState: e, theme: r }) => ({
        color: r.palette.primary.main,
        position: "relative",
        "& .MuiSvgIcon-root": {
          fontSize: 28,
          position: "relative",
          zIndex: 1
        },
        "& input": {
          position: "absolute",
          zIndex: 2
        },
        "&::after": {
          position: "absolute",
          content: '""',
          display: "block",
          width: "1em",
          height: "1em",
          fontSize: 20,
          borderRadius: 4,
          zIndex: 0,
          backgroundColor: e.disabled ? r.palette.action.disabledBackground : "#FFFFFF"
        }
      })
    }
  }
}, k1 = {
  MuiChip: {
    defaultProps: {
      size: "small"
    },
    styleOverrides: {
      root: ({ ownerState: e, theme: r }) => A({}, e.color === "undecided" && {
        color: r.palette.text.primary,
        borderColor: r.palette.undecided.main
      }),
      sizeSmall: ({ theme: e }) => ve(A({}, e.typography.body2), {
        height: 22
      })
    }
  }
}, C1 = {
  MuiDialog: {
    defaultProps: {
      fullWidth: !0,
      PaperProps: {
        elevation: 0
      }
    }
  },
  MuiDialogTitle: {
    defaultProps: {},
    styleOverrides: {
      root: {
        padding: 24,
        fontSize: 20,
        fontWeight: 700,
        lineHeight: 1.2,
        textAlign: "center",
        "&&+.MuiDialogContent-root": {
          paddingTop: 24
        }
      }
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: 24
      }
    }
  },
  MuiDialogContentText: {
    styleOverrides: {
      root: {
        color: "inherit"
      }
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: "16px 24px 24px",
        justifyContent: "center",
        "&>:not(:first-of-type)": {
          marginLeft: 16
        }
      }
    }
  },
  MuiBackdrop: {
    styleOverrides: {
      root: {
        background: "rgba(0,0,0,0.25)"
      }
    }
  }
}, j1 = {
  MuiFormControl: {
    defaultProps: {
      size: "small"
    }
  }
}, D1 = {
  MuiIconButton: {
    defaultProps: {
      color: "primary"
    },
    styleOverrides: {
      root: ({ ownerState: e, theme: r }) => {
        const { color: t } = e;
        let n = "inherit";
        return (t === void 0 || t === "default") && (n = r.palette.primary.light), t !== void 0 && t !== "inherit" && t !== "default" && (n = r.palette[t].light), {
          border: "2px solid transparent",
          borderRadius: 0,
          "&:focus": {
            borderColor: r.palette.action.buttonFocus
          },
          ":hover": {
            backgroundColor: n
          }
        };
      }
    }
  }
}, R1 = {
  MuiInputBase: {
    styleOverrides: {
      root: {
        fontSize: "0.875rem"
      }
    }
  },
  MuiTextField: {
    styleOverrides: {
      root: ({ ownerState: e, theme: r }) => ({
        "& .MuiFormLabel-root": {
          color: r.palette.text.primary
        },
        "& .MuiInputBase-root.Mui-error": {
          backgroundColor: r.palette.error.light
        },
        "& .MuiInputBase-root.Mui-disabled": {
          backgroundColor: r.palette.action.disabledBackground
        },
        "& .MuiInputBase-root.MuiOutlinedInput-root": {
          borderRadius: ye(e.label) ? "4px" : "8px",
          height: ye(e.label) ? "42px" : "46px"
        }
      })
    }
  }
}, $1 = {
  MuiList: {
    styleOverrides: {
      root: {
        padding: "8px 0"
      }
    }
  },
  MuiListItemButton: {
    styleOverrides: {
      root: ({ theme: e }) => ({
        "&:hover": {
          color: e.palette.primary.main
        },
        "&.Mui-disabled": {
          color: e.palette.action.disabled,
          backgroundColor: e.palette.background.disabled
        },
        "&.Mui-selected": {
          color: e.palette.primary.main,
          backgroundColor: e.palette.primary.light,
          "&:hover": {
            backgroundColor: e.palette.primary.light
          }
        }
      })
    }
  }
}, N1 = {
  MuiMenu: {
    styleOverrides: {
      paper: () => ({
        boxShadow: "0 6px 24px rgba(10,10,10,0.06)",
        borderRadius: 4
      })
    }
  },
  MuiMenuItem: {
    styleOverrides: {
      root: ({ theme: e }) => ({
        "&:hover": {
          color: e.palette.primary.main
        },
        "&.Mui-disabled": {
          color: e.palette.action.disabled,
          backgroundColor: e.palette.background.disabled
        },
        "&.Mui-selected": {
          color: e.palette.primary.main,
          backgroundColor: e.palette.primary.light,
          "&:hover": {
            backgroundColor: e.palette.primary.light
          }
        }
      })
    }
  }
}, I1 = {
  MuiPaper: {
    defaultProps: {
      square: !0,
      elevation: 0
    },
    styleOverrides: {}
  }
}, A1 = {
  MuiSelect: {
    styleOverrides: {
      select: {
        boxSizing: "border-box",
        textAlign: "left"
      },
      icon: ({ theme: e }) => ({
        color: e.palette.primary.main
      })
    }
  }
}, F1 = {
  MuiRadio: {
    defaultProps: {},
    styleOverrides: {
      root: ({ ownerState: e, theme: r }) => ({
        color: r.palette.primary.main,
        "& .MuiSvgIcon-root": {
          fontSize: 28,
          zIndex: 1
        },
        "& input": {
          position: "absolute",
          zIndex: 2
        },
        "&::after": {
          position: "absolute",
          content: '""',
          display: "block",
          width: "1em",
          height: "1em",
          fontSize: 20,
          borderRadius: 10,
          zIndex: 0,
          backgroundColor: e.disabled ? "#e3e3e3" : "#fff"
        },
        "&.Mui-disabled": {
          color: r.palette.action.disabled
        }
      })
    }
  }
}, W1 = {
  MuiContainer: {
    defaultProps: {
      disableGutters: !0
    }
  }
}, B1 = {
  MuiTableCell: {
    styleOverrides: {
      root: ({ theme: e }) => ve(A({}, e.typography.body1), {
        borderColor: "rgba(0, 0, 0, 0.23)",
        padding: 8
      }),
      head: ({ theme: e }) => ({
        color: e.palette.common.white,
        backgroundColor: e.palette.primary.main,
        border: "none"
      })
    }
  }
}, L1 = {
  components: A(A(A(A(A(A(A(A(A(A(A(A(A(A(A(A({}, M1), O1), P1), k1), W1), C1), j1), D1), R1), $1), N1), E1), I1), A1), F1), B1)
}, Y1 = Vs(A({
  constants: {
    drawerWidth: 240,
    footerHeight: 40,
    headerHeight: 64
  },
  palette: {
    primary: {
      main: "#3170C1",
      light: "#F2F9FC",
      dark: "#174076"
    },
    error: {
      main: "#E64E17",
      light: "#FFEDEB",
      dark: void 0
    },
    warning: {
      main: "#C83727",
      light: "#FFEDEB",
      dark: void 0
    },
    info: {
      main: "#FFF2AC",
      light: void 0,
      dark: void 0
    },
    accent: {
      main: "#229984",
      light: void 0,
      dark: "#146B5C",
      contrastText: "#FFFFFF"
    },
    success: {
      main: "#469A48",
      light: "#EDFFED",
      dark: void 0
    },
    progress: {
      main: "#F59419",
      light: void 0,
      dark: void 0,
      contrastText: "#FFFFFF"
    },
    undecided: {
      main: "#C7C7C7",
      light: void 0,
      dark: void 0,
      contrastText: "#393939"
    },
    withdraw: {
      main: "#E155F8",
      light: void 0,
      dark: void 0,
      contrastText: "#FFFFFF"
    },
    text: {
      primary: "#393939",
      secondary: "#787878",
      disabled: "#C7C7C7"
    },
    divider: "#DBDBDB",
    action: {
      active: "#F2F9FC",
      hover: "#F2F9FC",
      hoverOpacity: void 0,
      selected: "#F2F9FC",
      selectedOpacity: void 0,
      disabled: "#C7C7C7",
      disabledBackground: "#F1F1F1",
      disabledOpacity: void 0,
      focus: "#F2F9FC",
      buttonFocus: "#F59419",
      focusOpacity: void 0,
      activatedOpacity: void 0,
      onCopy: "#c7eeff"
    },
    background: {
      disabled: "#E3E3E3",
      done: "#EDFFED",
      edited: "rgba(255, 231, 201, 1)",
      error: "#FFE0E0",
      header: "#3170C1",
      screen: "#F7F7F7",
      loading: "rgba(0,0,0,0.25)"
    },
    border: {
      main: "rgba(0,0,0,0.23)",
      light: void 0,
      dark: void 0
    },
    borderOpaque: {
      main: "rgba(196, 196, 196, 1)",
      light: void 0,
      dark: void 0
    }
  },
  typography: {
    fontFamily: "Meiryo",
    h1: {
      fontSize: "1.5rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    h2: {
      fontSize: "1.25rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    h3: {
      fontSize: "1.125rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    h4: {
      fontSize: "1rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    headerTitle: {
      fontSize: "1rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    sideMenuLg: {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: 1.5
    },
    sideMenuMd: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: 1.5
    },
    sideMenuSm: {
      fontSize: "0.75rem",
      fontWeight: 400,
      lineHeight: 1.5
    },
    bodyXxl: {
      fontSize: "1.5rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    bodyXl: {
      fontSize: "1.25rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    bodyLg: {
      fontSize: "1.125rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    bodyMd: {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: 1.5
    },
    body1: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: 1.5
    },
    body2: {
      fontSize: "0.75rem",
      fontWeight: 400,
      lineHeight: 1.5
    },
    bodyXs: {
      fontSize: "0.625rem",
      fontWeight: 400,
      lineHeight: 1.5
    },
    label: {
      fontSize: "0.75rem",
      fontWeight: 400,
      lineHeight: 1.5
    },
    labelMd: {
      fontSize: "0.75rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    labelSm: {
      fontSize: "0.625rem",
      fontWeight: 700,
      lineHeight: 1.5
    },
    button: {
      fontSize: "1rem",
      fontWeight: 700,
      lineHeight: 1.5,
      textTransform: "none"
    },
    buttonSm: {
      fontSize: "0.875rem",
      fontWeight: 700,
      lineHeight: 1.5
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 880,
      lg: 1200,
      xl: 1536
    }
  }
}, L1));
function uv(r) {
  var e = Se(r, []);
  return /* @__PURE__ */ s.jsx(Gs, { theme: Y1, children: /* @__PURE__ */ s.jsx(Xs, A({}, e)) });
}
const H1 = Z(De)(({ theme: e }) => ({
  // Buildee利用規約画面
  "&.terms-service .terms-service__header": {
    borderBottom: "solid",
    lineHeight: "32px",
    padding: "16px",
    textAlign: "center"
  },
  "&.terms-service .terms-service__header .terms-service__title": {
    fontSize: "26px"
  },
  "&.terms-service .terms-service__header .terms-service__note": {
    color: e.palette.negative.main,
    fontSize: "14px"
  },
  "&.terms-service .terms-service__body": {
    overflow: "hidden"
  },
  "&.terms-service .terms-service__body .terms-service__contents": {
    overflow: "auto",
    height: "calc(100vh - 190px)",
    border: "1px solid #ccc",
    padding: "10px"
  },
  "&.terms-service .terms-service__body .terms-service__contents .contents__big-heading": {
    fontSize: "18px",
    fontWeight: "bold"
  },
  "&.terms-service .terms-service__body .terms-service__contents .contents__block": {
    paddingLeft: "1em",
    textIndent: "-1em"
  },
  "&.terms-service .terms-service__body .terms-service__contents .contents__footer": {
    textAlign: "left"
  },
  "&.terms-service .terms-service__footer": {
    paddingTop: "10px",
    textAlign: "center"
  },
  "&.footer_content": {
    paddingTop: "10px",
    textAlign: "center"
  }
})), z1 = Z(De)(({ theme: e }) => ({
  //利用規約
  "&#terms_body": {
    height: "calc(100vh - 140px)",
    margin: "10px 10px 60px 10px",
    padding: "10px",
    overflow: "scroll",
    whiteSpace: "pre-wrap",
    fontSize: "14px",
    border: `solid 1px ${e.palette.normal.main}`
  },
  "&.terms-service .terms-service__body .terms-service__contents .contents__big-heading": {
    fontWeight: "bold"
  },
  "&.terms-service .terms-service__body .terms-service__contents .contents__block": {
    paddingLeft: "1em",
    textIndent: "-1em"
  },
  "&.terms-service .terms-service__body .terms-service__contents .contents__footer": {
    textAlign: "left"
  },
  p: {
    margin: 0,
    padding: 0
  }
}));
function Dc() {
  return /* @__PURE__ */ s.jsx("div", { className: "dialog__body terms-service__body", children: /* @__PURE__ */ s.jsx("div", { className: "dual-panel", children: /* @__PURE__ */ s.jsx("div", { className: "dual-panel__item", children: /* @__PURE__ */ s.jsx("div", { className: "panel", children: /* @__PURE__ */ s.jsx("div", { className: "panel-header", children: /* @__PURE__ */ s.jsxs("div", { className: "terms-service__contents", children: [
    /* @__PURE__ */ s.jsx("p", { className: "contents__big-heading", children: "第1章 総則" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第1条（名称、目的、サービス概要）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 株式会社リバスタ（以下、「当社」といいます。）が保有する会員制のインターネット建設現場施工管理サービスの名称は、Buildeeとし、以下、Buildeeを通じて提供される全てのサービスを総称して「Buildee」といいます。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 Buildeeは、会員（次条に定めます。）の間の各種情報共有及び会員が実施する各種業務の効率化を図ることにより、日本国内の建設現場における作業効率の向上及び施工管理コストの低減を実現し、高度循環型社会の形成に寄与することをその目的とします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "3 Buildee利用規約（以下「本規約」と言います。）には、Buildeeの提供条件及び当社と会員の皆様、及び建設現場に参加する作業員個人（以下「作業員」といいます。）の皆様との間の権利義務関係及び会員がBuildeeを利用するにあたって遵守すべきルール等が定められています。会員は、Buildeeの利用に際して、本規約の全文をお読みいただいたうえで、本規約に同意いただく必要があります。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第2条（定義）" }),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__block", children: [
      "1 本規約において使用する以下の用語は、各々以下に定める意味を有するものとします。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（1）「会員」とは、Buildeeに登録された、建設現場の施工管理に関わる元請事業者及び協力会社のことをいい、「元請会員」と「協力会員」（次項で定義します。）から構成されます。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（2）「元請会員」とは、元請会社としてBuildeeを利用する会員をいいます。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（3）「協力会員」とは、元請会社との直接的な契約関係にかかわらず、協力会社としてBuildeeを利用する会員をいいます。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（4）「作業員」とは、正社員、契約社員、臨時社員、嘱託、パートタイマー、第三者から派遣された派遣社員等、雇用形態を問わず、会員の建設現場に参加する者をいいます。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（5）「知的財産権」とは、著作権、特許権、実用新案権、意匠権、商標権その他の知的財産権（それらの権利を取得し、またはそれらの権利につき登録等を出願する権利を含みます。）を意味します。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（6）「当社ホームページ」とは、当社が運営するウェブサイト（理由の如何を問わず、当社のウェブサイトのドメインまたは内容が変更された場合は、当該変更後のウェブサイトを含みます。）を意味します。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（7）「個人情報」とは、個人情報の保護に関する法律に定める個人情報を意味し、就業履歴に関する情報も個人情報に含みます。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（8）「ユーザーID」とは、当社がBuildeeの利用にあたって会員に付与するIDを意味します。"
    ] }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第3条（Buildeeの主催、運営管理）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 Buildeeは当社が主催し、その一切の運営管理は当社または当社が指定する者（以下、併せて「当社」といいます。）がこれを行います。当社は、必要に応じて業務の一部又は全部を外部委託することがあります。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 当社は、Buildeeに登録される情報を当社が保有し、または当社が契約しているデータセンター内のサーバー群で管理し、会員の要請に応じてその情報を提供します。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第4条（Buildeeの利用、一時中止、及び廃止）" }),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__block", children: [
      "1 Buildeeは、24時間365日利用することが可能ですが、定期的もしくは緊急時のシステムメンテナンス等の理由によりサービスの提供を一時的に中止もしくは利用の制限をする場合があります。また、以下のいずれかに該当する場合も同様とします。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（1）Buildeeの保守管理上やむを得ない事情が生じたとき。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（2）天災地変などの不可抗力、その他、Buildeeのサービス提供を中止せざるを得ない特段の事情が生じたとき。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（3）その他、当社がBuildeeのサービスを一時的に中止すべきと判断したとき。",
      /* @__PURE__ */ s.jsx("br", {})
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 当社は会員に対して3ヵ月前までに第6条1項で定めるいずれかの方法によって通知することでBuildeeを廃止することができます。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第5条（規約、サービス等の変更）" }),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__block", children: [
      "1 当社は、次条1項で定めるいずれかの連絡方法を用いて、あらかじめ会員に通知することにより次の各号で定める事項を任意に決定、実施することができます。ただし、緊急時等、事前の通知が困難な場合には、その実施後速やかに通知するものとします。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（1）Buildeeのサービス内容の重要な変更",
      /* @__PURE__ */ s.jsx("br", {}),
      "（2）Buildeeの利用条件（利用料を含みます。）の変更",
      /* @__PURE__ */ s.jsx("br", {}),
      "（3）本規約の変更・改定",
      /* @__PURE__ */ s.jsx("br", {}),
      "（4）その他Buildeeの管理運営にかかる必要事項"
    ] }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第6条（会員への連絡）" }),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__block", children: [
      "1 当社から会員への通知は、以下の各号のいずれかの方法により行います。なお、以下の各号のいずれかの方法により通知した場合、当社が通知を発した時点で会員に到達したものとみなします。また、複数の手段で通知した場合には、最も早く発した通知を基準とします。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（1）当社ホームページでの掲載",
      /* @__PURE__ */ s.jsx("br", {}),
      "（2）電話",
      /* @__PURE__ */ s.jsx("br", {}),
      "（3）電子メール",
      /* @__PURE__ */ s.jsx("br", {}),
      "（4）郵送",
      /* @__PURE__ */ s.jsx("br", {}),
      "（5）ファックス",
      /* @__PURE__ */ s.jsx("br", {}),
      "（6）Buildee上のお知らせ表示"
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 当社は、会員に対し、前項の方法をもって、Buildeeの利用に関する情報のほか、当社の事業内容や当社が提供するその他のサービスの案内等の情報提供を行うことがあります。会員は、当社へ個別に申し出ることにより、Buildeeの利用に関する情報以外の情報提供を拒むことができます（ただし、前項第1号は除きます。）。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第7条（登録情報の変更または削除）" }),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__block", children: [
      "1 当社は、以下に該当するときまたは該当するおそれがあると判断したときは、当社のみの判断でBuildee上の登録情報について、変更または削除することができるものとします。なお、本条による登録情報の変更または削除により会員または第三者に損害が生じたとしても、当社は一切の責任を負いません。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（1）会員が第18条（個人情報）、第21条（会員の義務）、第22条（反社会的勢力の排除）または第23条（禁止行為）に違反した場合",
      /* @__PURE__ */ s.jsx("br", {}),
      "（2）会員が当社に対して、口頭または書面等により、登録情報の変更または削除を依頼した場合",
      /* @__PURE__ */ s.jsx("br", {}),
      "（3）その他、当社が、Buildeeの運用管理上等、登録情報を削除または変更すべきと判断した場合"
    ] }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第8条（規約の範囲及び優先関係）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 本規約のほかに会員との間で個別契約が締結される場合は、当該契約も本規約に係る契約の一部を構成するものとします。なお、本規約の定めと個別契約における定めに齟齬がある場合、後者が優先するものとします。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第9条（CCUSとの連携）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 Buildeeは、一般財団法人建設業振興基金（以下「振興基金」といいます。）が運営する「建設キャリアアップシステム」（以下「CCUS」といいます。）における就業履歴データ登録標準API連携認定システムです。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 当社は、Buildeeに登録された作業員の個人情報について、CCUSと共同利用する場合があります。詳細は、振興基金が定める建設キャリアアップシステム個人情報保護方針をご覧ください。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "3 CCUSに登録された作業員に係る個人情報は、Buildeeを通じて、会員が共同で利用する場合があります。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第10条（機器及びご利用環境の整備・維持）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 Buildee利用のために必要となる、当社が指定するレンタル機器（以下「本機器」といいます。）は、BANKEN利用規約に同意し、申請書類を当社に提出することにより、レンタルすることができます。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 会員は、Buildeeと本機器を接続することにより、Buildeeの各種サービスを利用することができます。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "3 Buildeeに接続された機器、もしくは会員が利用するインターネットなどのネットワーク環境に不具合（但し、当社よりレンタルされた機器に起因する不具合は除きます。）がある場合、当社は会員に対してBuildeeの提供義務を負わないものとし、それによって会員に損害が発生したとしても、一切の責任を負わないものとします。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__big-heading", children: "第2章 入会手続き、会員登録" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第11条（入会申込及び会員登録）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 Buildeeの入会を希望する元請事業者もしくは協力会社（以下、「入会希望者」といいます。）は、当社ホームページ上のWEB申込みシステムから申込みを行うか、または所定の入会申込書に署名・捺印のうえ当社へ提出するものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 前項の定めにかかわらず、協力会社は、会員からの招待により協力会員として登録されることがあります。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第12条（入会審査、承諾及び取消）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 前条1項の入会申込を受けた場合、当社は、入会希望者（但し、元請事業者に限ります。）について入会審査を実施します。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 元請事業者は、前項の審査において入会を承認された場合、また、協力会社は、前条1項で定める当社指定のBuildee入会手続きを経て、各種条件を備えていることが当社により確認された場合、もしくは会員からの招待が当社にて確認された場合、Buildee会員としてのIDが当社より付与されます。" }),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__block", children: [
      "3 当社は、第1項の入会希望者における入会審査の際、もしくは会員が入会後、以下のいずれかに該当すると判断した場合、入会を拒否し、またはいつでもその会員資格を取り消すことができます（本項において入会希望者と会員を併せて、以下、「入会希望者等」といいます。）。なお、当社が入会を拒否または取消した場合、その理由を開示や説明する義務はないものとし、当社が以下の事由により会員登録を取り消した場合、既に支払われた初期費用及び利用料は返還されないものとします。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（1）入会希望者等の経営状態について与信上の不安が存すると当社が判断した場合",
      /* @__PURE__ */ s.jsx("br", {}),
      "（2）入会希望者等が過去に第24条（利用停止・利用禁止）で定める利用停止または利用禁止処分を受けたことがある場合",
      /* @__PURE__ */ s.jsx("br", {}),
      "（3）入会希望者等が元請事業者もしくは協力会社ではない場合または法人もしくは事業の実体を有しない場合",
      /* @__PURE__ */ s.jsx("br", {}),
      "（4）入会希望者等が、第22条（反社会的勢力の排除）1項各号のいずれかに該当する又は該当する恐れがあると当社が判断した場合",
      /* @__PURE__ */ s.jsx("br", {}),
      "（5）入会希望者が、当社または第三者に対して第22条（反社会的勢力の排除）2項に該当する行為を行った又はその恐れがあると当社が判断した場合",
      /* @__PURE__ */ s.jsx("br", {}),
      "（6）入会希望者が虚偽の内容にて登録した場合",
      /* @__PURE__ */ s.jsx("br", {}),
      "（7）その他当社が入会を不適当と認める相当の事情がある場合"
    ] }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第13条（登録期間）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 会員の登録期間は1か月間とし、登録期間の満了に先立ち、会員が第15条による退会の意思表示を行わない限り、さらに1か月間の登録期間が自動更新されるものとし、それ以降も同様とします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 第24条により利用停止もしくは利用禁止の処分が下された場合は前項の限りではありません。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第14条（初期費用・利用料等）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 会員はBuildeeに入会するに際し所定の初期費用等を支払うものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 会員はBuildeeの利用にあたり、当社所定の利用料等を支払うものとします。ただし、システム登録をした月の利用料は、システム登録日にかかわらず入会月末を締め日とする1か月分が発生するものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "3 Buildeeの料金体系は当社ホームページに記載の「Buildeeご利用料金」等に定めるものとします。「Buildeeご利用料金」等は、経済情勢、Buildeeの管理運用状況、その他諸般の事情により、あらかじめ会員に通知することにより、随時改定することがあります。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "4 初期費用及び利用料等が発生する会員には、当社ホームページに定める「Buildeeご利用料金」等に定める支払日に、あらかじめ定めた金融機関口座から口座振替する方法により利用料等の必要な費用をお支払いいただきます。なお、当社が別途認めた場合には、口座振替にかえて、毎月末を締め日として当社が作成、送付した請求書に基づいて翌月末日までに振り込む方法によりお支払いいただくことも可能です。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "5 初期費用・利用料等の支払に係る消費税、振込手数料等は会員の負担とします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "6 初期費用・利用料等は、いかなる場合でも返還いたしません。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第15条（退会と再入会）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 会員は登録期間中といえども、当社所定の退会届に必要事項を記入のうえ、退会を希望する月の前月末日までに当社に提出することにより退会することができるものとします。ただし、退会月の利用料は、その退会する日にかかわらず退会月末を締め日とする1か月分が発生するものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 退会した会員が再度入会を希望する場合は、第11条及び第12条に基づき、再度入会手続きを行うものとします。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__big-heading", children: "第3章 権利、義務" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第16条（知的財産権）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 Buildeeを構成するすべてのプログラム、ソフトウェア、商標、商号その他事業活動に用いられるサービス又は役務を表示するもの、各種資料等の著作物またはそれらに付随する一切の知的財産権は、当社もしくは当社にその利用を許諾した第三者に帰属します。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 当社は、会員がBuildeeに登録する各種情報またはファイルについて、それを複製し、バックアップする権利を有するものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "3 会員は、当社が定める「ソフトウェアの使用許諾権に関する細則」に同意し、当社もしくは当社以外のソフトウェアの使用許諾者が本条に定める知的財産権等を保有することを異議なく承認の上、それらを侵害しないものとします。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第17条（秘密保持等）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 会員は、Buildeeに関連して当社が会員に対して秘密に取扱うことを求めて開示した非公知の情報及びBuildeeを通じて取得した他の会員に関する情報（個人情報を含む）について、秘密に取扱い、Buildeeの各サービス利用のため以外の目的で利用しないものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 当社は、営業活動に利用する資料(紙媒体、メルマガ等)に、会員の社名を掲載する場合があります。また、当社ホームページに、会員の社名及び会員のWEBサイトへのリンク等を掲載することがあります。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第18条（個人情報）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 当社は、当社の定めるプライバシーポリシーに従い、適切に個人情報を取扱うものとします。" }),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__block", children: [
      "2 Buildeeに登録される個人情報は、以下の情報となります。",
      /* @__PURE__ */ s.jsx("br", {}),
      "(1) 氏名、性別、住所、生年月日、血液型、電話番号、FAX番号、メールアドレス、国籍、顔写真等の個人の属性に関する情報及びこれらの情報を管理するために発番されるID等の記号",
      /* @__PURE__ */ s.jsx("br", {}),
      "(2) 会社名、所属部署・現場名、役職、職種、取得資格、経験年数、各種技能講習の受講履歴、本人の勤務状況、勤務成績、職務に関する賞罰履歴等の職種・職歴に関する情報及びこれらの情報を管理するために発番されるID等の記号",
      /* @__PURE__ */ s.jsx("br", {}),
      "(3) 健康診断受診日、社会保険・年金の加入状況、血圧、じん肺管理区分等の労働安全衛生管理のための情報及びこれらの情報を管理するために発番されるID等の記号",
      /* @__PURE__ */ s.jsx("br", {}),
      "(4) 上記の他、Buildeeの利用に際して、申込者又は会員が当社に提出した情報"
    ] }),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__block", children: [
      "3 Buildeeに登録された個人情報の当社による利用目的は以下のとおりとなります。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（1）Buildeeの各サービスを提供するため。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（2）Buildeeの各サービスに関して通知、連絡、請求等をするため。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（3）BuildeeやBuildeeのアフターサービスや問い合わせ・ご依頼に対応するため。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（4）個人を識別できない形式に加工した統計データを作成するため。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（5）Buildeeの運営、改善、利用履歴に係る統計データの作成、その他サービスに関する企画・立案又は実施、その他これらに関連する業務のため。"
    ] }),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__block", children: [
      "4 Buildeeに登録された個人情報は、元請会員が企画組成し、個人情報が登録される建設現場に関与する会員の間で共同利用されます。また、第9条に定めるCCUSとの連携においても共同利用されます。共同利用に関する詳細事項は、「Buildeeにおける個人情報の共同利用について」に定めます。なお、個人情報の共同利用における利用目的は以下のとおりとなります。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（1）会員におけるアカウントの認証をするため。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（2）Buildeeの各サービスの利用に関する通知、連絡等をするため。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（3）建設現場に関わる各種業務を行うため。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（4）会員及び会員ではない代行先（第20条に定めます。）に作業員のキャリアに関する情報を共有するため。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（5）個人を識別できない形式に加工した統計データを作成するため。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（6）第9条に定めるCCUSとの共同利用をするため。"
    ] }),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__block", children: [
      "5 会員は、自らがBuildeeに登録する作業員の個人情報について、あらかじめ以下の事項について作業員から同意を取得しなければならないものとします。",
      /* @__PURE__ */ s.jsx("br", {}),
      " 本条2項各号に掲げる個人情報が、本条3項及び4項各号に掲げる利用目的で取り扱われること"
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "6 第19条（会員の権利等）第2項又は第20条（代行登録）に従い、自社以外の会員及び会員ではない者にBuildeeを利用させ、又は個人情報を代行登録する場合、当該会員において、前項の同意が適切に取得されるために必要な措置を講じなければならないものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "7 会員は、登録する作業員に対して、当社のプライバシーポリシーに同意させた上で、利用するものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "8 Buildeeにおいて、会員が協力会社を登録・検索する際に、会社情報として登録された個人事業主の個人情報（住所、会社名（氏名）、電話番号等）は他の会員から閲覧される可能性があります。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第19条（会員の権利等）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 会員は、本規約及び当社がBuildeeの利用方法等に関して随時実施する指示に従い、必要なソフトウェアをダウンロードして、当社からBuildeeのサービス提供を受け、これを利用することができます。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 会員は、本規約の他の定めにかかわらず、Buildeeの利用の目的で、協力会員、次条に基づき登録を行った協力会社、その他自己の取引先（委託先及び会員の関係会社を含み、これらを総称して「協力会社等」といいます）に対して、Buildeeを利用させることができます。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第20条（代行登録）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 会員は、当社所定の「覚書」を締結した第三者の会社情報と所属する作業員を、Buildeeに登録する業務（以下「代行登録業務」といいます。）を行うことができます。その場合、会員は、当社所定の「覚書」の写しを当社に提出しなければなりません。当社にて内容を確認し、内容に不備がないと確認された場合、代行登録が可能となります。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 前項に基づき、自らの会社情報と所属する作業員の登録代行を委託する協力会社を「代行先」といい、受託して登録を行う協力会社を「代行元」といいます。" }),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__block", children: [
      "3 代行先は、必ずしもBuildeeに会員登録をする必要はありません。但し、代行元は、代行先より以下の点につき確認し、代行先の行為について一切の責任を負うものとします。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（1）代行先は、本規約第11条から15条を除く全ての条項に同意し、会員と同等の義務を負うこと。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（2）代行先は、当社のプライバシーポリシーに同意すること。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（3）代行先は、自らに所属する作業員の個人情報が、当社、元請会員及び協力会員との間で共同で利用されること、及び第9条に従いCCUSに登録されて共同利用されることに対する同意を該当する作業員より適切に取得していること。"
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "4 代行元は、代行先からの代行登録業務の受託が終了した場合もしくは変更がある場合、遅滞なく当社に報告するものとします。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第21条（会員の義務）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 会員は、本規約及び当社がBuildeeの利用方法等に関して随時実施する指示を遵守するものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 会員は、Buildeeを第1条の目的に合致するよう適切に利用するとともに、その利用に際しては、Buildeeに対する社会の信頼性やその円滑な運営管理を損なうことがないよう十分に注意するものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "3 元請会員は、第19条2項で定める協力会社等にBuildeeを利用させる場合、自らが受託した建設現場と関係のない協力会社等を登録してはならず、元請会員の責任において協力会社等に本規約等を遵守するように周知徹底させるとともに、協力会社等がBuildeeを適切に利用するよう指導監督するものとし、協力会社等がBuildeeを適切に利用しなかったために当社や他の会員に損害が発生した場合には、協力会社等と共にその責任を負担するものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "4 会員は、第12条3項各号に規定する事項、本条に規定する会員の義務内容、次条に規定する禁止行為その他Buildeeの利用に関して、当社から照会を受け、説明、報告及び資料提出等を求められた場合、速やかにそれに応じるものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "5 会員はユーザーIDを第三者に盗難されないよう、パスワードを定期的に変更する等管理する責任を負い、第三者への譲渡や貸与等をしてはなりません。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "6 会員は、会員のユーザーID及びパスワードが不正に第三者に使用された場合、会員が使用したものとみなし、すべての責任を負います。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第22条（反社会的勢力の排除）" }),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__block", children: [
      "1 会員及び当社は、それぞれ自己及び自己の役員又は経営に実質的に関与している者（以下「役員等」といいます。）が下記の各号の一に該当しないこと、及び今後もこれに該当しないことを表明、保証します。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（1）暴力団、暴力団員、暴力団でなくなった時から 5 年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋、社会運動等標ぼうゴロ又は特殊知能暴力集団その他これらに準ずる者（以下「暴力団員等」といいます。）であること。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（2）暴力団員等が経営を支配していると認められる関係を有すること。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（3）暴力団員等が経営に実質的に関与していると認められる関係を有すること。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（4）自己もしくは第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってするなど、不当に暴力団員等を利用していると認められる関係を有すること。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（5）暴力団員等に対して資金等を提供し、又は便宜を供与するなどの関与をしていると認められる関係を有すること。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（6）役員等が暴力団員等と社会的に非難されるべき関係を有すること。"
    ] }),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__block", children: [
      "2 会員及び当社は、自ら又は第三者を利用して次の各号のいずれかに一つでも該当する行為を行ってはならないものとします。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（1）脅迫的な言動をすること、暴力を用いること、又は名誉・信用を毀損する行為を行うこと。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（2）偽計又は威力を用いて業務を妨害すること。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（3）公序良俗に反する行為、違法行為又は法的な責任を超えた不当な要求行為をすること。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（4）暴力団員等である第三者をして前三号の行為を行わせること。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（5）自ら、その役員又は実質的に経営を支配する者が暴力団員等へ資金等を提供し又は便宜を供与する等の関与をしていると認められる関係を有すること。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（6）その他前各号に準ずる行為。"
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "3 当社は、会員が前2項のいずれか一つにでも違反した場合またはその合理的な疑いが生じた場合は、別段の催告を要せず、会員登録を削除できるとともに、本規約に基づき成立した当社及び会員間のすべての契約並びにその他一切の当社及び会員間の契約を解除することができるものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "4 会員は、前項により登録を削除されたことを理由として、当社に対し、損害賠償を請求することができないものとします。また、前項により登録を削除された場合、会員は、当該解除によって当社に生じた損害の一切を賠償する義務を負うものとします。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__big-heading", children: "第4章 紛争の処理" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第23条（禁止行為）" }),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__block", children: [
      "1 会員はBuildeeの利用にあたり次の各号に定める行為を行ってはなりません。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（1）事実に反する情報を登録する行為。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（2）ユーザーIDやパスワードを不正に使用し、または使用させる行為。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（3）自己または他の会員のユーザーIDやパスワード、Buildeeのシステム上に登録された情報を第三者に開示する行為。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（4）Buildeeを利用する権利を他に貸与、転貸、譲渡する行為。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（5）当社や他の会員の信用を毀損し、またはその営業及び運営を妨害する行為。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（6）第三者になりすます行為。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（7）法令に違反するもしくは違反するおそれがある行為または犯罪に関連する行為。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（8）公序良俗違反またはそのおそれのある行為。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（9）当社の事前の承諾なく、Buildee上で宣伝、広告、勧誘等をする行為。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（10）当社、他の会員またはその他第三者の知的財産を始めとする各種権利を侵害またはそのおそれがある行為。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（11）Buildeeに無断でアクセスし、またはしようとする行為。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（12）その他、当社が不適当と認める行為。"
    ] }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第24条（利用停止・利用禁止）" }),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__block", children: [
      "1 当社は、会員が次の各号のいずれかに該当する場合において、当社が必要と判断するときは、予告期間なく直ちに当該会員及びそれ以外の会員によるサービスの利用を停止または禁止することができます。この場合、すでに当社に支払われた初期費用、利用料等は、理由の如何を問わず返金はされません。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（1）入会後、当該会員について第12条3項各号のいずれかに該当する事情が存することが判明したとき。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（2）本規約、及びこれに付随する諸規則、各種利用申込書、覚書、その他当社の指示等に違反する行為があったとき。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（3）利用料の支払いその他当社に対して負担する債務の履行の全部または一部を怠ったとき。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（4）当社に対する債務の履行遅滞を繰り返したとき。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（5）支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始若しくはこれらに類する手続の開始、差押、仮差押、仮処分、強制執行又は競売の申立てがあったとき。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（6）自ら振出し、若しくは引受けた手形若しくは小切手につき、不渡りの処分を受けたとき、又は手形交換所の取引停止処分その他これに類する措置を受けたとき。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（7）当社からの連絡に対して応答がないとき。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（8）その他当社がBuildeeの利用継続を不適当と認める相当の事情が存するとき。"
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 当社は、会員を利用停止または利用禁止とすることを決定したときは、第6条1項によりその旨を他の会員に通知するとともに、Buildeeのシステム上で当該会員の名称を公開することができるものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "3 会員がサービスの利用停止または利用禁止となった場合、会員は、利用停止または利用禁止を理由として、当社に対し、損害賠償を請求することができないものとします。また、会員は、当該利用停止または利用禁止によって当社に生じた損害の一切を賠償する義務を負うものとします。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第25条（免責事項等）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 Buildeeの利用にあたり会員が自らシステム上に登録する各種情報の真実性、正確性、有用性、妥当性に関しては、会員においてその一切の責任を負担するものとし、当社は一切その責任を負担しません。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 当社は、Buildeeのサービスを利用することによって、個人情報保護法、建設業法、労働基準法、労働安全衛生法等の各種関連法規が遵守されることにつき保証するものではありませんので、それらの各種関連法規の遵守については会員の責任にて行っていただき、当社は一切の責任を負いません。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "3 Buildeeの利用にあたり会員相互間もしくは会員とその他の第三者もしくは作業員との間で何らかの紛争を生じた場合、当該紛争は会員の責任において解決するものとし、当社は一切その責任を負担しません。" }),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__block", children: [
      "4 当社は、会員が本規約に基づきBuildeeのサービスを利用することができるようシステムの運営管理に努めるものとしますが、次の各号のいずれかに該当する事由により会員がBuildeeを利用することができなくなった場合には、当社は一切その責任を負担しません。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（1）第4条に基づきサービスの提供を一時中止するとき。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（2）天災地変、法令・規則の制定・改廃、疫病・感染症の流行その他の不可抗力により、Buildeeの履行が妨げられたとき。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（3）当社に帰責事由が存しない原因によりBuildeeのシステム上に登録された各種情報データ等が消失または毀損したとき。",
      /* @__PURE__ */ s.jsx("br", {}),
      "（4）次項に基づき当社がBuildeeを廃止し、または事業譲渡等を行うとき。"
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "5 当社は、経営上必要性があると判断した時は、あらかじめ3か月前までに会員に通知した上で、Buildeeを廃止し、またはBuildeeを含む当社事業の全部もしくは一部の事業譲渡等を行うことができるものとします。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第26条（損害賠償）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 当社が故意または重過失により本規約に違反し、その結果、会員に損害が発生した場合、当社はその損害を賠償します。ただし、その損害賠償責任は、具体的な本規約の違反行為により直接かつ通常発生する損害の範囲内に限定され、かつ、その賠償額は会員が直近1か月間に当社に支払った利用料を上限とするものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 会員は、本規約に違反することにより、又はBuildeeの利用に関連して当社に損害を与えた場合、当社に対しその損害を賠償しなければなりません。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "3 会員が、Buildeeに関連して他の会員その他の第三者からクレームを受け又はそれらの者との間で紛争を生じた場合には、直ちにその内容を当社に通知するとともに、会員の費用と責任において当該クレーム又は紛争を処理し、当社からの要請に基づき、その経過及び結果を当社に報告するものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "4 会員によるBuildeeの利用に関連して、当社が、他の会員その他の第三者から権利侵害その他の理由により何らかの請求を受けた場合は、会員は当該請求に基づき当社が当該第三者に支払を余儀なくされた金額を賠償しなければなりません。但し、当社の故意又は過失に起因する場合はこの限りではありません。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第27条（権利義務の譲渡）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 会員は、本規約上の地位または権利義務を当社の事前の書面による承諾なく第三者に譲渡、承継させることはできません。ただし、合併または会社分割によって、本規約上の地位または権利義務が包括承継される場合はこの限りではありません。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 会員は、前項に基づき、本規約上の地位または権利義務を第三者に譲渡または承継した場合は、速やかに当社に対して当該譲渡または承継の事実が分かる資料を提出するものとします。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "3 当社は、Buildeeのサービスに係る事業を第三者に譲渡した場合には、本規約上の地位または権利義務を当該第三者に譲渡することができるものとし、会員は、当該譲渡について、あらかじめ同意したものとします。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第28条（外部サービスとの連携）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 会員は、BuildeeのユーザーIDと第三者が提供するサービス（以下、「外部サービス」といいます。）のアカウントを連携して利用することができます。その場合、会員は、外部サービスの利用規約を自己の費用と責任で遵守するものとし、会員と外部サービスを提供する事業者との間で紛争等が生じた場合でも、当社は当該紛争等について一切の責任を負いません。" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "2 外部サービスとの連携に関する詳細事項は、外部サービスとの連携に関する規約に定めます。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第29条（分離可能性）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 本規約のいずれかの条項またはその一部が、法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効または執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第30条（誠実義務）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 Buildeeの利用または本規約の解釈適用を巡る当社と会員間の紛争、会員相互間の紛争については、相互に信義誠実の原則に則り話し合いによる円満な解決に努めるものとします。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "第31条（準拠法及び紛争の解決方法）" }),
    /* @__PURE__ */ s.jsx("p", { className: "contents__block", children: "1 Buildeeの利用または本規約の準拠法は日本法とし、その解釈適用を巡るあらゆる紛争は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。" }),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsx("p", { className: "contents__big-heading", children: "付 則（本規約の発効）" }),
    "本規約は下記のとおり、発効し、改定されました。",
    /* @__PURE__ */ s.jsx("br", {}),
    /* @__PURE__ */ s.jsxs("p", { className: "contents__footer", children: [
      "●発 効：2017年10月1日",
      /* @__PURE__ */ s.jsx("br", {}),
      "●第１回改定：2019年12月9日",
      /* @__PURE__ */ s.jsx("br", {}),
      "●第２回改定：2020年10月25日",
      /* @__PURE__ */ s.jsx("br", {}),
      "●第３回改定：2021年8月29日",
      /* @__PURE__ */ s.jsx("br", {}),
      "●第４回改定：2022年4月1日",
      /* @__PURE__ */ s.jsx("br", {}),
      "●第５回改定：2024年3月24日",
      /* @__PURE__ */ s.jsx("br", {}),
      "●第６回改定：2025年2月1日"
    ] })
  ] }) }) }) }) }) });
}
function lv({
  accept: e,
  deny: r
}) {
  return /* @__PURE__ */ s.jsx(En, { children: /* @__PURE__ */ s.jsxs(H1, { className: "dialog dialog--modal dialog--dialog-new-foremen terms-service", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "terms-service__header", children: [
      /* @__PURE__ */ s.jsx("span", { className: "terms-service__title", children: "Buildee利用規約" }),
      /* @__PURE__ */ s.jsx("div", { className: "terms-service__note", children: "※利用規約の改定により過去に同意済みの方にも再表示する場合があります。" })
    ] }),
    /* @__PURE__ */ s.jsx(Dc, {}),
    /* @__PURE__ */ s.jsxs("div", { className: "terms-service__footer", children: [
      /* @__PURE__ */ s.jsx("button", { className: "btn-fixedsize--sub", onClick: r, children: "拒否" }),
      /* @__PURE__ */ s.jsx("span", { children: " " }),
      /* @__PURE__ */ s.jsx("button", { className: "btn-fixedsize--effective", onClick: e, children: "同意" })
    ] })
  ] }) });
}
function dv({
  accept: e,
  deny: r
}) {
  return /* @__PURE__ */ s.jsxs(En, { children: [
    /* @__PURE__ */ s.jsxs(
      z1,
      {
        id: "terms_body",
        className: "terms-service nested-hidden-overflow-x",
        children: [
          /* @__PURE__ */ s.jsx("strong", { children: "Buildee利用規約" }),
          /* @__PURE__ */ s.jsx("br", {}),
          /* @__PURE__ */ s.jsx("span", { className: "text-red-primary", children: "※利用規約の改定により過去に同意済みの方にも再表示する場合があります。" }),
          /* @__PURE__ */ s.jsx("br", {}),
          /* @__PURE__ */ s.jsx("br", {}),
          /* @__PURE__ */ s.jsx(Dc, {})
        ]
      }
    ),
    /* @__PURE__ */ s.jsx("footer", { children: /* @__PURE__ */ s.jsxs("div", { className: "footer_content nested-hidden-overflow-x", children: [
      /* @__PURE__ */ s.jsx(
        Qi,
        {
          className: "footer_content-button",
          color: "negative",
          onClick: r,
          children: "拒否"
        }
      ),
      /* @__PURE__ */ s.jsx(
        Qi,
        {
          className: "footer_content-button",
          color: "commit",
          onClick: e,
          children: "同意"
        }
      )
    ] }) })
  ] });
}
const Hs = /\[\[(.+?):(.+?)\]\]/g, q1 = (e, r) => {
  const t = [];
  let n = 0, o;
  for (Hs.lastIndex = 0; (o = Hs.exec(e)) !== null; ) {
    const [i, a, c] = o, u = o.index;
    n < u && t.push(e.slice(n, u)), t.push(
      /* @__PURE__ */ s.jsx(
        "a",
        {
          href: c,
          rel: "noreferrer noopener",
          target: "_blank",
          className: r,
          children: a
        },
        u
      )
    ), n = u + i.length;
  }
  return n < e.length && t.push(e.slice(n)), t;
};
function fv({
  content: e,
  urlClassName: r
}) {
  const t = He(
    () => q1(e, r),
    [e, r]
  );
  return /* @__PURE__ */ s.jsx($r, { children: t });
}
export {
  w1 as AsyncMultiSelect,
  Vx as AsyncSelect,
  b1 as AsyncSuggestiveMultiSelect,
  a1 as AsyncSuggestiveSelect,
  uv as Button,
  av as DatePicker,
  jc as MultiSelect,
  fv as NoticeContentWithUrl,
  Yf as SPAsyncMultiSelectWithFilter,
  Rf as SPAsyncSelect,
  Af as SPAsyncSuggestiveSelect,
  Qi as SPButton,
  nv as SPCheckboxs,
  Vn as SPChip,
  Po as SPDatePicker,
  kx as SPDateRangePicker,
  iv as SPDialog,
  Ct as SPLabel,
  Oa as SPMultiSelectWithFilter,
  rv as SPRadios,
  Ea as SPSelect,
  Ma as SPSuggestiveSelect,
  dv as SPTermsOfServiceMiddle,
  ov as SPTextInput,
  sv as SPUploadFileSelect,
  Pc as Select,
  Cc as SuggestiveMultiSelect,
  kc as SuggestiveSelect,
  lv as TermsOfServiceMiddle,
  cv as TextField
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@bld/bld-libs/components.js
// module id = 156
// module chunks = 0